/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  Dialog as DialogComponent,
  // DialogActionsBar,
  // DialogCloseEvent,
} from "@progress/kendo-react-dialogs";
// import '@progress/kendo-theme-default/dist/all.css';
import { Splitter, SplitterOnChangeEvent } from "@progress/kendo-react-layout";
import { useInternationalization } from "@progress/kendo-react-intl";
import { process, SortDescriptor, State } from "@progress/kendo-data-query";
import { clone, getter } from "@progress/kendo-react-common";
import {
  GridRowDoubleClickEvent,
  GridRowClickEvent,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { withTranslation } from "react-multi-lang";
import {
  sheetDefaultContent,
  isMultitenant,
  convertshorthandtooriginal,
  getsequenceoncode,
  getordertype,
  orderdefaultcheck
} from "./../../custom_functions/Constance.jsx";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
// import PageLoader from "./../../custom_modules/general/PageLoader.jsx";
import {
  DataModel,
  PanesModel,
  SplitBtnItems,
  SelectedItemType,
  UploadAddEvent,
  ViewChangeEvent,
  SortChangeEvent,
  AppSwitchChangeEvent,
  ContextMenuEvent,
} from "../../interfaces/FileManagerModels";

import {
  formatData,
  formatserverData,
  groupBy,
  // groupByobject,
  getFolderTree,
  searchTreeItem,
  searchTreeItemonpath,
  addDataItem,
  addFolderonObj,
  addprojectinsidetask,
  getFolderToSave,
  convertExtensionToIcon,
  convertDateFormat,
  convertToBreadcrumbData,
  removeDataItem,
  editDataItem,
  getFolderPath,
  removeItem,
  getDirectoryOncode,
  getDirectoryOncodeandfilefor,
  getDirectoryOnName,
  addfileitemstoFolderwithfilefor,
  addfileitemsforhomebutton,
  addorderitemsforhomebutton,
  addorderitemstoFolderwithfilefor,
  replaceallordertoFolderwithfilefor,
  deleteorderitemstoFolderwithfilefor,
  deletefileitemstoFolderwithfilefor,
  deletefileitemsforhomebutton,
  replaceonechangeorderordertoFolderwithfilefor,
  getAllFolderFromItem,
  getAllFolderFromMultiItem,
  setdates,
  expandparentfolder,
  Movemultifolders,
  // getsheetitemnameonscreen,
  Onsetfolderexpande,
  validateTreeItem,
  replaceItem,
} from "../../helpers/helperMethods";

import {
  extractValuefromsheet,
  Silentauditobject,
  AuditTrailValidation,
  GetutcDate,
  Servicecalls,
  Getuserprojectfromsession,
  Getuserworkflowfromsession,
  generateLink,
  setDateAsuserDefined,
  Manualauditobject,
  dateDiffInDays,
  convertUTCDateToLocalDate,
  ControlRights,
  Getteamusersfromsession,
  valiadateTenantPackage,
  orderType,
  GetutcDateaudi,
  updateOrderStatusCheck,
  Onsaveactivewidgetsdata,
  AuditTrailValidationOnScreen,
  renderSwitch,
  formsequenceformatview,
  Getteamfromsession,
  Serviceuserworkflowdetails,
  gridDtatExport,
  gridDtatExportToolBar
} from "./../../custom_functions/Functions.jsx";

import { updateorderopen, updatesheetorderdata } from "./../../redux_store/actions/index";
import { OrderSequence } from "./../../custom_functions/Constance.jsx";
import { useLayoutEffect } from "react";
import store from "./../../redux_store/store/index";

import Service from "./../../custom_modules/general/Service.jsx";

import { Modal, ModalBody } from "reactstrap";
import Audit from "../../custom_modules/Audit";
//import Audit from "../Audit";
// const Audittrail = React.lazy(
//   () => import("../../custom_modules/Audit")
// );
import "bootstrap";
import $ from "jquery";

import { UploadFileInfo } from "@progress/kendo-react-upload";
import { TreeViewItemClickEvent } from "@progress/kendo-react-treeview";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { Offset } from "@progress/kendo-react-popup";
import { withAlert } from "react-alert";
// import { FileManagerToolbar } from "../../controls/FileManagerToolbar";
import { NameCell, DateCreatedCell } from "../../controls/GridView";
import { MyFolderContext } from "../main_pages/orders/PRegistertask.jsx";
import { SplitButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { ExcelExport } from "@progress/kendo-react-excel-export";


const Upgrade = React.lazy(() => import("../general/Upgrade.jsx"));

// import { ListView } from "../../controls/ListView";
// import { FileInformation } from "../../controls/FileInformation";
// import { FolderTree } from "../../controls/FolderTree";
// import { DateFilter } from "../../controls/DateFilter";
// import { BreadcrumbComponent } from "../../controls/Breadcrumb";
// import {
//   DeleteDialog,
//   EditDialog,
//   MoveDialog,
//   AddDialog,
//   CommonDialog,
// } from "../../controls/Dialog";
// import { ContextMenu } from "../../controls/ContextMenu";
// import { Unsharelistview } from "./../../custom_functions/ManipulationFunction.jsx";
// import { PendingViewCell1 } from "./../../controls/columnMenu.jsx";
const PendingViewCell = React.lazy(
  () => import("./../../controls/PendingViewCell.jsx")
);
const Unsharelistview = React.lazy(() =>
  import("./../../custom_functions/ManipulationFunction.jsx").then(
    ({ Unsharelistview }) => ({ default: Unsharelistview })
  )
);
const FileManagerToolbar = React.lazy(() =>
  import("../../controls/FileManagerToolbar").then(
    ({ FileManagerToolbar }) => ({ default: FileManagerToolbar })
  )
);

const GridView = React.lazy(() =>
  import("../../controls/GridView").then(({ GridView }) => ({
    default: GridView,
  }))
);
const ListView = React.lazy(() =>
  import("../../controls/ListView").then(({ ListView }) => ({
    default: ListView,
  }))
);

const FileInformation = React.lazy(() =>
  import("../../controls/FileInformation").then(({ FileInformation }) => ({
    default: FileInformation,
  }))
);

const FolderTree = React.lazy(() =>
  import("../../controls/FolderTree").then(({ FolderTree }) => ({
    default: FolderTree,
  }))
);

const DateFilter = React.lazy(() =>
  import("../../controls/DateFilter").then(({ DateFilter }) => ({
    default: DateFilter,
  }))
);
const BreadcrumbComponent = React.lazy(() =>
  import("../../controls/Breadcrumb").then(({ BreadcrumbComponent }) => ({
    default: BreadcrumbComponent,
  }))
);

const DeleteDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ DeleteDialog }) => ({
    default: DeleteDialog,
  }))
);

// const ProjectTeam = React.lazy(() =>
//   import("../../controls/ProjectTeamComponent").then(({ ProjectTeam }) => ({
//     default: ProjectTeam,
//   }))
// );


const EditDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ EditDialog }) => ({
    default: EditDialog,
  }))
);

const MoveDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ MoveDialog }) => ({
    default: MoveDialog,
  }))
);

const AddDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ AddDialog }) => ({
    default: AddDialog,
  }))
);

const CommonDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ CommonDialog }) => ({
    default: CommonDialog,
  }))
);
const ContextMenu = React.lazy(() =>
  import("../../controls/ContextMenu").then(({ ContextMenu }) => ({
    default: ContextMenu,
  }))
);
const isPremiumTenant = valiadateTenantPackage() === "3" ? true : false;
export const MyGlobalContext = React.createContext<any>(null);
export const OrdershowContext = React.createContext<any>(null);
// export const AuditUrl = React.createContext<any>(null);

const KendoTreeList = React.lazy(() => import("../../controls/KendoTreeList"));

const Sheetorderview = React.lazy(() => import("./Sheetorderview"));

const splitterPanes: PanesModel[] = [
  {
    size: "20%",
    min: "20px",
    collapsible: true,
  },
  {},
  {
    size: "20%",
    min: "20px",
    collapsible: true,
  },
];

const initialSort: SortDescriptor[] = [
  {
    field: "path",
    dir: "desc",
  },
];

const DATA_ITEM_KEY = "path";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
let Folderadd_Event: any = undefined;
let Isview_Constence: boolean = false;
let SelectedCDPTreeItem: any;
let SelectedCDFvalue: any;
let passobjectdates = {};
let folderCreate = false;
let deletefolderevents = false;
const Sheetorder = (props: any) => {
  const selectedTreeItemRef = React.useRef<any>(null);
  let excelExportRef = React.useRef<any>(null);
  const currentDate = sessionStorage.getItem("currentDate");
  const Foldercontext = useContext(MyFolderContext);
  const history = useHistory();
  const [sheetdatainit, setsheetdatainit] = React.useState<any>(undefined);
  const [sheetdatainitservice, setsheetdatainitservice] = React.useState(false);
  const [idle_save, setidlesave] = React.useState(false);
  const [isOrderMismatched, setisOrderMismatched] = useState(false);
  folderCreate = props?.folderCreate;
  const intl = useInternationalization();
  const updateuserrights = (screenrights: any) => {
    let pend = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_PENDINGWORK");
    let complete = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_COMPLETEDWORK");
    // let myOrder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_MYORDERS");
    // let assignedOrder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ASSIGNED");
    let orderByMe = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ORDERSHAREDBYME");
    let orderToMe = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ORDERSHAREDTOME");
    let limsorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_LIMSTASKORDER");
    let elnorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNTASKORDER");
    let researchorder = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_RESEARCHACTIVITY"
    );
    let excelorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_MANAGEEXCEL");
    let Evaluation = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_SHEETEVALUATION");
    let Foldercreate = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_FOLDERCREATION"
    );
    let sheetorderrights = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_SCN_SHEETORDERS"
    );
    let moveorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_MOVEORDERS");
    let sheetorderexport = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_SHEETORDEREXPORT"
    );
    let fileupload = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_UPLOADSHEETORDER"
    );

    let UserRights = {
      orderByMeVisible: orderByMe.UserGroupRights.rights,
      orderToMeVisible: orderToMe.UserGroupRights.rights,
      LIMSorderVisible: limsorder.UserGroupRights.rights,
      LIMSordersyncvisb: limsorder.UserGroupRights.save,
      ELNorderVisible: elnorder.UserGroupRights.rights,
      ExcelorderVisible: excelorder.UserGroupRights.rights,
      DocumentorderVisible: Evaluation.UserGroupRights.rights,
      Researchorder: researchorder.UserGroupRights.rights,
      Evalsavevisb: Evaluation.UserGroupRights.save,
      Excelsavevisb: excelorder.UserGroupRights.save,
      Researchvisible: researchorder.UserGroupRights.save,
      Folderrights: Foldercreate.UserGroupRights.rights,
      Folderrightscreate: Foldercreate.UserGroupRights.save,
      Folderrightseditvisb: Foldercreate.UserGroupRights.edit,
      Folderrightdeletevisb: Foldercreate.UserGroupRights.del,
      ELNorder: elnorder.UserGroupRights.save,
      sheetordervisible: sheetorderrights.UserGroupRights.rights,
      moveorderrights: moveorder.UserGroupRights.rights,
      sheetexportvisible: sheetorderexport.UserGroupRights.rights,
      pendingrights: pend.UserGroupRights.rights,
      completedrights: complete.UserGroupRights.rights,
      uploadrights: fileupload.UserGroupRights.rights,
    };
    return UserRights;
  };

  const [userrights] = React.useState<any>(updateuserrights(props.rights));
  const [isupgradeopen, setisupgradeopen] = React.useState(false);
  const [stateData, setStateData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateCDFData, setStateCDFData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [radioCDFbtnenable, setradioCDFbtnenable] = React.useState<number>(4);
  const [panes, setPanes] = React.useState<PanesModel[]>(splitterPanes);

  const [pullcontents, setPullcontents] = React.useState<boolean>(false);
  const [IsLoader, setIsLoader] = React.useState<boolean>(false);
  const [selectedGridItem, setSelectedGridItem] = React.useState<DataModel>({});

  const [auditRights] = React.useState(
    AuditTrailValidationOnScreen("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS")
  );
  const pendinglimsorderfolder = {
    directorycode: -7,
    parentdircode: -5,
    dateCreated: convertDateFormat(
      new Date(
        currentDate !== undefined && currentDate !== null
          ? currentDate
          : new Date()
      ),
      intl
    ),
    dateModified: convertDateFormat(new Date(), intl),
    size: 124,
    path: `${"Sheet"}/${"Pending Orders"}/${"Lims Order"}`,
    directoryname: props.t("Orders.Sheetorders.IDS_LBL_LIMSORDER"),
    icon: convertExtensionToIcon("Lims Order", null),
    filefor: "LPO",
    items: [],
  };
  const pendingelnorderfolder = {
    directorycode: -8,
    parentdircode: -5,
    dateCreated: convertDateFormat(
      new Date(
        currentDate !== undefined && currentDate !== null
          ? currentDate
          : new Date()
      ),
      intl
    ),
    dateModified: convertDateFormat(new Date(), intl),
    size: 124,
    path: `${"Sheet"}/${"Pending Orders"}/${"ELN Order"}`,
    directoryname:
      isMultitenant === 2
        ? props.t("Dashboard.IDS_LBL_ELNTASKS")
        : props.t("Orders.Sheetorders.IDS_LBL_ELNTASKORDER"),
    icon: convertExtensionToIcon("ELN Order", null),
    filefor: "EPO",
    items: [],
  };
  const completedlimsorderfolder = {
    directorycode: -12,
    parentdircode: -6,
    dateCreated: convertDateFormat(
      new Date(
        currentDate !== undefined && currentDate !== null
          ? currentDate
          : new Date()
      ),
      intl
    ),
    dateModified: convertDateFormat(new Date(), intl),
    size: 124,
    path: `${"Sheet"}/${"Completed Orders"}/${"Lims Order"}`,
    directoryname: props.t("Orders.Sheetorders.IDS_LBL_LIMSORDER"),
    icon: convertExtensionToIcon("Lims Order", null),
    filefor: "LCO",
    items: [],
  };
  const completedelnorderfolder = {
    directorycode: -13,
    parentdircode: -6,
    dateCreated: convertDateFormat(
      new Date(
        currentDate !== undefined && currentDate !== null
          ? currentDate
          : new Date()
      ),
      intl
    ),
    dateModified: convertDateFormat(new Date(), intl),
    size: 124,
    path: `${"Sheet"}/${"Completed Orders"}/${"ELN Order"}`,
    directoryname:
      isMultitenant === 2
        ? props.t("Dashboard.IDS_LBL_ELNTASKS")
        : props.t("Orders.Sheetorders.IDS_LBL_ELNTASKORDER"),
    icon: convertExtensionToIcon("ELN Order", null),
    filefor: "ECO",
    items: [],
  };

  const [isSelectAllFile, setIsSelectAllFile] = React.useState<boolean>(false);
  const [isSelectAllOrder, setIsSelectAllOrder] =  React.useState<any>(undefined);

  const [selectedTreeItem, setSelectedTreeItem] =React.useState<DataModel | null>(isMultitenant === 0 ? pendinglimsorderfolder : pendingelnorderfolder);
  const [selectedCDPTreeItem, setSelectedCDPTreeItem] =React.useState<DataModel | null>();
  const [selectedTreeItemDuplicate, setSelectedTreeItemDuplicate] = React.useState<DataModel | null>(isMultitenant === 0 ? pendinglimsorderfolder : pendingelnorderfolder);

  const [gridSelection, setGridSelection] = React.useState<{
    [id: string]: boolean | number[];
  }>({});

  const [detailsData, setDetailsData] = React.useState<null | number | Object>(
    null
  );
  // const [selectedteam, setSelectedTeam] = useState<string | null>();

  const [files, setFiles] = React.useState<UploadFileInfo[]>([]);
  const [contentView, setContentView] = React.useState<string | null>(
    localStorage.getItem("elnsheetorderview") !== undefined &&
      localStorage.getItem("elnsheetorderview") !== null
      ? localStorage.getItem("elnsheetorderview")
      : "list"
  );
  const [contextMenuView, setContextMenuView] = React.useState<boolean>(false);
  const [menuOffSet, setMenuOffSet] = React.useState<Offset>({
    left: 0,
    top: 0,
  });
  const [editDialogView, setEditDialogView] = React.useState<boolean>(false);
  const [deleteDialogView, setDeleteDialogView] =
    React.useState<boolean>(false);
  const [moveDialogView, setMoveDialogView] = React.useState<boolean>(false);
  const [isMenuContext, setIsMenuContext] = React.useState<boolean>(false);
  const [adddialogVisible, setAddDialogVisible] =
    React.useState<boolean>(false);

  const [selectedOrders, setSelectedOrders] = React.useState<any[]>([]);
  const [addedfiles, setAddedfiles] = React.useState<any[]>([]);
  const [isMultiSelectOrder, setIsMultiSelectOrder] =
    React.useState<boolean>(false);

  const [selectedFiles, setSelectedFiles] = React.useState<any[]>([]);
  const [isMultiSelectFile, setIsMultiSelectFile] =
    React.useState<boolean>(false);

  const [selectedFolders, setSelectedFolders] = React.useState<any[]>([]);
  const [isMultiSelectFolders, setIsMultiSelectFolders] =
    React.useState<boolean>(false);

  const [stateUserData] = React.useState<DataModel>();
  const [fileviewfor] = React.useState<number>(1);
  let itemperpage = 10;
  if (
    localStorage.getItem("Elnitemperpage") !== undefined &&
    localStorage.getItem("Elnitemperpage") !== null
  ) {
    let sheetcolumnsval: any = localStorage.getItem("Elnitemperpage");
    itemperpage = JSON.parse(sheetcolumnsval);
  }
  const [takeskip, setTakeskip] = React.useState<any>({
    skip: 0,
    take: itemperpage,
    group: [],
    collapsedIds: [],
  });

  const sheetdaydiff = localStorage.getItem("sheetdaydiff");
  const [sheetUnmapped, setSheetUnmapped] = React.useState<boolean>(false);
  const [isorderopen, setIsorderopen] = React.useState<any>(
    store.getState().sheetopne !== null && props.notificationorder === ""
      ? store.getState().sheetopne
      : false
  );
  // const [openedorder, setOpenedorder] = React.useState<any>(store.getState().Sheetview.OrderTestcode !== null && store.getState().Sheetview.OrderTestcode !== "" ? store.getState().Sheetview.OrderTestcode : undefined);
  const [openedorder, setOpenedorder] = React.useState<any>(undefined);

  let daydiff = 7;
  if (typeof sheetdaydiff === "string" && sheetdaydiff !== "NaN") {
    daydiff = parseInt(JSON.parse(sheetdaydiff));
  }

  let SelectAllFile: any = false;
  let AllSelectedFiles: any = [];
  let SelectAllOrder: any = false;
  let AllSelectedOrder: any = [];
  const [changedtodate, setchangedtodate] = React.useState<boolean>(false);
  const sheetfiltertype = localStorage.getItem("sheetfiltertype");
  const [SearchContentText, setSearchContentText] = useState<any>("");
  const [cancellorder, setCancellorder] = React.useState<boolean>(false);
  const [cancellorderitem, setCancellorderitem] = React.useState<any>("");
  const [dublicateorder, setDuplicateorder] = useState<boolean>(false);
  const [dublicateorderitem, setDublicateorderitem] = useState<any>("");
  const [searchCriteriaType, setsearchCriteriaType] = useState<any>(0);
  const [orderstatusType, setorderstatusType] = React.useState(0);
  const [orderflag, setorderflag] = React.useState(-1);
  const [flitertest, setFlitertest] = useState<any>({
    testcode: -1,
    testname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }),
  });
  const [fliterproject, setFliterproject] = useState<any>({
    projectcode: -1,
    projectname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }),
  });
  let filtertype = 2;
  if (typeof sheetfiltertype === "string") {
    filtertype = parseInt(JSON.parse(sheetfiltertype));
  }
  const userDefinedDate =
    sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "UTC Format"
      ? "YY/MM/DD HH:mm:ss"
      : sessionStorage.userDefinedDate;
  const [filterType, setfilterType] = React.useState(filtertype);
  let diffdate;
  diffdate = new Date().setDate(new Date().getDate() - daydiff);

  const [fromRange, setfromRange] = React.useState(
    filtertype === 1
      ? setDateAsuserDefined(
        new Date(
          new Date().setDate(new Date().setHours(0, 0, 0, 0)),
          sessionStorage.userDefinedDate
        )
      )
      : setDateAsuserDefined(
        diffdate,
        // sessionStorage.userDefinedDate
        userDefinedDate
      )
  );
  const [toRange, settoRange] = React.useState(
    setDateAsuserDefined(new Date(), userDefinedDate)
  );

  const [isunshareopen, setIsunshareopen] = React.useState<boolean>(false);
  const [selectedUnsharedItem, setSelectedUnsharedItem] =
    React.useState<DataModel>({});
  let initialorders: any = null;

  const [servicecall, setServicecall] = React.useState<any>({
    ServiceToUrl: "",
    ServiceHeaderobject: {},
    ServiceMethodType: "POST",
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    ServiceTenant: undefined,
    Servicecontenttype: undefined,
  });
  const [Auditservicecall, setAuditservicecall] = React.useState<any>({
    AuditUrl: "",
    AuditObject: {},
    AuditPassfunction: undefined,
    AuditFailfunction: undefined,
    AuditCancelfunction: undefined,
    Auditfilefunction: false,
  });

  const [isFiltered] = React.useState<boolean>(false);

  const [fileType, setFileType] = React.useState(-1);
  const [iscancelled, setIscancelled] = React.useState<boolean>(false);

  const [sheetData, setSheetData] = React.useState<DataModel[]>(
    formatData([], intl)
  );

  const [sheetSelected, setSheetSelected] = React.useState<any>(
    formatData([], intl)
  );

  const projects = Getuserprojectfromsession();
  const workflow = Getuserworkflowfromsession();

  let sheetcolumns: any = undefined;
  if (
    localStorage.getItem("elnsheetcolumns") !== undefined &&
    localStorage.getItem("elnsheetcolumns") !== null
  ) {
    let sheetcolumnsval: any = localStorage.getItem("elnsheetcolumns");
    sheetcolumns = JSON.parse(sheetcolumnsval);
  }

  let orderdataforfolder: any = [];
  let sateorderdummy: any = [];

  SelectedCDFvalue = selectedTreeItem === null || SelectedCDPTreeItem ? 5 : 4;
  const onradioCDFbtnclick = (event: any) => {
    if (parseInt(event.target.value) === 4) {
      setradioCDFbtnenable(4);
      // setSelectedCDPTreeItem(undefined)
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      return 4;
    } else if (parseInt(event.target.value) === 5) {
      setradioCDFbtnenable(5);
      SelectedCDFvalue = 5;
      return 5;
    }
  };
  const ChoosePath = (data: any) => {
    let newArray = data.slice();
    // Elements to add
    let elementsToAdd = {
      directorycode: null,
      parentdircode: -1,
      dateCreated: convertDateFormat(
        new Date(
          currentDate !== undefined && currentDate !== null
            ? currentDate
            : new Date()
        ),
        intl
      ),
      // dateModified: convertDateFormat(new Date(), intl),
      size: 124,
      path: props.t("Templates.Sheettemplates.IDS_LBL_HOME"),
      directoryname: props.t("Templates.Sheettemplates.IDS_LBL_HOME"),
      icon: convertExtensionToIcon(props.t("Templates.Sheettemplates.IDS_LBL_HOME"), null),
      filefor: "HF",
      items: [], //projectitems,
    };
    newArray.unshift(elementsToAdd);
    setStateCDFData(
      newArray?.filter(
        (item: any) =>
          item.filefor === "PR" ||
          item.filefor === "DR" ||
          item.filefor === "SMM" ||
          item.filefor === "HF"
      )
    );
  };
  const openunsharelist = (item: any) => {
    setIsunshareopen(true);
    setSelectedUnsharedItem(item);
  };

  const closeunsharelist = (item: any) => {
    setIsunshareopen(false);
    setSelectedUnsharedItem({});
  };

  const onorderunshare = (item: any) => {
    let selectunshare: any = selectedUnsharedItem;
    if (selectunshare !== undefined && Object.keys(selectunshare).length > 0) {
      let unsharedindex = selectunshare.sharebyme.findIndex(
        (obj: any) => obj.sharedbycode === item.sharedbycode
      );
      if (unsharedindex > -1) {
        let canremove = false;
        selectunshare.sharebyme.splice(unsharedindex, 1);
        if (selectunshare.sharebyme.length <= 0) {
          delete selectunshare.sharebyme;
          if (
            selectunshare.assignedto === undefined &&
            selectunshare.sharetome === undefined
          ) {
            canremove = true;
          }
        }
        let newData = stateData;
        let selectedtree = selectedTreeItem;
        if (selectedTreeItem?.directorycode !== undefined) {
          if (!canremove) {
            newData = addorderitemstoFolderwithfilefor(
              stateData,
              selectedTreeItem?.directorycode,
              intl,
              [selectunshare],
              "UR",
              screen
            );
            setStateData(newData);
            setSelectedGridItem(selectunshare);
            setSelectedUnsharedItem(selectunshare);
          } else if (canremove) {
            newData = deleteorderitemstoFolderwithfilefor(
              stateData,
              selectedTreeItem?.directorycode,
              intl,
              [selectunshare],
              "OSBM",
              screen
            );
            setStateData(newData);
            setSelectedGridItem({});
            setSelectedUnsharedItem({});
            setDetailsData(null);
          }
          selectedtree = getDirectoryOncodeandfilefor(
            newData,
            selectedTreeItem?.directorycode,
            "OSBM"
          );
          setSelectedTreeItem(selectedtree);
          setSelectedTreeItemDuplicate(selectedtree);
        }

        setPullcontents(true);
      }


      let passobj = [{
        batchcode: selectunshare.batchcode,
        createby: { usercode: sessionStorage.User },
        stepstartdate: GetutcDate(new Date()),
        viewoption: 2,
        orderobjects: JSON.stringify({
          batchcode: selectunshare.batchcode,
          batchid: selectunshare?.batchid,
          action: "unshare",
          privileges: item?.sharerights,
          sharebyusername: item.sharebyusername,
          sharetousername: item.sharetousername,
        })
      }]

      setTimeout(() => {
        Servicecalls(
          "" + ELNurl + "/protocol/updateTransactionHistoryList",
          passobj,
          ongetordersfailure,
          ongetordersfailure
        );
      }, 1000);

    }
  };
  const onordercommonaction = (items: any, actiontype: any) => {
    if (items?.order.batchid !== undefined) {
      Servicecalls(
        "" + ELNurl + "/Instrument/getsingleorder",
        { batchcode: items?.order.batchcode },
        (response: any) => {
          if (
            response.length > 0 &&
            response[0].lockeduser !== undefined &&
            response[0].lockeduser !== null && actiontype !== "duplicate"
          ) {
            props.alert.error(
              props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDERWIHTOUTUNLOCK")
            );
          } else {
            if (actiontype === "duplicate") {
              setDublicateorderitem(response.length > 0 ? response[0] : items.order !== undefined ? items.order : items);
              setDuplicateorder(true);
            } else {
              setCancellorderitem(
                items.order !== undefined ? items.order : items
              );
              setCancellorder(true);
            }
          }
        },
        () => { }
      );
    }
  };

  const MyCustomCellAction = (props: any) => (
    <Suspense fallback={<div></div>}>
      <PendingViewCell
        {...props}
        keyfield={"batchcode"}
        // onclick={this.onbuttonchecked}
        passbackorder={onOrderShared}
        openunsharelist={openunsharelist}
        onordercommonaction={onordercommonaction}
        filedownloadurl={
          ELNurl +
          "/Instrument/downloadsheetfileforfolder/" +
          isMultitenant +
          "/" +
          sessionStorage.getItem("tenantid")
        }
        ondeletefile={ondeletefile}
      />
    </Suspense>
  );

  const [columns, setColumns] = React.useState<any[]>([
    {
      field: "batchid",
      title: props.t("Orders.Sheetorders.IDS_LBL_ORDERID", {
        screenname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_TASK")
            : props.t("Dashboard.IDS_LBL_ORDER"),
      }),
      show: true,
      default: true,
      cell: NameCell,
      // headerCell: "namecell"
      isprimary: true,
      showtoall: true,
    },
    {
      field: "dateCreated",
      title: props.t("Orders.Sheetorders.IDS_LBL_DATECREATE"),
      show: true,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "dateCompleted",
      title: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
      show: false,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "dateModified",
      title: props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON"),
      show: false,
      classNames: "date-block",
      default: false,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "testname",
      title: props.t("Orders.Sheetorders.IDS_LBL_TASK"),
      show: true,
      default: true,
    },
    {
      field: "filename",
      title: "Sheet",
      show:
        sheetcolumns !== undefined &&
          sheetcolumns.find((obj: string) => obj === "filename")
          ? true
          : false,
      default: false,
    },
    {
      field: "projectname",
      title: props.t("Orders.Sheetorders.IDS_LBL_PROJECT"),
      show:
        sheetcolumns !== undefined &&
          sheetcolumns.find((obj: string) => obj === "projectname")
          ? true
          : false,
      default: false,
    },
    {
      field: "materialname",
      title: props.t("Logbook.IDS_LBL_MATERIAL"),
      show:
        sheetcolumns !== undefined &&
          sheetcolumns.find((obj: string) => obj === "materialname")
          ? true
          : false,
      default: false,
    },
    {
      field: "tle",
      title: props.t("Orders.Sheetorders.IDS_LBL_TITLE"),
      show:
        sheetcolumns !== undefined &&
          sheetcolumns.find((obj: string) => obj === "tle")
          ? true
          : false,
      default: false,
    },
    // {
    //   field: "repositoryitemname",
    //   title: props.t("Orders.Sheetorders.IDS_LBL_INVENTORYNAME"),
    //   show:
    //     sheetcolumns !== undefined &&
    //       sheetcolumns.find((obj: string) => obj === "repositoryitemname")
    //       ? true
    //       : false,
    //   default: false,
    // },
    {
      field: "keyword",
      title: props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
      show:
        sheetcolumns !== undefined &&
          sheetcolumns.find((obj: string) => obj === "keyword")
          ? true
          : false,
      default: false,
    },
    {
      field: props.t("Orders.Sheetorders.IDS_LBL_PROCESSORDER"),
      title: props.t("Orders.Sheetorders.IDS_LBL_ACTIONS"),
      width: "100px",
      show: true,
      default: true,
      cell: MyCustomCellAction,
      headerCell: "actionheader",
      ismapulationcol: true,
    },
  ]);

  const [columnsForSplit, setColumnsForSplit] = React.useState<any[]>([
    {
      field: "directoryname",
      title: props.t("Orders.Sheetorders.IDS_LBL_ORDERID", {
        screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER"),
      }),
      show: true,
      default: true,
      cell: NameCell,
      isprimary: true,
      showtoall: true,
    },
    {
      field: "dateCreated",
      title: props.t("Orders.Sheetorders.IDS_LBL_DATECREATE"),
      show: true,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "dateCompleted",
      title: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
      show: false,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "testname",
      title: props.t("Orders.Sheetorders.IDS_LBL_TASK"),
      show: true,
      default: true,
    },
    {
      field: "filename",
      title: "Sheet",
      show: sheetcolumns !== undefined && sheetcolumns.find((obj: string) => obj === "filename") ? true : false,
      default: false,
    },
    {
      field: "projectname",
      title: props.t("Orders.Sheetorders.IDS_LBL_PROJECT"),
      show: sheetcolumns !== undefined && sheetcolumns.find((obj: string) => obj === "projectname") ? true : false,
      default: false,
    },
    {
      field: "materialname",
      title: props.t("Logbook.IDS_LBL_MATERIAL"),
      show: sheetcolumns !== undefined && sheetcolumns.find((obj: string) => obj === "materialname") ? true : false,
      default: false,
    },
    // {
    //   field: "repositoryitemname",
    //   title: props.t("Orders.Sheetorders.IDS_LBL_INVENTORYNAME"),
    //   show:
    //     sheetcolumns !== undefined &&
    //       sheetcolumns.find((obj: string) => obj === "repositoryitemname")
    //       ? true
    //       : false,
    //   default: false,
    // },
    {
      field: "keyword",
      title: props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
      show: sheetcolumns !== undefined && sheetcolumns.find((obj: string) => obj === "keyword") ? true : false,
      default: false,
    },
    {
      field: props.t("Orders.Sheetorders.IDS_LBL_PROCESSORDER"),
      title: props.t("Orders.Sheetorders.IDS_LBL_ACTIONS"),
      width: "170px",
      show: true,
      default: true,
      cell: MyCustomCellAction,
      headerCell: "actionheader",
      ismapulationcol: true,
    },
  ]);

  let split: SplitBtnItems[] = columnsForSplit.filter(
    (col) => col.show && !col.ismapulationcol
  );
  //  columns.map((col) => { return col.show && !col.ismapulationcol ? { text: col.title, value: col.field } : null }).filter(notUndefined => notUndefined !== undefined) as SplitBtnItems[];
  if (split.length > 0) {
    split = split.map((col: any) => {
      return { text: col.title, value: col.field };
    });
  }
  const [splitBtnItems, setsplitBtnItems] = React.useState<
    SplitBtnItems[] | undefined
  >(split);

  let ELNurl = (window as any).appUrl.ELN;
  // let SDMSurl = (window as any).appUrl.SDMS;

  // let deleteitem: DataModel | null = {};
  let deleteitem: any = [];

  const screen = "Sheet";
  const ongetfoldersuccess = (response: any, intl: any) => {

    console.log(selectedTreeItem);
    console.log(selectedTreeItemDuplicate);
    console.log(userrights);

    let selectedTreeItemCopy = selectedTreeItem; 

    if(!userrights?.LIMSorderVisible){
      if(userrights?.ELNorderVisible){
        selectedTreeItemCopy = pendingelnorderfolder;
      }else if(userrights?.Researchorder){
        selectedTreeItemCopy = {
          directorycode: -9,
          parentdircode: -5,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Sheet"}/${"Pending Orders"}/${"Activity Order"}`,
          directoryname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_RESEARCHACTASKS")
              : props.t("Orders.Sheetorders.IDS_LBL_REASEARCHACTIVITY"),
          icon: convertExtensionToIcon("Activity Order", null),
          filefor: "RPO",
          items: [],
        };
      }else if(userrights?.DocumentorderVisible){
        selectedTreeItemCopy = {
          directorycode: -11,
          parentdircode: -5,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Sheet"}/${"Pending Orders"}/${"Sheet Evaluation"}`,
          directoryname: props.t("Orders.Sheetorders.IDS_LBL_SHEETEVAL"),
          icon: convertExtensionToIcon("Sheet Evaluation", null),
          filefor: "SPO",
          items: [],
        };
      }else if (userrights?.ExcelorderVisible) {
        selectedTreeItemCopy = {
          directorycode: -10,
          parentdircode: -5,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Sheet"}/${"Pending Orders"}/${"Manage Excel"}`,
          directoryname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_EXCELTASKS")
              : props.t("Orders.Sheetorders.IDS_LBL_EXCEL"),
          icon: convertExtensionToIcon("Manage Excel", null),
          filefor: "MPO",
          items: [],
        };
      }
      setSelectedTreeItem(selectedTreeItemCopy);
      setSelectedTreeItemDuplicate(selectedTreeItemCopy);
    }

    let Userprojects = sessionStorage.Userprojects !== undefined ? JSON.parse(sessionStorage.Userprojects) : [];
    let directory = response?.directory?.filter((items: any) => ((items?.parentcodeondefaultfoder && Userprojects.filter((projectcode: any) => projectcode === items?.parentcodeondefaultfoder)?.length > 0) || (items?.parentcodeondefaultfoder === undefined) || (items?.parentcodeondefaultfoder % 1 !== 0)));
    // let Material_List = response.Material;
    // let Materialtest = response.Materialtest;

    let orders: DataModel[] = [];
    // let useritems: DataModel[] = [];

    // let pendingordersitems: DataModel[] = [];
    if (
      userrights.LIMSorderVisible !== undefined &&
      userrights.LIMSorderVisible === true &&
      isMultitenant === 0
    ) {
      orders.push(pendinglimsorderfolder);
    }
    if (userrights.ELNorderVisible === true) {
      orders.push(pendingelnorderfolder);
    }
    if (userrights.Researchorder === true) {
      orders.push({
        directorycode: -9,
        parentdircode: -5,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Pending Orders"}/${"Activity Order"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_RESEARCHACTASKS")
            : props.t("Orders.Sheetorders.IDS_LBL_REASEARCHACTIVITY"),
        icon: convertExtensionToIcon("Activity Order", null),
        filefor: "RPO",
        items: [],
      });
    }
    if (userrights.ExcelorderVisible === true) {
      orders.push({
        directorycode: -10,
        parentdircode: -5,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Pending Orders"}/${"Manage Excel"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_EXCELTASKS")
            : props.t("Orders.Sheetorders.IDS_LBL_EXCEL"),
        icon: convertExtensionToIcon("Manage Excel", null),
        filefor: "MPO",
        items: [],
      });
    }
    if (userrights.DocumentorderVisible === true) {
      orders.push({
        directorycode: -11,
        parentdircode: -5,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Pending Orders"}/${"Sheet Evaluation"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_SHEETEVAL"),
        icon: convertExtensionToIcon("Sheet Evaluation", null),
        filefor: "SPO",
        items: [],
      });
    }
    if (
      userrights.ELNorderVisible === true ||
      userrights.Researchorder === true ||
      userrights.ExcelorderVisible === true ||
      userrights.DocumentorderVisible === true ||
      userrights.LIMSorderVisible === true
    ) {
      orders.push({
        directorycode: -5,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Pending Orders"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_PENDINGWORK", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Pending Orders", null),
        filefor: "PO",
        items: [], //pendingordersitems,
        expanded: true,
      });
    }
    // let completedordersitems: DataModel[] = [];
    if (
      userrights.LIMSorderVisible !== undefined &&
      userrights.LIMSorderVisible === true &&
      isMultitenant === 0
    ) {
      orders.push(completedlimsorderfolder);
    }
    if (userrights.ELNorderVisible === true) {
      orders.push(completedelnorderfolder);
    }
    if (userrights.Researchorder === true) {
      orders.push({
        directorycode: -14,
        parentdircode: -6,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Completed Orders"}/${"Activity Order"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_RESEARCHACTASKS")
            : props.t("Orders.Sheetorders.IDS_LBL_REASEARCHACTIVITY"),
        icon: convertExtensionToIcon("Activity Order", null),
        filefor: "RCO",
        items: [],
      });
    }
    if (userrights.ExcelorderVisible === true) {
      orders.push({
        directorycode: -15,
        parentdircode: -6,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Completed Orders"}/${"Manage Excel"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_EXCELTASKS")
            : props.t("Orders.Sheetorders.IDS_LBL_EXCEL"),
        icon: convertExtensionToIcon("Manage Excel", null),
        filefor: "MCO",
        items: [],
      });
    }
    if (userrights.DocumentorderVisible === true) {
      orders.push({
        directorycode: -16,
        parentdircode: -6,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Completed Orders"}/${"Sheet Evaluation"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_SHEETEVAL"),
        icon: convertExtensionToIcon("Sheet Evaluation", null),
        filefor: "SCO",
        items: [],
      });
    }
    if (
      userrights.ELNorderVisible === true ||
      userrights.Researchorder === true ||
      userrights.ExcelorderVisible === true ||
      userrights.DocumentorderVisible === true ||
      userrights.LIMSorderVisible === true
    ) {
      orders.push({
        directorycode: -6,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Completed Orders"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_COMPLETEDWORK", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Completed Orders", null),
        filefor: "CO",
        items: [], //ompletedordersitems,
      });
    }

    orders.push({
      directorycode: -23,
      parentdircode: -1,
      dateCreated: convertDateFormat(
        new Date(
          currentDate !== undefined && currentDate !== null
            ? currentDate
            : new Date()
        ),
        intl
      ),
      dateModified: convertDateFormat(new Date(), intl),
      size: 124,
      path: `${"Sheet"}/${"Cancelled Orders"}`,
      directoryname: props.t("Orders.Protocolorders.IDS_LBL_CANCELLEDPROTO", {
        screenname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_TASKS")
            : props.t("Dashboard.IDS_LBL_ORDERS"),
      }),
      icon: convertExtensionToIcon("Cancelled Orders", null),
      filefor: "CAO",
      items: [], //completedordersitems,
    },
      {
        directorycode: -24,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Rejected Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_REJECTEDORDERS", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Rejected Orders", null),
        filefor: "RJO",
        items: [], //completedordersitems,
      });
    if (sessionStorage.accouttype !== "1") {
      orders.push({
        directorycode: -17,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Assigned Orders"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_ASSIGNED", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Assigned Orders", null),
        filefor: "ASO",
        items: [],
      });
    }

    if (sessionStorage.accouttype !== "1") {
      orders.push({
        directorycode: -18,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"My Orders"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_MYORDERS", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("My Orders", null),
        filefor: "MYO",
        items: [],
      });
    }
    if (
      userrights.orderByMeVisible === true ||
      userrights.orderToMeVisible === true
    ) {
      if (sessionStorage.accouttype !== "1") {
        orders.push({
          directorycode: -19,
          parentdircode: -1,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Sheet"}/${"Shared Orders"}`,
          directoryname: props.t("Orders.Sheetorders.IDS_LBL_SHAREDORDERS", {
            screenname:
              isMultitenant === 2
                ? props.t("Dashboard.IDS_LBL_TASKS")
                : props.t("Dashboard.IDS_LBL_ORDERS"),
          }),
          icon: convertExtensionToIcon("Shared Orders", null),
          filefor: "SHO",
          items: [],
        });
      }
    }
    if (userrights.orderByMeVisible === true) {
      orders.push({
        directorycode: -20,
        parentdircode: -19,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Orders Shared By Me"}`,
        directoryname: props.t("Orders.Sheetorders.IDS_LBL_ORDERSHAREDBYME", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Orders Shared By Me", null),
        filefor: "OSBM",
        items: [],
      });
    }
    if (userrights.orderToMeVisible === true) {
      orders.push({
        directorycode: -21,
        parentdircode: -19,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Orders Shared To Me"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Orders.Sheetorders.IDS_LBL_ORDERSHAREDWITHME")
            : props.t("Orders.Sheetorders.IDS_LBL_ORDERSHAREDTOME"),
        icon: convertExtensionToIcon("Orders Shared To Me", null),
        filefor: "OSTM",
        items: [],
      });
    }

    if (directory !== null && directory !== undefined && directory.length > 0) {
      // let directories: DataModel[] = [];
      directory = directory.filter((items: any) => items.path !== undefined);
      directory.map((dic: any, index: any) => {
        orders.push({
          directorycode: dic.directorycode,
          parentdircode: dic.parentdircode,
          dateCreated: convertDateFormat(new Date(dic.dateCreated), intl),
          // dateModified: convertDateFormat(new Date(dic.dateModified), intl),
          dateModified: dic.dateModified ? convertDateFormat(new Date(dic.dateModified), intl) : null,
          createdDate: dic.dateCreated,
          // dateCreated: dic.dateCreated,
          // dateModified: dic.dateModified,
          parentcodeondefaultfoder: dic?.parentcodeondefaultfoder || null,
          size: 124,
          path: dic.path,
          directoryname: dic.directoryname,
          icon: convertExtensionToIcon(dic.directoryname, null),
          filefor: "DR",
          viewoption: dic.viewoption,
          teamname: dic.teamname !== undefined ? dic.teamname : undefined,
          Created_By: dic?.createdby?.username ?? "",
          Modified_By: dic?.modifiedby?.username ?? "",
          foldermapping: dic?.foldermapping || "",
        });
        return dic;
      });
    }
    let groupeddata = groupBy(orders, "parentdircode");
    let data = groupeddata["-1"];
    let basepath = "Sheet";
    if (data !== undefined) {
      orders = formatData(
        formatserverData(data, groupeddata, intl, screen, basepath),
        intl
      );
    }
    if (
      props.notificationorder?.Open_Type === "Globl_Search_Folder" ||
      props.notificationorder?.Open_Type === "Activities_Folder"
    ) {
      let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(orders)));
      orders = expandPathInHierarchy(
        Allstate_Data,
        props.notificationorder?.path,
        orders
      );
      const newTreeItem = searchTreeItem(orders, props.notificationorder);
      setSelectedTreeItem(newTreeItem);
      if (props.notificationorder?.Open_Type === "Activities_Folder") {
        let isFolderprecentonResponce = response.directory.some((items: any) => items.directorycode === props.notificationorder?.directorycode);
        let afterFolderRemoveResponce = directory.some((items: any) => items.directorycode === props.notificationorder?.directorycode);
        if (isFolderprecentonResponce && !afterFolderRemoveResponce) {
          props.alert.error(
            props.t("Orders.Protocolorders.IDS_LBL_MAPPEDFOLDER")
          );
        }
      }
      setTimeout(() => {
        const elements = document.getElementsByClassName(
          "k-in k-state-selected"
        );
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 1000);
      props.onresetnotification();
    } else {

      console.log(selectedTreeItem);
      console.log(selectedTreeItemDuplicate);
      console.log(selectedTreeItemCopy);

      if (
          selectedTreeItemCopy !== undefined &&
          selectedTreeItemCopy?.directorycode !== undefined &&
          selectedTreeItemCopy?.filefor !== undefined
        ) {
          orders = expandparentfolder(
          orders,
          selectedTreeItemCopy?.directorycode,
          intl,
          selectedTreeItemCopy?.filefor,
          screen
        ).data;
      }      
    }
    setPullcontents(true);
    ChoosePath(orders);
    setStateData(orders);
    setIsMultiSelectOrder(false);
    setIsMultiSelectFile(false);
    setIsMultiSelectFolders(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);
    setSelectedCDPTreeItem(undefined);
    SelectedCDPTreeItem = undefined;
    SelectedCDFvalue = 4;
    initialorders = orders;
    if (
      Foldercontext === undefined ||
      props.notificationorder?.Open_Type === "Globl_Search_Folder" ||
      props.notificationorder?.Open_Type === "Activities_Folder"
    ) {
      setPullcontents(true);
    }
    else {
        getordersforfolders(
          selectedTreeItemCopy,
          selectedTreeItemCopy,
          fromRange,
          toRange,
          fileType,
          searchCriteriaType,
          orderflag,
          flitertest,
          fliterproject,
          iscancelled,
          orders
        );   
    }
  };
  /**
   * Used to Update the from and To Date to filter the folder data
   * @param From date
   * @param To date
   * @param Cloned local copy of folder data
   */
  // const getFilteredByDate = (
  //   dataList: DataModel[],
  //   fromDate: string,
  //   toDate: string
  // ) => {
  //   let list: DataModel[] = [];
  //   if (toDate && fromDate) {
  //     dataList.forEach((element) => {
  //       let obj = element;
  //       obj.items = element.items?.filter(
  //         (obj) =>
  //           obj &&
  //           obj.dateCreated &&
  //           new Date(obj.dateCreated).getTime() >=
  //           new Date(fromDate).getTime() &&
  //           new Date(obj.dateCreated).getTime() <= new Date(toDate).getTime()
  //       );
  //       list.push(obj);
  //     });
  //   } else if (fromDate) {
  //     dataList.forEach((element) => {
  //       let obj = element;
  //       obj.items = element.items?.filter(
  //         (obj) =>
  //           obj &&
  //           obj.dateCreated &&
  //           new Date(obj.dateCreated).getTime() >= new Date(fromDate).getTime()
  //       );
  //       list.push(obj);
  //     });
  //   } else {
  //     list = dataList;
  //   }
  //   return list;
  // };

  const onnotificationprocessOpenSuccess = (response: any, parameter: any) => {
    console.log(response);
    if (parameter.openfor === "link") {
      let passdata = {
        order: response.order,
        rights: userrights,
        user: store.getState().Loggeduser,
        tenantid: sessionStorage.getItem("tenantid"),
        token: sessionStorage.getItem("Token"),
        loginTime: sessionStorage.getItem("LoginTime"),
        loggedfrom: sessionStorage.getItem("loggedfrom"),
        azuretoken: sessionStorage.getItem("azuretoken"),
        tenantdomain: sessionStorage.getItem("tenantdomain"),
        packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
        username: sessionStorage.Username,
        idletime: sessionStorage.idletime
      };
      localStorage.setItem("linkedorder", JSON.stringify(passdata));
      setTimeout(() => {
        history.push("/vieworder");
      }, 500);
    } else {
      handleOrderopenClick(null, response.order);
    }
  };

  const onnotificationprocessOpenFailure = (response: any) => { };

  const updateStateforprocessnotification = (
    ordercode: any,
    openfor: String
  ) => {
    updateOrderStatusCheck(ordercode, store.getState().Loggeduser.usercode);
    let passObjDet = {
      batchcode: ordercode,
      objLoggeduser: store.getState().Loggeduser,
      ismultitenant: isMultitenant,
      lstproject: projects,
      lstworkflow: workflow,
      openfor: openfor,
    };

    setServicecall({
      ServiceToUrl: "" + ELNurl + "/Instrument/Getorderforlink",
      ServiceHeaderobject: passObjDet,
      ServiceMethodType: "POST",
      ServcieonSuccess: onnotificationprocessOpenSuccess,
      ServcieonFailure: onnotificationprocessOpenFailure,
      ServiceTenant: undefined,
      Servicecontenttype: undefined,
    });
  };

  const onAuditValidateError = (response: any) => { };

  const onAuditValidateFailure = (response: any) => { };

  const ongetfolderfailure = (event: any) => { };

  const initialLogic: "and" | "or" = "and";
  const [sortSelectedText, setsortSelectedText] = useState(split[0]?.text || "");
  const [stateContentData, setStateContentData] = React.useState<State>({
    sort: initialSort,
    filter: {
      logic: initialLogic,
      filters: [{ field: "path", operator: "contains", value: "" }],
    },
  });
  const [SearchValue, setSearchValue] = useState("");

  const updateFileDetailsData = React.useCallback(
    (selection: SelectedItemType) => {
      if (selection.path) {
        // const newSelectedItem = searchTreeItem(stateData, selection);
        setDetailsData(selection);
      } else if (!selection.path && Object.keys(selection).length) {
        setDetailsData(Object.keys(selection).length);
      } else {
        setDetailsData(null);
      }
    },
    []
  );

  const ongetorderssuccess = (responseobj: any, passeddata: any, orderobject: any) => {
    let iscolumnChanged = false;
    const updatedColumns = columns.map((col) => {
      const shouldUpdate =
        (col.field === "dateCompleted" && passeddata.filefor === "RJO") ||
        col.title === props.t("Orders.Sheetorders.IDS_LBL_DATEREJECTED");
      if (shouldUpdate) {
        iscolumnChanged = true;

        return {
          ...col,
          title:
            passeddata.filefor === "RJO"
              ? props.t("Orders.Sheetorders.IDS_LBL_DATEREJECTED")
              : props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
        };
      }
      return col;
    });

    if (passeddata.filefor === "RJO" || iscolumnChanged) {
      handleoncolumnchange(updatedColumns, splitBtnItems);
    }
    setPullcontents(false);
    let response: any = [];
    let shareOrders: any = [];

    if (responseobj?.Orders !== undefined) {
      response = responseobj?.Orders;
    } else {
      response = responseobj;
    }

    if (responseobj?.sharedmeorders !== undefined && responseobj?.sharedmeorders?.length > 0 &&
      responseobj?.sharedtome !== undefined && responseobj?.sharedtome?.length > 0
    ) {
      shareOrders = responseobj?.sharedmeorders?.map((ord: any) => {
        let s2me = responseobj.sharedtome.find((obj: any) => ord.bc === obj.sharebatchcode);
        if (s2me) {
          ord.sharetome = [s2me];
        }
        if (response.findIndex((item: any) => item.bc === ord.bc) === -1) {
          response.push(ord);
        }
        return ord;
      });
    }

    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      response = [
        ...new Map(
          response.map((item: any) => [item.bc !== undefined ? item.bc : item.batchcode, convertshorthandtooriginal(item)])
        ).values(),
      ];
      if (passeddata.filefor === "DR" && passeddata.orderflag !== undefined) {
        response = response.filter((item: any) => {
          if (item.orderflag?.trim() === passeddata.orderflag) {
            if (passeddata.approvelstatus === 3) {
              return item.approvelstatus === passeddata.approvelstatus;
            }
            return true;
          }
          return false;
        });
      }

      if (
        (passeddata.filefor === "LCO" || passeddata.filefor === "ECO" || passeddata.filefor === "RCO" || passeddata.filefor === "MCO" || passeddata.filefor === "SCO") && passeddata.isFinalStep === 2) {
        response = response.filter(
          (itesm: any) =>
            itesm.orderflag !== undefined &&
            itesm.orderflag.trim() === "R" &&
            itesm.approvelstatus !== 3
        );
      }
      if (
        passeddata.filefor === "LCO" || passeddata.filefor === "ECO" || passeddata.filefor === "RCO" || passeddata.filefor === "MCO" || passeddata.filefor === "SCO") {
        response = response.map((items: any) => {
          delete items?.lockeduser;
          return items;
        });
      }
      response.forEach((item: any) => {
        if (item?.orderflag?.trim() === "N" && item?.filetype === 0) {
          item.canuserprocess = true;
        }
        if (item?.tittle !== undefined && item?.tittle !== null) {
          item.tle = item.tittle;
        }
        // process button for "myo"
        //   else if (
        //     passeddata.filefor === "MYO"&& item.assignedto !== undefined && item.viewoption !== undefined &&item.viewoption === 1 
        //   ) {
        //       if( item.sentforapprovel!==undefined){
        //         if(item.approvelaccept === undefined){
        //           item.canuserprocess = false;
        //         }else if (item.approvelaccept==="2"){
        //           item.canuserprocess = true;
        //         }else{
        //           item.canuserprocess = false;
        //         }
        //       }else{
        //           item.canuserprocess = true;
        //       }
        //   }  

        // //   for assigned
        //   else if(passeddata.filefor === "ASO" && item.assignedto !== undefined && item.viewoption !== undefined &&item.viewoption === 1 ){
        //     if(item.sentforapprovel!==undefined){
        //       if((item.sentforapprovel && item.approvelaccept===undefined)|| item.sentforapprovel && item.approvelaccept !== "3"){
        //         item.canuserprocess = true;
        //       }else{              
        //         item.canuserprocess = false;
        //       }
        //     }else{
        //       item.canuserprocess = false;
        //     }
        //  }

        //   else if(passeddata.filefor === "DR" && item.assignedto !== undefined){
        //     if(parseInt(props.sessionvalues.usercode) === item.createdby.usercode && item.assignedto.usercode !== item.createdby.usercode){
        //           if(item.sentforapprovel!==undefined){
        //             if((item.sentforapprovel && item.approvelaccept===undefined)|| item.sentforapprovel && item.approvelaccept !== "3"){
        //               item.canuserprocess = true;
        //             }else{              
        //               item.canuserprocess = false;
        //             }
        //           }else{
        //             item.canuserprocess = false;
        //           }
        //         }else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createdby.usercode){
        //           if( item.sentforapprovel!==undefined){
        //             if(item.approvelaccept === undefined){
        //               item.canuserprocess = false;
        //             }else if (item.approvelaccept==="2"){
        //               item.canuserprocess = true;
        //             }else{
        //               item.canuserprocess = false;
        //             }
        //           }else{
        //               item.canuserprocess = true;
        //           }
        //         }else if(parseInt(props.sessionvalues.usercode) === item.createdby.usercode && item.assignedto.usercode === item.createdby.usercode){
        //           item.canuserprocess = true;
        //         }else{
        //           item.canuserprocess = false;
        //         }
        //   }

        if (item.assignedto !== undefined && item.viewoption !== undefined && item.viewoption === 1) {
          if (parseInt(props.sessionvalues.usercode) === item.createdby.usercode && item.assignedto.usercode !== item.createdby.usercode) {
            if (item.sentforapprovel !== undefined) {
              if ((item.sentforapprovel && item.approvelaccept === undefined) || (item.sentforapprovel && item.approvelaccept !== "3")) {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = false;
            }
          } else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createdby.usercode) {
            if (item.sentforapprovel !== undefined) {
              if (item.approvelaccept === undefined) {
                item.canuserprocess = false;
              } else if (item.approvelaccept === "2") {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = true;
            }
          }
        }

        else if (item.lsprojectmaster === undefined && response.assignedto === undefined
          && item.viewoption !== undefined && item.viewoption === 1) {
          item.canuserprocess = true;
        }

        else if (
          (item.lsprojectmaster === undefined &&
            item.viewoption !== undefined &&
            item.viewoption === 2 &&
            item.lsuserMaster?.usercode === parseInt(sessionStorage.User)) ||
          item.viewoption === 3
        ) {
          item.canuserprocess = true;
        }

        if (item?.sharetome !== undefined && item?.sharetome !== null) {
          item.canuserprocess = item?.sharetome?.sharerights === 1 ? true : false;
        }

        if (
          item.assignedto !== undefined &&
          (passeddata.filefor === "ASO" || passeddata.filefor === "MYO")
        ) {
          delete item.lsworkflow;
        }
      });
      orderdataforfolder = response;

      getfolderfiles(passeddata, orderobject);
    }
  };

  const ongetordersfailure = (response: any) => {

  };
  const getfolderfiles = (directory: any, orderobject: any) => {
    // if (loadtime) {
    //   ongetfilessuccess([], {
    //     directorycode: directory.directorycode, filefor: directory.filefor,
    //     contentsearchtype: searchCriteriaType.value,
    //     contentsearch: SearchContentText.SearchContentText
    //     , ismultitenant: isMultitenant,
    //     orderflag: orderflag !== undefined && orderflag !== -1 && orderflag === 1 ? "N" : "R",
    //     approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",
    //   })
    // } else {

    let returndateobj = setdates(
      filterType,
      isFiltered,
      "sheetdaydiff",
      toRange,
      changedtodate
    );
    if (returndateobj !== undefined) {
      setfromRange(returndateobj.fromRange);
      settoRange(returndateobj.toRange);
    }

    setIsLoader(true);
    setServicecall({
      ServiceToUrl: "" + ELNurl + "/Instrument/Getfilesforfolder",
      ServiceHeaderobject: {
        directorycode: directory.directorycode,
        filefor: directory.filefor,
        contentsearchtype: searchCriteriaType.value,
        contentsearch: SearchContentText.SearchContentText,
        ismultitenant: isMultitenant,
        orderflag:
          orderflag !== undefined && orderflag !== -1 && orderflag === 1
            ? "N"
            : "R",
        approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",
        fromdate: GetutcDate(new Date(returndateobj.fromRange)),
        todate: GetutcDate(new Date(returndateobj.toRange)),
        lssitemaster: {
          sitecode: sessionStorage.Usersite,
          sitename: sessionStorage.Usersitename,
        },
      },

      ServiceMethodType: "POST",
      ServcieonSuccess: (response: any, data: any) => { ongetfilessuccess(response, data, orderobject) },
      ServcieonFailure: ongetfilesfailure,
      ServiceTenant: undefined,
      Servicecontenttype: undefined,
    });
    // }
  };

  const ongetfilessuccess = (response: any, passeddata: any, orderobject: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      // setIsLoader(true);
      let directorycode = passeddata.directorycode;
      let itemdata = [];
      if (response !== undefined && response.length > 0) {
        itemdata = response;
      }
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];

      let newdata = replaceallordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );

      newdata = addfileitemstoFolderwithfilefor(
        newdata,
        directorycode,
        intl,
        itemdata,
        passeddata.filefor,
        screen
      );

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        passeddata.filefor
      );

      if (orderobject) {

        let path;
        if (selectedtree && selectedtree.items) {
          selectedtree.items.map((data: any) => {
            if (data.order && data.order.batchid === orderobject.order.batchid) {
              path = data.path;
            }
          })
        }

        setDetailsData(orderobject);
        setSelectedGridItem(orderobject);
        if (path) {
          setGridSelection({
            [path]: true,
          });
        }

        setTimeout(() => {
          const elements = document.getElementsByClassName(
            "k-in k-state-selected"
          );
          if (elements.length > 0) {
            for (let i = 0; i < elements.length; i++) {
              const element = elements[i];
              element.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }, 1000);
      }

      setSelectedTreeItem(selectedtree);
      setSelectedTreeItemDuplicate(selectedtree);
      setStateData(newdata);
      if (Folderadd_Event === undefined) {
        setSelectedCDPTreeItem(undefined);
      } else {
        Folderadd_Event = undefined;
      }

      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      setisOrderMismatched(false);
      setsheetdatainitservice(false);
      setsheetdatainit(undefined);
      setIsLoader(false);
      setIsMultiSelectOrder(false);
      setIsMultiSelectFile(false);
      setIsMultiSelectFolders(false);
      setIsSelectAllFile(false);
      setIsSelectAllOrder(false);

    } else {
      setIsLoader(false);
    }

  };

  const ongetfilesfailure = (response: any) => {
    setIsLoader(false);
  };

  const handleTreeItemClick = (event: any) => {
    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
    if (
      stateContentData !== undefined &&
      stateContentData?.sort?.length !== undefined &&
      stateContentData.sort.length > 0 &&
      stateContentData.sort[0].field === ""
    ) {
      setStateContentData({
        sort: initialSort,
        filter: {
          logic: initialLogic,
          filters: [{ field: "path", operator: "contains", value: "" }],
        },
      });
    }
    let fromDate: any;
    let toDate: any;

    const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded = !event.item.expanded;
    let returndateobj = setdates(
      filterType,
      isFiltered,
      "sheetdaydiff",
      toRange,
      changedtodate
    );
    if (returndateobj !== undefined && filterType !== 1) {
      setfromRange(returndateobj.fromRange);
      settoRange(returndateobj.toRange);
      fromDate = returndateobj.fromRange;
      toDate = returndateobj.toRange;
    } else {
      fromDate = new Date(fromRange);
      fromDate.setHours(0, 0, 0);
      toDate = new Date(fromRange);
      toDate.setHours(23, 59, 59, 999);

      setfromRange(fromDate);
      settoRange(toDate);
    }
    initialorders = null;
    getordersforfolders(
      event.item,
      newSelectedItem,
      fromDate,
      toDate,
      fileType,
      searchCriteriaType,
      orderflag,
      flitertest,
      fliterproject,
      iscancelled,
      stateData
    );
    // console.log(selectedTreeItem)
    setSelectedTreeItem(newSelectedItem);
    setSelectedTreeItemDuplicate(newSelectedItem);
    setSelectedCDPTreeItem(undefined);

    setDetailsData(event.item);
    setSelectedGridItem({});
    setGridSelection({});
  };

  const handleCDPTreeItemClick = (event: TreeViewItemClickEvent) => {
    const newSelectedItem: DataModel = searchTreeItem(stateCDFData, event.item);
    newSelectedItem.expanded = !event.item.expanded;
    setSelectedCDPTreeItem(newSelectedItem);
    SelectedCDPTreeItem = newSelectedItem;
    // setDetailsData(event.item);
    setSelectedGridItem({});
    setGridSelection({});
  };

  const onuserordersuccess = (response: any, passeddata: any) => {

    const shareresponse = response;
    const workflow = Getuserworkflowfromsession();
    //let protocolworkflow = Getprotocoluserworkflowfromsession();


    if (response.sharebyme !== undefined) {
      response.sharebyme.forEach((item: any) => {
        if (item?.order && item?.order?.batchid) {
          item = OrderSequence(item.order);
          if (item?.filename !== undefined && item?.filename !== null && item?.sheetversionno !== undefined && item?.sheetversionno !== null) {
            item.filename = item.filename + " (v" + item.sheetversionno + ")";
          }
          // item.canuserprocess = workflow && workflow?.length > 0 ? true : false;
          item.lstworkflow = workflow;

          if (item?.orderflag?.trim() === "N" && item?.filetype === 0) {
            item.canuserprocess = true;
          }
          else if (item.lsprojectmaster === undefined
            && item.viewoption !== undefined && item.viewoption === 1) {
            item.canuserprocess = true;
          } else if (
            (item.lsprojectmaster === undefined &&
              item.viewoption !== undefined &&
              item.viewoption === 2 &&
              item.lsuserMaster?.usercode === parseInt(sessionStorage.User)) ||
            item.viewoption === 3
          ) {
            item.canuserprocess = true;
          }
        }
      });
    } else if (response.sharetome !== undefined) {
      response.sharetome.forEach((item: any) => {
        if (item?.order && item?.order?.batchid) {
          item.order = OrderSequence(item.order);
          if (item?.order?.filename !== undefined && item?.order?.filename !== null && item?.order?.sheetversionno !== undefined && item?.order?.sheetversionno !== null) {
            item.order.filename = item.order.filename + " (v" + item.order.sheetversionno + ")";
          }
          item.order.lstworkflow = workflow;
        }
      });
    }

    let assignedorder: any = [];
    let sharedorder =
      response.sharebyme !== undefined ? response.sharebyme : [];
    let sharetomeorder =
      response.sharetome !== undefined ? response.sharetome : [];
    if (sharedorder !== undefined && sharedorder.length > 0) {
      sharedorder = groupBy(sharedorder, "sharebatchcode");
      sharedorder = Object.keys(sharedorder).map(function (key) {
        let order = sharedorder[key][0].order;
        let shares: any = [];
        sharedorder[key].map((share: any) => {
          share.sharedonDate = convertDateFormat(
            convertUTCDateToLocalDate(new Date(share.sharedon)),
            intl
          );
          delete share.order;
          shares.push(share);
          return share;
        });
        order.sharebyme = shares;
        // let assignedorderindex = assignedorder.findIndex(
        //   (obj: any) => obj.batchcode === parseInt(key)
        // );
        // if (assignedorderindex > -1) {
        //   assignedorder.splice(assignedorderindex, 1);
        // }
        return order;
      });

      assignedorder = assignedorder.concat(sharedorder);
    }

    if (sharetomeorder !== undefined && sharetomeorder.length > 0) {
      sharetomeorder = groupBy(sharetomeorder, "sharebatchcode");
      sharetomeorder = Object.keys(sharetomeorder).map(function (key) {
        let order = sharetomeorder[key][0].order;
        let shares: any = [];
        sharetomeorder[key].map((share: any) => {
          share.sharedonDate = convertDateFormat(
            convertUTCDateToLocalDate(new Date(share.sharedon)),
            intl
          );
          delete share.order;
          shares.push(share);
          return share;
        });
        if (sharetomeorder[key][0].sharerights !== undefined) {
          order.canuserprocess = sharetomeorder[key][0].sharerights !== undefined && sharetomeorder[key][0].sharerights === 1 && order.canuserprocess ? true : false;
        }
        order.sharetome = shares;
        // let assignedorderindex = assignedorder.findIndex(
        //   (obj: any) => obj.batchcode === parseInt(key)
        // );
        // if (assignedorderindex > -1) {
        //   if (assignedorder[assignedorderindex].sharebyme !== undefined) {
        //     order.sharebyme = assignedorder[assignedorderindex].sharebyme;
        //   }
        //   assignedorder.splice(assignedorderindex, 1);
        // }
        return order;
      });

      assignedorder = assignedorder.concat(sharetomeorder);
    }

    // let directorycode = response.directorycode;
    // let newData = replaceallordertoFolderwithfilefor(
    //   stateData,
    //   directorycode,
    //   intl,
    //   assignedorder,
    //   "UR",
    //   screen
    // );
    // let selectedtree = getDirectoryOncodeandfilefor(
    //   newData,
    //   directorycode,
    //   "UR"
    // );
    // setSelectedTreeItem(selectedtree);
    // setStateData(newData);
    orderdataforfolder = assignedorder;
    getfolderfiles({
      directorycode: response.directorycode,
      filefor: passeddata.filefor,
      searchCriteriaType,
      SearchContentText,
    }, undefined);
  };
  const Auditcancel = () => {
    ($("#auditTrailModalsheetview") as any).modal("hide");
    const fileduids = files.map(function (file) {
      return file["uid"];
    });
    const screen = "sheet";
    Servicecalls(
      "" + ELNurl + "/Instrument/onDeleteforCancel/" + screen,
      fileduids,
      ondeletefileCancelSuccess.bind(this),
      onaddFailure.bind(this)
    );
    setFiles([]);
    setDuplicateorder(false);
  };

  useEffect(() => {
    if (props.idle_save === true) {
      setidlesave(true)
    }
  }, [props.idle_save])

  // useEffect(() => {
  //console.log("kkkk")
  //
  // },[isSelectAllOrder,isSelectAllFile])
  const Commonpassobject = (
    item: any,
    newSelectedItem: any,
    fromdate: any,
    todate: any,
    filetype: any,
    searchCriteriaType: any,
    orderflag: any
  ) => {
    let passObjDet1: any = {
      filetype: filetype,
      directorycode: newSelectedItem.directorycode,
      objuser: {
        fromdate: GetutcDate(new Date(fromdate)),
        todate: GetutcDate(new Date(todate)),
      },
      filefor: item.filefor,
      createdby: store.getState().Loggeduser,
      lsuserMaster:
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? store.getState().Loggeduser
          : {
            usercode: localStorage.getItem("User"),
            username: localStorage.getItem("Username"),
            unifieduserid: localStorage.getItem("unifieduserid"),
          },
      searchCriteria: {
        contentsearchtype: searchCriteriaType.value,
        contentsearch: SearchContentText.SearchContentText,
      },
      ismultitenant: isMultitenant,
      sitemaster: { sitecode: sessionStorage.Usersite }
    };
    if (orderflag !== undefined && orderflag !== -1) {
      if (orderflag === 3) {
        passObjDet1.approvelstatus = 3;
      } else if (orderflag === 2) {
        passObjDet1.approvelstatus = 1;
      } if (orderflag === 4) {
        passObjDet1.orderflag = orderflag === 4 ? "N" : "R";
      }
      else {
        passObjDet1.orderflag = orderflag === 1 ? "N" : "R";
      }
    }



    passObjDet1.lstuserMaster = Getteamusersfromsession();

    return passObjDet1;
  };


  const flattenAndExtractDirectoryCodes = (stateDataobj: any, Isdirectfolder: boolean) => {
    const result: number[] = [];
    const traverse = (items: any[]) => {
      for (const currentValue of items) {
        if ((currentValue.filefor === "DR" && currentValue.directorycode !== undefined && currentValue.directorycode > 0 && !Isdirectfolder) || (Isdirectfolder && currentValue.directorycode !== undefined && currentValue.directorycode > 0)) {
          result.push(currentValue.directorycode);
        }
        if (currentValue.items) {
          traverse(currentValue.items);
        }
      }
    };
    traverse(stateDataobj);

    return result;
  };


  const getordersforfolders = (
    item: any,
    newSelectedItem: any,
    fromdate: any,
    todate: any,
    filetype: any,
    searchCriteriaType: any,
    orderflag: any,
    flitertest: any,
    fliterproject: any,
    iscancelled: any,
    folderdata: any
  ) => {
    // let fromdate = filterType === 1 ? GetutcDateaudi(GetutcDate(new Date(fromdateoriginal))) : fromdateoriginal;
    if (item !== undefined && item !== null) {
      if (
        (item.directorycode === -18 && item.filefor === "MYO") ||
        (item.directorycode === -17 && item.filefor === "ASO")
      ) {
        let lslogilablimsorderdetail = {
          filetype: filetype,
          fromdate: GetutcDate(new Date(fromdate)),
          todate: GetutcDate(new Date(todate)),
          lstworkflow: workflow,
          lsuserMaster:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: sessionStorage.User,
                username: sessionStorage.Username,
                unifieduserid: sessionStorage.unifieduserid,
              },
          orderflag: item.filefor === "MYO" ? "M" : "A",
          searchCriteria: {
            contentsearchtype: searchCriteriaType.value,
            contentsearch: SearchContentText.SearchContentText,
          },
          ismultitenant: isMultitenant,
          sitecode: sessionStorage.Usersite,
        };
        let passObjDet: any = {
          filetype: filetype,
          filefor: item.filefor,
          directorycode: item.directorycode,
        };
        passObjDet.lslogilablimsorderdetail = lslogilablimsorderdetail;
        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet.orderflag = orderflag === 1 ? "N" : "R";
          if (orderflag === 3) {
            passObjDet.rejected = 1;
          }
        }

        if (flitertest.testcode !== -1) {
          passObjDet.lslogilablimsorderdetail.testcode = flitertest.testcode;
        }

        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet.lslogilablimsorderdetail.lsprojectmaster = fliterproject;
        }

        setServicecall({
          ServiceToUrl:
            "" + ELNurl + "/Instrument/Getordersonassignedandmyorders",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: (response: any) => { },
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (
        (item !== undefined && item.filefor === "OSBM") ||
        item.filefor === "OSTM"
      ) {
        let passObjDet: any = {
          filetype: filetype,
          // loginuser: store.getState().Loggeduser,
          selecteduser: {
            usercode: sessionStorage.User,
            username: sessionStorage.Username,
            objuser: {
              fromdate: GetutcDate(new Date(fromdate)),
              todate: GetutcDate(new Date(todate)),
            },
            lssitemaster: {
              sitecode: sessionStorage.Usersite,
              sitename: sessionStorage.Usersitename,
            },
          },
          directorycode: item.directorycode,
          lstworkflow: workflow,
          filefor: item.filefor,

          lslogilablimsorderdetail: {
            searchCriteria: {
              contentsearchtype: searchCriteriaType.value,
              contentsearch: SearchContentText.SearchContentText,
            },
          },
          ismultitenant: isMultitenant,
        };

        if (flitertest.testcode !== -1) {
          passObjDet.testcode = flitertest.testcode;
        }
        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet.lsprojectmaster = fliterproject;
        }

        setServicecall({
          ServiceToUrl: "" + ELNurl + "/Instrument/Getusersharedorders",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: onuserordersuccess,
          ServcieonFailure: (response: any) => { },
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (item !== undefined && item.filefor === "CAO" || item.filefor === "RJO") {
        let passObjDet1: any = {
          filetype: filetype,
          directorycode: newSelectedItem.directorycode,
          fromdate: GetutcDate(new Date(fromdate)),
          todate: GetutcDate(new Date(todate)),
          filefor: item.filefor,
          lstproject: projects,
          createdby: store.getState().Loggeduser,
          lsuserMaster:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: localStorage.getItem("User"),
                username: localStorage.getItem("Username"),
                unifieduserid: localStorage.getItem("unifieduserid"),
              },
          searchCriteria: {
            contentsearchtype: searchCriteriaType.value,
            contentsearch: SearchContentText.SearchContentText,
          },
          ismultitenant: isMultitenant,
          sitecode: sessionStorage.Usersite,
        };
        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet1.orderflag = orderflag === 1 ? "N" : "R";
        }
        if (orderflag !== undefined && orderflag === 3) {
          passObjDet1.approvelstatus = 3;
          passObjDet1.rejected = 1;
        } else if (orderflag !== undefined && orderflag === 2) {
          passObjDet1.approvelstatus = 1;
        }
        passObjDet1.lstuserMaster = Getteamusersfromsession();
        if (passObjDet1.lstproject === null) {
          passObjDet1.lstproject = [{
            projectcode: -1
          }]
        }
        if (passObjDet1.lstuserMaster === null) {
          passObjDet1.lstuserMaster = [{
            usercode: -1
          }]
        }

        if (flitertest.testcode !== -1) {
          passObjDet1.testcode = flitertest.testcode;
        }

        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet1.lsprojectmaster = fliterproject;
        }
        let Url = item.filefor === "CAO" ? "/Instrument/Getcancelledordes" : "/Instrument/GetRejectedorderbyflaganduser";
        setServicecall({
          ServiceToUrl: "" + ELNurl + Url,
          ServiceHeaderobject: passObjDet1,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (item !== undefined && item.filefor === "DR") {
        let passObjDet1: any = {};
        let URL_Servicecall: any = "";
        if (
          item?.parentcodeondefaultfoder !== undefined &&
          item.parentcodeondefaultfoder !== null &&
          item?.path.includes("Sheet/Projects/")
        ) {
          let directorycode = item.parentcodeondefaultfoder
            .toString()
            .split(".");
          let fromDate = GetutcDate(new Date(fromdate));
          if (fromdate === todate) {
            fromdate = new Date(fromdate).setHours(0);
            fromDate = GetutcDate(new Date(fromdate));
          }
          passObjDet1 = {
            filetype: filetype,
            fromdate: fromDate,
            todate: GetutcDate(new Date(todate)),
            lsprojectmaster: { projectcode: directorycode[0] },
            lstestmasterlocal: { testcode: directorycode[1] },
            directorycode: newSelectedItem.directorycode,
            filefor: item.filefor,
            lsuserMaster: store.getState().Loggeduser,
            searchCriteria: {
              contentsearchtype: searchCriteriaType.value,
              contentsearch: SearchContentText.SearchContentText,
            },
            ismultitenant: isMultitenant,
            sitecode: sessionStorage.Usersite,
          };
          if (orderflag !== undefined && orderflag !== -1) {
            passObjDet1.orderflag = orderflag === 1 ? "N" : "R";
          }
          if (orderflag !== undefined && orderflag === 3) {
            passObjDet1.approvelstatus = 3;
          } else if (orderflag !== undefined && orderflag === 2) {
            passObjDet1.approvelstatus = 1;
          }
          passObjDet1.lssheetOrderStructure = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            filetype,
            searchCriteriaType,
            orderflag
          );
          passObjDet1.lstworkflow = workflow;
          URL_Servicecall = "" + ELNurl + "/Instrument/Getordersonproject";
        } else if (
          item?.parentcodeondefaultfoder !== undefined &&
          item.parentcodeondefaultfoder !== null &&
          item?.path.includes("Sheet/Material/")
        ) {
          let directorycode = item.parentcodeondefaultfoder
            .toString()
            .split(".");

          passObjDet1 = {
            filetype: filetype,
            fromdate: GetutcDate(new Date(fromdate)),
            todate: GetutcDate(new Date(todate)),
            elnmaterial: { nmaterialcode: directorycode[0] },
            lstestmasterlocal: { testcode: directorycode[1] },
            directorycode: newSelectedItem.directorycode,
            filefor: item.filefor,
            lsuserMaster: store.getState().Loggeduser,
            searchCriteria: {
              contentsearchtype: searchCriteriaType.value,
              contentsearch: SearchContentText.SearchContentText,
            },
            ismultitenant: isMultitenant,
            lstproject: projects,
          };
          if (orderflag !== undefined && orderflag !== -1) {
            passObjDet1.orderflag = orderflag === 1 ? "N" : "R";
          }
          if (orderflag !== undefined && orderflag === 3) {
            passObjDet1.approvelstatus = 3;
          } else if (orderflag !== undefined && orderflag === 2) {
            passObjDet1.approvelstatus = 1;
          }
          passObjDet1.lstuserMaster = Getteamusersfromsession();
          passObjDet1.lssheetOrderStructure = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            filetype,
            searchCriteriaType,
            orderflag
          );
          URL_Servicecall = "" + ELNurl + "/Instrument/Getordersonmaterial";
        }
        else {
          passObjDet1 = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            filetype,
            searchCriteriaType,
            orderflag
          );
          if (flitertest.testcode !== -1) {
            passObjDet1.testcode = flitertest.testcode;
          }

          if (
            fliterproject.projectcode !== undefined &&
            fliterproject.projectcode !== -1
          ) {
            passObjDet1.lsprojectmaster = fliterproject;
          }

          passObjDet1.lstworkflow = workflow;
          passObjDet1.lsusersteam = Getteamfromsession();
          passObjDet1.sitemaster = { sitecode: sessionStorage.Usersite };
          passObjDet1.iscancelled = iscancelled;
          passObjDet1.lstworkflow = workflow;
          // passObjDet1.objuser =
          URL_Servicecall = "" + ELNurl + "/Instrument/Getordersondirectory";
        }

        setServicecall({
          ServiceToUrl: URL_Servicecall,
          ServiceHeaderobject: passObjDet1,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
      else if (item !== undefined && item.filefor === "TMS") {
        let directorycode = newSelectedItem.directorycode.toString().split(".");

        let passObjDet3: any = {
          filetype: filetype,
          fromdate: GetutcDate(new Date(fromdate)),
          todate: GetutcDate(new Date(todate)),
          lssamplemaster: { samplecode: directorycode[0] },
          lstestmasterlocal: { testcode: directorycode[1] },
          directorycode: newSelectedItem.directorycode,
          filefor: item.filefor,
          lstworkflow: workflow,
          lsuserMaster: store.getState().Loggeduser,
          searchCriteria: {
            contentsearchtype: searchCriteriaType.value,
            contentsearch: SearchContentText.SearchContentText,
          },
          ismultitenant: isMultitenant,
        };
        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet3.orderflag = orderflag === 1 ? "N" : "R";
        }
        if (orderflag !== undefined && orderflag === 3) {
          passObjDet3.approvelstatus = 3;
        } else if (orderflag !== undefined && orderflag === 2) {
          passObjDet3.approvelstatus = 1;
        }
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/Instrument/Getordersonsample",
          ServiceHeaderobject: passObjDet3,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
      else if (
        item !== undefined &&
        (item.filefor === "LPO" ||
          item.filefor === "EPO" ||
          item.filefor === "RPO" ||
          item.filefor === "MPO" ||
          item.filefor === "SPO" ||
          item.filefor === "LCO" ||
          item.filefor === "ECO" ||
          item.filefor === "RCO" ||
          item.filefor === "MCO" ||
          // item.filefor === "RJO" ||
          item.filefor === "SCO")
      ) {
        columns.map((col) => {
          if (
            item.filefor === "LCO" ||
            item.filefor === "ECO" ||
            item.filefor === "RCO" ||
            item.filefor === "MCO" ||
            item.filefor === "SCO"
          ) {
            if (col.field === "dateCompleted") {
              col.show = true;
            }
          } else {
            if (col.field === "dateCompleted") {
              col.show = false;
            }
          }
          return col;
        });

        let fromDate = GetutcDate(new Date(fromdate));

        if (fromdate === todate) {
          fromdate = new Date(fromdate).setHours(0);
          fromDate = GetutcDate(new Date(fromdate));
        }


        let lstdirectorycode = flattenAndExtractDirectoryCodes(JSON.parse(JSON.stringify(folderdata)), false);

        let passObjDet4: any = {
          filetype: renderSwitch(item.filefor),
          fromdate: fromDate,
          todate: GetutcDate(new Date(todate)),
          lstproject: projects,
          lstworkflow: workflow,
          directorycode: newSelectedItem.directorycode,
          orderflag:
            item.filefor === "LPO" ||
              item.filefor === "EPO" ||
              item.filefor === "RPO" ||
              item.filefor === "MPO" ||
              item.filefor === "SPO"
              ? "N"
              : "R",
          filefor: item.filefor,
          lsuserMaster: store.getState().Loggeduser,
          searchCriteria: {
            contentsearchtype: searchCriteriaType.value,
            contentsearch: SearchContentText.SearchContentText,
          },
          ismultitenant: isMultitenant,
          lstdirectorycode
        };

        if (
          item.filefor === "LCO" ||
          item.filefor === "ECO" ||
          item.filefor === "RCO" ||
          item.filefor === "MCO" ||
          // item.filefor === "RJO" ||
          item.filefor === "SCO"
        ) {
          if (
            orderflag !== undefined &&
            (orderflag === -1 || orderflag === 2)
          ) {
            passObjDet4.orderflag = "R";
            passObjDet4.isFinalStep = orderflag;
          } else if (orderflag !== undefined && orderflag === 3) {
            passObjDet4.approvelstatus = 3;
          }
        }

        if (flitertest.testcode !== -1) {
          passObjDet4.testcode = flitertest.testcode;
        }
        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet4.lsprojectmaster = fliterproject;
        }
        passObjDet4.lstuserMaster = Getteamusersfromsession();
        console.log(passObjDet4);
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/Instrument/Getorderbyflaganduser",
          ServiceHeaderobject: passObjDet4,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
      columns.map((col) => {
        if (
          item.filefor === "LCO" ||
          item.filefor === "ECO" ||
          item.filefor === "RCO" ||
          item.filefor === "MCO" ||
          item.filefor === "SCO" || item.filefor === "RJO"
        ) {
          if (col.field === "dateCompleted") {
            col.show = true;
          }
        } else {
          if (col.field === "dateCompleted") {
            col.show = false;
          }
        }
        return col;
      });
      setPullcontents(false);
    }
  };



  const handleSplitterChange = (event: SplitterOnChangeEvent) => {
    setPanes(event.newState);
  };

  const handleSelectionChange = (event: GridRowClickEvent, skipdata: any) => {
    // if (contentView === "grid" && click >= 2) {
    //   handleGridDoubleClick(event, skipdata);
    // }
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }

    setSelectedGridItem(event.dataItem);
    updateFileDetailsData(event.dataItem);
    if (event.dataItem.path) {
      const key = event.dataItem["path"].toString();
      setGridSelection({ [key]: true });
    }
  };

  const handleMultipleSelection = (event: any, skipdata: any) => {
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }

    const newSelection = getSelectedState({
      event,
      selectedState: gridSelection,
      dataItemKey: DATA_ITEM_KEY,
    });

    setGridSelection(newSelection);
    updateFileDetailsData(newSelection);
  };

  const handleSortChange = (event: SortChangeEvent, skipdata: any) => {
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }
    const newSortedData = clone(stateContentData);

    if (event.direction === "asc" || event.direction === "desc") {
      newSortedData.sort[0].dir = event.direction;
    }

    if (event.item) {
      newSortedData.sort[0].field = event.item.value;
    }

    if (event.sort) {
      newSortedData.sort = event.sort;
    }
    if (event?.direction === undefined) {
      setsortSelectedText(event.item.text || "");
    }
    setStateContentData(newSortedData);
  };

  const handleGridDoubleClick = (
    event: GridRowDoubleClickEvent,
    skipdata: any
  ) => {
    console.trace();
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }

    const itemType = convertExtensionToIcon(event.dataItem.path, null);
    if (itemType?.type === props.t("Header.IDS_LBL_FOLDERS")) {
      if (selectedTreeItem) {
        selectedTreeItem.expanded = true;
      }

      const newSelectedItem = searchTreeItem(stateData, event.dataItem);
      newSelectedItem.expanded = true;
      setSelectedTreeItem(newSelectedItem);
      setSelectedTreeItemDuplicate(newSelectedItem);
      initialorders = null;
      getordersforfolders(
        event.dataItem,
        newSelectedItem,
        fromRange,
        toRange,
        fileType,
        searchCriteriaType,
        orderflag,
        flitertest,
        fliterproject,
        iscancelled,
        stateData
      );
    } else if (
      event.dataItem !== undefined &&
      event.dataItem.order !== undefined &&
      event.dataItem.order.ordercancell === undefined
    ) {
      handleOrderopenClick(null, event.dataItem.order);
    } else if (
      event.dataItem !== undefined &&
      event.dataItem.order !== undefined &&
      event.dataItem.order.ordercancell !== undefined &&
      event.dataItem.order.ordercancell === 1
    ) {
      props.alert.error(
        props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDEROPEN")
      );
    }
  };

  const handleMultiSelectClick = (event: any, item: any) => {
    let itemindex = selectedOrders.findIndex(
      (obj) => obj.batchcode === item.batchcode
    );
    if (itemindex > -1) {
      selectedOrders.splice(itemindex, 1);
    } else {
      selectedOrders.push(item);
    }

    setSelectedOrders([...selectedOrders]);
  };

  const handleMultiSelectFileClick = (event: any, item: any) => {
    let itemindex = selectedFiles.findIndex(
      (obj) => obj.folderfilecode === item.folderfilecode
    );
    if (itemindex > -1) {
      selectedFiles.splice(itemindex, 1);
    } else {
      selectedFiles.push(item);
    }

    setSelectedFiles([...selectedFiles]);
  };

  const handleMultiSelectFolderClick = (event: any, item: any) => {
    let itemindex = selectedFolders.findIndex(
      (obj) => obj.directorycode === item.directorycode
    );
    if (itemindex > -1) {
      selectedFolders.splice(itemindex, 1);
    } else {
      selectedFolders.push(item);
    }

    setSelectedFolders([...selectedFolders]);
  };

  const onOrderShared = (item: any) => {
    if (selectedTreeItem !== undefined && selectedTreeItem !== null) {
      let directorycode = selectedTreeItem?.directorycode;
      let filefor = selectedTreeItem?.filefor;
      if (
        filefor === "UR" &&
        directorycode !== undefined &&
        directorycode?.toString() === sessionStorage.getItem("User")
      ) {
        let selectedtreeitems =
          selectedTreeItem !== undefined ? selectedTreeItem?.items : [];
        let selecteditem = selectedGridItem;
        selectedtreeitems = selectedtreeitems?.map((obj: any) => {
          if (
            obj.directorycode === item.order.order.batchcode &&
            obj.order !== undefined
          ) {
            if (obj.order.sharebyme === undefined) {
              obj.order.sharebyme = [];
            }
            let shareindex = obj.order.sharebyme.findIndex(
              (shareobj: any) =>
                shareobj.sharedbycode === item.order.sharedbycode
            );
            let itemvalue = item.order;
            itemvalue.sharedonDate = convertDateFormat(
              convertUTCDateToLocalDate(new Date(itemvalue.sharedon)),
              intl
            );
            if (shareindex <= -1) {
              obj.order.sharebyme.push(itemvalue);
            } else {
              obj.order.sharebyme[shareindex] = itemvalue;
            }
            selecteditem = obj;
          }
          return obj;
        });
        if (selectedtreeitems !== undefined) {
          selectedTreeItem.items = selectedtreeitems;
          setSelectedTreeItem(selectedTreeItem);
          setSelectedTreeItemDuplicate(selectedTreeItem);
          setSelectedGridItem(selecteditem);
          setDetailsData(selecteditem);
        }
      }
    }
  };
  const handlecancelClick = (event: any) => {
    SelectedCDFvalue = 4;
    setSelectedCDPTreeItem(undefined);

    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
  };


  const handleexportClick = (evet: any) => {
    if ((excelExportRef.current !== null && contentView === "grid") || (contentView === "list")) {
      // if (contentView === "list") {
      let item = selectedTreeItem && selectedTreeItem.items
        ? process(
          selectedTreeItem.items.map((item: any) => ({
            ...item,
            [SELECTED_FIELD]: gridSelection[idGetter(item)],
          })),
          stateContentData
        )
        : !selectedTreeItem
          ? process(
            stateData.map((item) => ({
              ...item,
              [SELECTED_FIELD]: gridSelection[idGetter(item)],
            })),
            stateContentData
          )
          : null;
      const dateFields = ['dateCompleted', 'dateCreated', 'dateModified'];

      excelExportRef.current = {
        allResult: {
          data: (item?.data || []).reduce((acc, items) => {
            if (!items?.order) return acc;
            const order = { ...items.order };
            for (const field of dateFields) {
              if (items[field] !== undefined) {
                order[field] = items[field];
              }
            }
            return [...acc, order];
          }, []),
          columns,
        },
      };
      // }
      gridDtatExportToolBar(evet, excelExportRef, "Sheet Orders", contentView);
    }
  }
  const handleExcelExport = (excelExportRefobj: any, allResult: any) => {
    if (excelExportRefobj.current !== null) {
      excelExportRef = excelExportRefobj;
      excelExportRef.current.allResult = allResult;
    }
  };

  const handleNewFolderClick = (event: any) => {
    Folderadd_Event = event;
    let newData: any = props.sessionvalues;
    newData.directoryname = event.value.trim();
    newData.viewoption = event.folderplace;
    newData.sitemaster = { sitecode: sessionStorage.Usersite };
    newData.createdby = { usercode: sessionStorage.User };
    // newData.teamcode = event.projectteamcode !== undefined ? event.projectteamcode.teamcode : undefined;

    // if (selectedTreeItem) {
    //   if (selectedTreeItem.filefor === "DR" || selectedTreeItem.filefor === "TMP" || selectedTreeItem.filefor === "TMS") {
    //     newData.parentdircode = selectedTreeItem.directorycode;
    //   } else {
    //     newData.parentdircode = stateData[0].parentdircode;
    //   }
    // }
    // SelectedCDFvalue =event.selectedCDF;

    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;
    if (Selected_Treeitems) {
      if (
        (Selected_Treeitems !== undefined &&
          Selected_Treeitems.filefor === "DR") ||
        Selected_Treeitems.filefor === "TMP" ||
        Selected_Treeitems.filefor === "TMS" ||
        Selected_Treeitems.filefor === "TMM"
      ) {
        let parts = Selected_Treeitems?.directorycode?.toString().split(".");
        if (parts?.length === 2) {
          newData.parentdircode = parts[0];
          newData.floatvalues = parts[1];
        } else {
          newData.parentdircode = Selected_Treeitems.directorycode;
        }
      } else {
        newData.parentdircode = stateData[0].parentdircode;
      }
    } else {
      newData.parentdircode = stateData[0].parentdircode;
    }

    if (
      Object.keys(event?.FOlder_Type).length > 0 &&
      Object.keys(event?.Onselected_Foldertype).length > 0
    ) {
      const folderTypeCode = event.FOlder_Type.code;
      const folderMapValues =
        folderTypeCode === 1
          ? event.Onselected_Foldertype.projectname
          : folderTypeCode === 2
            ? event.Onselected_Foldertype.testname
            : event.Onselected_Foldertype.matname;

      newData.foldermapping = `${event.FOlder_Type.Folder_Type} - ${folderMapValues}`;
      if (event.Onselected_Foldertype?.projectcode !== undefined) {
        newData.parentcodeondefaultfoder = event.Onselected_Foldertype?.projectcode
      }
    } else if (Object.keys(event?.FOlder_Type).length > 0) {
      const folderTypeCode = event.FOlder_Type.code;
      if (folderTypeCode === 0) {
        newData.foldermapping = `${event.FOlder_Type.Folder_Type}`;
      }
    }
    Servicecalls(
      "" + ELNurl + "/Instrument/Insertdirectory",
      newData,
      onfoldersuccess,
      onfolderfailure
    );
  };

  const onfoldersuccess = (response: any, event: any) => {
    let passObjDet = {};
    let validData = response.response.status;
    let newData = props.sessionvalues;
    response.parentdircode = response.parentdircode + "." + event.floatvalues;
    newData.sitemaster = { sitecode: sessionStorage.Usersite };
    newData.createdby = { usercode: sessionStorage.User };

    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;

    if (validData) {
      if (
        Selected_Treeitems &&
        (Selected_Treeitems?.filefor === "DR" ||
          Selected_Treeitems.filefor === "TMP" ||
          Selected_Treeitems.filefor === "TMS" ||
          Selected_Treeitems.filefor === "TMM")
      ) {
        newData = getFolderToSave(
          stateData,
          Selected_Treeitems,
          intl,
          response.directoryname,
          screen,
          response
        );
        // let passObjDet = {
        //   objsilentaudit: Silentauditobject(
        //     "create",
        //     "Sheet Orders",
        //     props.t("Orders.Sheetorders.IDS_AUDIT_WITHINANOTHERFOLDER", {
        //       user: props.sessionvalues.username,
        //       folder2: response.directoryname,
        //       folder1: Selected_Treeitems.directoryname,
        //       visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : "Project Team"

        //     })
        //   ),
        // };
        // Servicecalls(
        //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        //   passObjDet,
        //   onAuditValidateError.bind(this),
        //   onAuditValidateFailure.bind(this)
        // );
      } else {
        newData = getFolderToSave(
          stateData,
          null,
          intl,
          response.directoryname,
          screen,
          response
        );
        // let passObjDet = {
        //   objsilentaudit: Silentauditobject(
        //     "create",
        //     "Sheet Orders",
        //     props.t("Orders.Sheetorders.IDS_AUDIT_REQADDNEWFOLDER", {
        //       user: props.sessionvalues.username,
        //       folder: response.directoryname,
        //       visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : "Project Team"

        //     })
        //   ),
        // };
        // Servicecalls(
        //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        //   passObjDet,
        //   onAuditValidateError.bind(this),
        //   onAuditValidateFailure.bind(this)
        // );
      }
      newData.parentdircode = event.parentdircode;
      newData.floatvalues = event.floatvalues;
      let Audit = AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_SHEETORDERS",
        "IDS_TSK_NEWFOLDER"
      );
      if (Audit) {
        ($("#auditTrailModalsheetview") as any).modal("show");
        newData.objmanualaudit = Manualauditobject("create", "Sheet Orders");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/Insertnewdirectory",
          AuditObject: newData,
          AuditPassfunction: oninsertfoldersuccess,
          AuditFailfunction: oninsertfolderfailure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/Instrument/Insertnewdirectory",
          newData,
          oninsertfoldersuccess,
          oninsertfolderfailure
        );
      }
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST"));
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "warning",
          "Sheet Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_FOLDEREXIST", {
            folder: response.directoryname,
          })
        ),
      };
    }

    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
  };

  const onfolderfailure = (response: any) => { };

  const oninsertfoldersuccess = (response: any) => {
    if (response.floatvalues !== undefined) {
      response.parentdircode = parseFloat(
        response.parentdircode + "." + response.floatvalues
      );
    }
    ($("#auditTrailModalsheetview") as any).modal("hide");
    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;

    if (
      Selected_Treeitems &&
      (Selected_Treeitems?.filefor === "DR" ||
        Selected_Treeitems.filefor === "TMP" ||
        Selected_Treeitems.filefor === "TMS" ||
        Selected_Treeitems.filefor === "TMM")
    ) {
      // newData = getFolderToSave(
      //   stateData,
      //   selectedTreeItem,
      //   intl,
      //   response.directoryname,
      //   screen,
      //   response
      // );
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_WITHINANOTHERFOLDER", {
            user: props.sessionvalues.username,
            folder2: response.directoryname,
            folder1: Selected_Treeitems.directoryname,
            visible:
              response.viewoption === 1
                ? "Site"
                : response.viewoption === 2
                  ? "Only me"
                  : "Project Team",
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    } else {
      // newData = getFolderToSave(
      //   stateData,
      //   null,
      //   intl,
      //   response.directoryname,
      //   screen,
      //   response,

      // );
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_REQADDNEWFOLDER", {
            user: props.sessionvalues.username,
            folder: response.directoryname,
            visible:
              response.viewoption === 1
                ? "Site"
                : response.viewoption === 2
                  ? "Only me"
                  : "Project Team",
            screenname:
              isMultitenant === 2
                ? props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS")
                : props.t("Orders.Sheetorders.IDS_LBL_SHEETORDER"),
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }

    let newData;

    props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FOLDERADDED"));

    if (response !== undefined) {
      response.icon = convertExtensionToIcon(response.directoryname, null);
      response.dateCreated = convertDateFormat(
        convertUTCDateToLocalDate(new Date(response.dateCreated)),
        intl
      );
      // response.dateModified = convertDateFormat(
      //   convertUTCDateToLocalDate(new Date(response.dateModified)),
      //   intl
      // );

      response.filefor = "DR";
      response.Created_By = sessionStorage.Username;
    }
    if (
      Selected_Treeitems &&
      (Selected_Treeitems?.filefor === "DR" ||
        Selected_Treeitems.filefor === "TMP" ||
        Selected_Treeitems.filefor === "TMS" ||
        Selected_Treeitems.filefor === "TMM")
    ) {
      newData = addFolderonObj(stateData, Selected_Treeitems, intl, response);
      // const newTreeItem = searchTreeItem(newData, Selected_Treeitems);
      // setSelectedTreeItem(newTreeItem);
      // setSelectedTreeItemDuplicate(newTreeItem);
    } else {
      newData = addFolderonObj(stateData, null, intl, response);
    }
    const newTreeItem = searchTreeItem(newData, response);

    setSelectedTreeItem(newTreeItem);
    setSelectedTreeItemDuplicate(newTreeItem);
    let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(newData)));
    let Statevalues_update: DataModel[] = expandPathInHierarchy(
      Allstate_Data,
      response.path,
      newData
    );

    setStateData(Statevalues_update);

    if (Folderadd_Event?.Enable_Newfolder !== undefined) {
      setSelectedCDPTreeItem(newTreeItem);
      SelectedCDPTreeItem = newTreeItem;
    } else {
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
    }

    SelectedCDFvalue = 4;
    setDetailsData(response);
    ChoosePath(Statevalues_update);
    // setStateCDFData(newData?.filter((item: any) => item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"))
    Isview_Constence = false;
    setPullcontents(true);
    // setradioCDFbtnenable(4);
    // setTimeout(() => {
    //   response.expanded = true;
    //   handleTreeItemClick({ item: response });
    // }, 30);
  };

  const expandPathInHierarchy = (
    stateDataobj: any,
    path: any,
    stateData: any
  ) => {
    const pathSegments = path.split("/");
    let currentLevel = stateDataobj;
    const Fullpath = pathSegments.reduce((Path: any, Items: any) => {
      Path = Path ? `${Path}/${Items}` : Items;
      const matchingFolder = currentLevel.find(
        (folder: any) => folder.path === Path
      );
      if (matchingFolder) {
        let State_updateddata = Onsetfolderexpande(
          stateData,
          matchingFolder?.directorycode,
          screen
        );
        stateData = State_updateddata;
      }
      return Path;
    }, "");
    return stateData;
  };

  const flattenHierarchy = (stateDataobj: any) => {
    console.log(stateDataobj);
    return stateDataobj?.reduce((result: any[], currentValue: any) => {
      result.push(currentValue);
      if (currentValue.items) {
        result = result.concat(flattenHierarchy(currentValue.items));
      }
      return result;
    }, []);
  };

  const oninsertfolderfailure = (response: any) => { };

  const handleRegisterOrder = (response: any) => {
    let selectedorder = response.selectOrderData;
    let selectedtest = response.selectTestData;
    let selectedsheet = response.selectSheetData;
    let selectedproject = response.selectProjectData;
    let selectedsample = response.selectSampleData;
    let selectedrepository = response.selectRepoData;
    let selectedrepositorydata = response.selectRepodataData;
    // let selectedworkflow = response.selectWflowData;
    let selectedkeyword = response.selectOrderKey;
    let selectedfolder = response.selectFolderData;
    let selectassigneduser = response.selectassigneduser;
    let viewoption = response.viewoption;
    let selectedMaterial = response.selectMaterial;
    let selectedMaterialInventory = response.selectMaterialInventory;
    let duedate = response.duedate;
    let cautiondate = response.cautiondate;
    let period = response.period;
    let Repeat = response.Repeat;
    let Interval = response.Interval;
    let timespan = response.timespan;
    let autocreatedate = response.autocreatedate;
    let Autoregister_Count = response?.Autoregister_Count;
    let selectedprojectteam = response?.selectedprojectteam;
    let teamselected = response?.selectedprojectteam.length > 0 ? true : false;

    let lsautoregisterorderdetail = {
      repeat: Repeat,
      interval: Interval,
      timespan: timespan !== undefined ? timespan.name : "",
      screen: "Sheet_Order",
      autocreatedate: autocreatedate,
      ismultitenant: isMultitenant,
    };

    // let teamcode = response.projectteamcode !== undefined ? response.projectteamcode.teamcode : undefined

    let contentparsed =
      selectedsheet !== undefined &&
        selectedsheet.filecontent === undefined &&
        selectedsheet.filecontent !== null
        ? extractValuefromsheet(selectedsheet.filecontent)
        : extractValuefromsheet(sheetDefaultContent);

    if (parseInt(selectedorder.type) === 4) {
      selectedsheet = { filecode: 1, filecontent: sheetDefaultContent };
    }
    let sequence = getsequenceoncode(1);
    let passObjDet: any = {
      testcode:
        selectedtest !== undefined && selectedtest !== null
          ? selectedtest.testcode
          : null,
      testname:
        selectedtest !== undefined && selectedtest !== null
          ? selectedtest.testname
          : null,
      lstestmasterlocal:
        selectedtest !== undefined &&
          selectedtest !== null &&
          Object.keys(selectedtest).length > 0
          ? selectedtest
          : null,
      lsfile: selectedsheet,
      sheetversionno: ((parseInt(selectedorder.type) === 2 || parseInt(selectedorder.type) === 3) && (selectedsheet?.approved !== 1)) ? (selectedsheet?.versionno - 1) : selectedsheet?.versionno || 1,
      lssamplefile: {
        filecontent:
          selectedsheet !== undefined
            ? selectedsheet.filecontent
            : sheetDefaultContent,
        contentvalues: contentparsed.contentvalues,
        contentparameter: contentparsed.contentparameter,
        createdate: GetutcDate(new Date()),
        createbyuser: store.getState().Loggeduser,
        processed: 0,
        versionno: 1,
        lssamplefileversion: [
          {
            filecontent:
              selectedsheet !== undefined
                ? selectedsheet.filecontent
                : sheetDefaultContent,
            createdate: GetutcDate(new Date()),
            createbyuser: store.getState().Loggeduser,
            versionno: 1,
            versionname: "version_1",
          },
        ],
      },
      filetype: parseInt(selectedorder.type),
      lsuserMaster: store.getState().Loggeduser,
      lsprojectmaster: selectedproject,
      assignedto: selectassigneduser,
      sample: selectedsample !== undefined && selectedsample !== null
        ? selectedsample
        : null,
      objLoggeduser: store.getState().Loggeduser,
      //  objsilentaudit: silentaudit,
      objmanualaudit: Manualauditobject("insert", "Sheet Orders"),
      ismultitenant: isMultitenant,
      createdtimestamp: GetutcDate(new Date()),
      lsrepositories: !isPremiumTenant ? selectedrepository : null,
      lsrepositoriesdata: !isPremiumTenant ? selectedrepositorydata : null,
      elnmaterial: selectedMaterial?.matcode ? { nmaterialcode: selectedMaterial.matcode, smaterialname: selectedMaterial.matname } : null,
      elnmaterialinventory: isPremiumTenant ? selectedMaterialInventory : null,
      keyword: selectedkeyword,
      tittle: response.selectOrdertittle,
      directorycode:
        selectedfolder === undefined || selectedfolder === null
          ? null
          : selectedfolder.directorycode,
      orderdisplaytype: response.orderdisplaytype,
      viewoption:
        selectedproject !== undefined && selectedproject !== null
          ? 1
          : viewoption,
      lstworkflow: workflow,
      duedate: GetutcDate(duedate),
      cautiondate: GetutcDate(cautiondate),
      period: period !== undefined ? period.name : "",
      repeat: Repeat,
      lsselectedTeam: selectedprojectteam,
      teamselected: teamselected,
      isclone: false,
      sequenceid: sequence && formsequenceformatview(JSON.parse(sequence.sqf), sequence.sep, "g", {
        projectname: selectedproject && selectedproject.projectname ? selectedproject.projectname : "",
        projectcode: selectedproject && selectedproject.projectid ? selectedproject.projectid : "",
        task: selectedtest && selectedtest.testname ? selectedtest.testname : "",
        ordertype: getordertype(parseInt(selectedorder.type))
      })
    };
    if (Repeat) {
      passObjDet.autoregistercount = Autoregister_Count;
    }
    passObjDet.lsautoregisterorderdetail = Repeat
      ? lsautoregisterorderdetail
      : null;

    // passObjDet.lsautoregisterorderdetail = {
    //                 repeat: Repeat,
    //                 interval: Interval,
    //                 timespan: timespan !== undefined ? timespan.name : "",
    //                 screen: "IDS_MDL_SHEETORDER",
    //                 autocreatedate: autocreatedate,
    //                 ismultitenant: isMultitenant
    //               }

    passObjDet.lsActiveWidgets = {
      screenname: "Sheet_Order",
      activityType: "Insert",
      userId: sessionStorage.User,
    };
    passObjDet.keyword = selectedkeyword;
    // if (viewoption === 3) {
    //   passObjDet.teamcode = teamcode
    // }

    passObjDet.notificationdate = convertUTCDateToLocalDate(new Date());
    passObjDet.sitecode = sessionStorage.Usersite;

    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_SHEETORDERS",
      "IDS_TSK_REGISTER"
    );

    // let ordersuccess = false;
    // if (response.selectWflowData !== undefined) {
    //   ordersuccess = true;
    // }

    passObjDet.sitecode = sessionStorage.Usersite;
    passObjDet.isDefault = orderdefaultcheck();

    if (Audit) {
      ($("#auditTrailModalsheetview") as any).modal("show");
      passObjDet.objmanualaudit = Manualauditobject(
        "registered",
        "Sheet Orders"
      );
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/Instrument/InsertELNOrder",
        AuditObject: passObjDet,
        AuditPassfunction: oninsertordersuccess.bind(this, selectedfolder),
        AuditFailfunction: oninsertorderfailure.bind(this),
      });
    } else {
      Servicecalls(
        "" + ELNurl + "/Instrument/InsertELNOrder",
        passObjDet,
        oninsertordersuccess.bind(this, selectedfolder),
        oninsertorderfailure.bind(this)
      );
    }
  };
  const oninsertordersuccess = (selectedfolder: any, response: any) => {
    //for refresh issue
    let dup_response = { ...response };
    let shortnedres = OrderSequence(dup_response);
    response.batchid = shortnedres.batchid;
    setDuplicateorder(false);
    if (response?.tittle !== undefined && response?.tittle !== null) {
      response.tle = response.tittle;
    }

    ($("#auditTrailModalsheetview") as any).modal("hide");
    console.log(response);
    if (
      response.lsautoregisterorders !== undefined &&
      response.lsautoregisterorders !== null
    ) {
      console.log(response);
      updateTransaction(response);
    }
    if (
      response !== undefined &&
      response.orderdisplaytype !== undefined &&
      response.orderdisplaytype !== null
    ) {
      // let OrdersList = store.getState().OrdersList;
      // if ((OrdersList.length > 0) && (response.filetype === 1 || response.filetype === 2)) {
      //   OrdersList.unshift(response);
      //   store.dispatch(SheetandProtocolOrders(OrdersList));
      // }

      let lsActiveWidgets = {
        screenname: "Sheet_Order",
        activityType: "Insert",
        userId: sessionStorage.User,
        activewidgetsdetailscode: response.batchcode || "",
        Activewidgetsdetails: response.batchid || "",
        sitecode: sessionStorage.Usersite
      };
      Onsaveactivewidgetsdata(lsActiveWidgets);

      let selectedtree =
        selectedfolder !== null ? selectedfolder : selectedTreeItem;

      let orderobject = {
        dateCreated: convertDateFormat(
          convertUTCDateToLocalDate(new Date(response.createdtimestamp)) ||
          null,
          intl
        ),
        dateModified: convertDateFormat(
          convertUTCDateToLocalDate(new Date(response.createdtimestamp)) ||
          null,
          intl
        ),
        dateCompleted:
          response.completedtimestamp !== undefined
            ? convertDateFormat(
              convertUTCDateToLocalDate(
                new Date(response.completedtimestamp)
              ) || null,
              intl
            )
            : null,
        size: 124,
        icon: convertExtensionToIcon(
          response.batchid + ".ord",
          response.orderflag !== undefined && response.orderflag.trim() === "R"
            ? "#54c518"
            : "#e16733"
        ),
        items: [],
        path: `${selectedtree?.path}/${response.batchid + ".ord"}`,
        directorycode: response.batchcode,
        parentdircode:
          response.orderdisplaytype === 3
            ? selectedtree?.directorycode
            : response.orderdisplaytype === 1 &&
              response.lsprojectmaster !== undefined &&
              response.lsprojectmaster !== null &&
              response.testcode !== undefined
              ? parseFloat(
                response.lsprojectmaster.projectcode + "." + response.testcode
              )
              : response.orderdisplaytype === 2 &&
                response.lssamplemaster !== undefined &&
                response.lssamplemaster !== null &&
                response.testcode !== undefined
                ? parseFloat(
                  response.lssamplemaster.samplecode + "." + response.testcode
                )
                : selectedtree?.directorycode,
        directoryname: response.batchid,
        order: response,
        link: generateLink(response.batchcode, "Sheet"),
      };

      // setSelectedTreeItem(selectedfolder);
      if (response?.isclone) {
        props.alert.success(
          props.t("Orders.Protocolorders.IDS_MSG_ELNPROTOCOLORDERCLONESUCCESS", {
            orderid: response.batchid,
            screenname:
              isMultitenant === 2
                ? props.t("Dashboard.IDS_LBL_TASK")
                : props.t("Dashboard.IDS_LBL_ORDER"),
            param: "",
          })
        )
      } else {
        props.alert.success(
          props.t("Orders.Sheetorders.IDS_LBL_ORDERMSG", {
            orderid: response.batchid,
            screenname:
              isMultitenant === 2
                ? props.t("Dashboard.IDS_LBL_TASK")
                : props.t("Dashboard.IDS_LBL_ORDER"),
          })
        );
      }

      setSelectedCDPTreeItem(undefined);
      if (response.assignedto && response.assignedto !== null) {
        if (response.assignedto.usercode === parseInt(sessionStorage.User)) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -18, "MYO");
        } else {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -17, "ASO");
        }
      } else if (
        (response.orderdisplaytype === 1 &&
          response.lsprojectmaster !== undefined &&
          response.lsprojectmaster !== null &&
          (response.directorycode === undefined ||
            response.directorycode1 === null)) ||
        (response.orderdisplaytype === 2 &&
          response.elnmaterial !== undefined &&
          response.elnmaterial !== null &&
          (response.directorycode === undefined ||
            response.directorycode1 === null))
      ) {
        if (response.filetype === 2) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -8, "EPO");
        } else if (response.filetype === 3) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -9, "RPO");
        } else if (response.filetype === 4) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -10, "MPO");
        } else if (response.filetype === 5) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -11, "SPO");
        }
      } else {
        selectedtree = getDirectoryOncodeandfilefor(
          stateData,
          response.directorycode,
          "DR"
        );
        let fromDate: any;
        let toDate: any;
        let returndateobj: any = setdates(
          filterType,
          isFiltered,
          "sheetdaydiff",
          toRange,
          changedtodate
        );
        if (returndateobj !== undefined && filterType !== 1) {
          fromDate = returndateobj.fromRange;
          toDate = returndateobj.toRange;
        } else {
          fromDate = new Date(fromRange);
          fromDate.setHours(0, 0, 0);
          toDate = new Date(fromRange);
          toDate.setHours(23, 59, 59, 999);
        }

        let passObjDet1 = Commonpassobject(
          selectedtree,
          selectedtree,
          fromDate,
          toDate,
          fileType,
          searchCriteriaType,
          orderflag
        );
        if (flitertest.testcode !== -1) {
          passObjDet1.testcode = flitertest.testcode;
        }

        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet1.lsprojectmaster = fliterproject;
        }

        passObjDet1.lstworkflow = workflow;
        passObjDet1.lsusersteam = Getteamfromsession();
        passObjDet1.sitemaster = { sitecode: sessionStorage.Usersite };
        passObjDet1.iscancelled = iscancelled;
        passObjDet1.lstworkflow = workflow;

        Servicecalls("" + ELNurl + "/Instrument/Getordersondirectory", passObjDet1,
          (response: any, data: any) => { ongetorderssuccess(response, data, orderobject) }, ongetordersfailure
        );
      }

      if (response?.isclone) {
        const { batchcode, versionno, sequenceid } = dublicateorderitem;
        let passObjDet1 = {
          objsilentaudit: Silentauditobject(
            "cloned",
            "Protocol Orders",
            props.t("Orders.Protocolorders.IDS_AUDIT_CLONEPROTOCOLORDERS", {
              oldorderid: batchcode,
              version: versionno,
              screenName: "Protocol Order",
              neworderid: response.batchid,
              user: store.getState().Loggeduser.username,
            })
          ),
        };
        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet1,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );

        const clonedOrderCode = response.sequenceid;
        const currentUser = sessionStorage.User;
        const currentUsername = sessionStorage.Username;
        const passObjDet: any[] = [0, 1].map((index) => {
          const isOriginal = index === 0;
          return {
            batchcode: isOriginal ? batchcode : response?.batchcode,
            createby: { usercode: currentUser },
            stepstartdate: GetutcDate(new Date()),
            action: props.t(isOriginal ? "Templates.Protocoltemplates.IDS_MSG_SHEETORDERCLONEORIGINAL" : "Templates.Protocoltemplates.IDS_MSG_ORDERCLONE", {
              Originalbatchid: sequenceid,
              batchid1: clonedOrderCode,
              user: currentUsername,
              version: versionno || 1
            }),
            viewoption: 6,
          };
        });
        Servicecalls(
          "" + ELNurl + "/protocol/updateTransactionHistoryList",
          passObjDet,
          ongetordersfailure,
          ongetordersfailure
        );

      } else {
        if (
          response.assignedto !== undefined &&
          response.assignedto.userstatus === "Locked"
        ) {
          let passObjDet1 = {
            objsilentaudit: Silentauditobject(
              "assign",
              "Sheet Orders",
              props.t("Orders.Sheetorders.IDS_AUDIT_ASSIGNTOUSER", {
                // screen: orderType(response.filetype),
                user1: response.batchid,
                user2: response.lockedusername,
              })
            ),
          };
          Servicecalls(
            "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet1,
            onAuditValidateError.bind(this),
            onAuditValidateFailure.bind(this)
          );
        } else {
          let passObjDet = {
            objsilentaudit: Silentauditobject(
              "registered",
              "Sheet Orders",
              props.t("Orders.Sheetorders.IDS_AUDIT_INSERTORDERS", {
                orderid: response.batchid,
                user: store.getState().Loggeduser.username,
                screenName: orderType(response.filetype),
                visible:
                  response.viewoption === 1
                    ? "Site"
                    : response.viewoption === 2
                      ? "Only me"
                      : "Project Team",
              })
            ),
          };
          Servicecalls(
            "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            onAuditValidateError.bind(this),
            onAuditValidateFailure.bind(this)
          );
        }
      }


      // else if (response.noworkflow === false) {
      //   passObjDet = {
      //     objsilentaudit: Silentauditobject(
      //       "assign",
      //       "Sheet Orders",
      //       props.t("Orders.Sheetorders.IDS_AUDIT_WORKFLOWASSIGNTOUSER", {
      //         screen: orderType(response.filetype),
      //         user1: response.batchid,
      //         user2: store.getState().Loggeduser.username,
      //       })
      //     ),
      //   };
      //   Servicecalls(
      //     "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      //     passObjDet,
      //     onAuditValidateError.bind(this),
      //     onAuditValidateFailure.bind(this)
      //   );
      // }

      // if (
      //   response.directorycode !== undefined &&
      //   response.orderflag.trim() === "N"
      // ) {
      //   response.canuserprocess = true;
      // } else
      if (
        response.lsprojectmaster === undefined &&
        response.viewoption !== undefined &&
        response.viewoption === 1
      ) {
        response.canuserprocess = true;
      } else if (
        (response.lsprojectmaster === undefined &&
          response.viewoption !== undefined &&
          response.viewoption === 2 &&
          response.lsuserMaster?.usercode === parseInt(sessionStorage.User)) ||
        response.viewoption === 3
      ) {
        response.canuserprocess = true;
      }

      if (response.assignedto && response.assignedto !== null) {
        if (response.assignedto.usercode === parseInt(sessionStorage.User)) { //MYO
          if (response.sentforapprovel !== undefined) {
            if (response.approvelaccept === undefined) {
              response.canuserprocess = false;
            } else if (response.approvelaccept === "2") {
              response.canuserprocess = true;
            } else {
              response.canuserprocess = false;
            }
          } else {
            response.canuserprocess = true;
          }
        } else { //ASO
          if (response.sentforapprovel !== undefined) {
            if ((response.sentforapprovel && response.approvelaccept === undefined) || (response.sentforapprovel && response.approvelaccept !== "3")) {
              response.canuserprocess = true;
            } else {
              response.canuserprocess = false;
            }
          } else {
            response.canuserprocess = false;
          }
        }
      }




      let newdata = addFolderonObj(stateData, selectedtree, intl, orderobject);
      newdata = addprojectinsidetask(
        newdata,
        null,
        intl,
        response,
        "PR",
        screen
      );

      //   if (selectedtree && selectedtree.parentdircode && selectedtree.parentdircode>0) {
      //    selectedtree.dateModified  = convertDateFormat(convertUTCDateToLocalDate(new Date()),intl);
      //     selectedtree.Modified_By = sessionStorage.Username;
      //  }

      if (selectedtree?.directorycode && selectedtree?.filefor) {
        setSelectedTreeItem(
          getDirectoryOncodeandfilefor(
            newdata,
            selectedtree?.directorycode,
            selectedtree?.filefor
          )
        );
        setSelectedTreeItemDuplicate(
          getDirectoryOncodeandfilefor(
            newdata,
            selectedtree?.directorycode,
            selectedtree?.filefor
          )
        );
      }
      if (
        selectedTreeItem?.filefor === "LCO" ||
        selectedTreeItem?.filefor === "ECO" ||
        selectedTreeItem?.filefor === "RCO" ||
        selectedTreeItem?.filefor === "MCO" ||
        selectedTreeItem?.filefor === "SCO"
      ) {
        columns.map((col) => {
          if (col.field === "dateCompleted") {
            col.show = false;
          }
          return col;
        });
      }
      let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(newdata)));
      /*** changed for currentitem date issue */
      let Statevalues_update: DataModel[] = expandPathInHierarchy(
        Allstate_Data,
        selectedtree?.path,
        newdata
      );
      setStateData(Statevalues_update);
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      // setStateData(newdata);
      setDetailsData(orderobject);
      setSelectedGridItem(orderobject);
      setGridSelection({
        [`${selectedtree?.path}/${response.batchid + ".ord"}`]: true,
      });
      console.log(gridSelection);

      settoRange(new Date());
      // setPullcontents(true);
      setTimeout(() => {
        const elements = document.getElementsByClassName(
          "k-in k-state-selected"
        );
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 1000);

      props.props.alert.success(
        props.t("Orders.Sheetorders.IDS_MSG_ORDER", { param: "" })
      );
    }
  };

  const updateTransaction = (response: any) => {
    let passobj = {
      batchcode: response.batchcode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Orders.Sheetorders.IDS_AUDIT_AUTOREGISTERSTART", {
        // screen: orderType(stateOrder.Assigntestfor),
        batchid: response.batchid,
        // user: store.getState().Loggeduser.username,
      }),
      viewoption: 2,
    };

    Servicecalls(
      "" + ELNurl + "/protocol/updatetransactionhistory",
      passobj,
      (res: any) => { },
      (res: any) => { }
    );
  };
  const oninsertorderfailure = (response: any) => { };

  const handleSearchChange = (event: InputChangeEvent) => {
    // let eventPath = "";
    if (event.value !== undefined && event.value !== "") {
      // if (selectedTreeItem?.items) {
      //   const curPath = getFolderPath(selectedTreeItem.items[0].path);
      //   eventPath = `${curPath}/${event.value}`;
      // } else if (stateData && stateData.length > 0) {
      //   const curPath = getFolderPath(stateData[0].path);
      //   eventPath = `${curPath}/${event.value}`;
      // }

      setStateContentData({
        ...stateContentData,
        filter: {
          logic: initialLogic,
          filters: [
            { field: "path", operator: "contains", value: event.value },
          ],
        },
      });
      setSearchValue(event.value);
    } else {
      setStateContentData({
        sort: initialSort,
        filter: {
          logic: initialLogic,
          filters: [{ field: "path", operator: "contains", value: "" }],
        },
      });
      setSearchValue("");
    }
  };

  const handleSwitchChange = (event: AppSwitchChangeEvent) => {
    const newPanes: PanesModel[] = panes.slice(0);
    if (event.value) {
      newPanes[2].size = "30%";
      setPanes(newPanes);
    } else {
      newPanes[2].size = "0%";
      setPanes(newPanes);
    }
  };

  const handleViewChange = (event: ViewChangeEvent) => {
    if (event.viewValue.gridView) {
      setContentView("grid");
      localStorage.setItem("elnsheetorderview", "grid");
    }
    if (event.viewValue.listView) {
      setContentView("list");
      localStorage.setItem("elnsheetorderview", "list");
    }
  };

  // const handleFileChange = (event: UploadAddEvent) => {
  const handleFileChange = (event: any) => {
    let files = event.files;
    let size = 200 * 1024 * 1024;
    // let err = [];
    if (files.length !== 0) {
      for (var x = 0; x < files.length; x++) {
        if (files[x].size > size && isMultitenant === 2) {
          // err[x] = props.alert.error("Maximum upload size limit reached. Upgrade to upload files larger than 200 MB.");
          setisupgradeopen(true);
        } else {
          if (
            event &&
            event.event &&
            event.event.affectedFiles &&
            event.event.affectedFiles.length > 0 &&
            event.event.affectedFiles[0].status === 4 &&
            event.event.response &&
            event.event.response.status === 200 &&
            event.event.response.response &&
            event.event.response.response.res &&
            !event.event.response.response.res.status &&
            event.event.response.response.uid
          ) {
            let uid = event.event.response.response.uid;
            if (event.files) {
              let files = event.files.filter((file: any) => file.uid !== uid);
              setFiles(files);
            }

            props.alert.error(
              props.t(
                event.event.affectedFiles[0].name +
                " file already exists in the directory"
              )
            );
          } else {
            if (event.files) {
              setFiles(event.files);
            }
          }
        }
      }
    } else {
      setFiles([]);
    }
  };

  const handleAddFileChange = (event: UploadAddEvent) => {
    if (
      event &&
      event.event &&
      event.event.affectedFiles &&
      event.event.affectedFiles.length > 0 &&
      event.event.affectedFiles[0].status === 3 &&
      event.event.affectedFiles[0].progress === 0
    ) {
      if (event.files) {
        setAddedfiles(event.files);
      }
      Servicecalls(
        "" + ELNurl + "/Instrument/validatefileexistonfolder",
        {
          directorycode: selectedTreeItem?.directorycode,
          filefor: selectedTreeItem?.filefor,
          filename: event.event.affectedFiles[0].name,
        },
        onvalidateSuccess.bind(this),
        onvalidateFailure.bind(this)
      );
    }
  };

  const onvalidateSuccess = (response: any) => {
    if (response.status) {
      if (addedfiles) {
        setFiles(addedfiles);
      }
    }
  };

  const onvalidateFailure = (response: any) => { };

  const handleClearFileList = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (event) {
      setFiles([]);
    }
  };

  const handleUploadComplete = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ishomeupload: boolean,
    click: string
  ) => {
    if (files && files.length > 0) {
      let fileduids = files.map(function (file) {
        return file["uid"];
      });

      if (!ishomeupload) {
        if (click !== "close") {
          let Audit = AuditTrailValidation(
            "IDS_MDL_ORDERS",
            "IDS_SCN_SHEETORDERS",
            "IDS_TSK_UPLOAD"
          );
          let passobject: any = {};
          passobject = {
            objmanualaudit: Manualauditobject("upload", "Sheet Orders"),
            fileduids: fileduids,
          };
          if (Audit) {
            ($("#auditTrailModalsheetview") as any).modal("show");
            setAuditservicecall({
              AuditUrl: "" + ELNurl + "/Instrument/Getaddedfilesforfolder",
              AuditObject: passobject,
              AuditPassfunction: onaddSuccess.bind(this),
              AuditFailfunction: onaddFailure.bind(this),
              AuditCancelfunction: Auditcancel.bind(this),
              Auditfilefunction: true,
            });
          } else {
            if (click === "close") {
              Auditcancel();
            } else {
              Servicecalls(
                "" + ELNurl + "/Instrument/Getaddedfilesforfolder",
                fileduids,
                onaddSuccess.bind(this),
                onaddFailure.bind(this)
              );
            }
          }
        } else {
          Auditcancel();
        }
      } else if (ishomeupload) {
        setFiles([]);
      }
    }
  };

  const onaddSuccess = (response: any) => {
    props.alert.success(
      props.t("Orders.Sheetorders.IDS_LBL_FILEUPLOADSUCCESS", { param: "" })
    );
    ($("#auditTrailModalsheetview") as any).modal("hide");
    let passObjDet;
    if (response.length > 0) {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "upload",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_FOLDERFILEUPLOAD", {
            file: response[0].filename,
            user: store.getState().Loggeduser.username,
          })
        ),
      };

      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    setAuditservicecall({
      AuditUrl: "",
      AuditObject: {},
      AuditPassfunction: undefined,
      AuditFailfunction: undefined,
      AuditCancelfunction: undefined,
      Auditfilefunction: false,
    });

    const newData: DataModel | any = addDataItem(
      stateData,
      selectedCDPTreeItem ? selectedCDPTreeItem : selectedTreeItem,
      response,
      intl
    );

    if (selectedCDPTreeItem) {
      setSelectedTreeItem(selectedCDPTreeItem);
      ChoosePath(newData);
      // setStateCDFData(newData?.filter((item: any) => item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"));
      getordersforfolders(
        selectedCDPTreeItem,
        selectedCDPTreeItem,
        fromRange,
        toRange,
        fileType,
        searchCriteriaType,
        orderflag,
        flitertest,
        fliterproject,
        iscancelled,
        stateData
      );
    } else {
      setStateData(newData);
    }
    setFiles([]);
  };

  const onaddFailure = (response: any) => {
    ($("#auditTrailModalsheetview") as any).modal("hide");
    setFiles([]);
  };

  const handleBreadcrumbSelection = (event: any) => {
    setSelectedGridItem({});
    setGridSelection({});

    if (!event.nativeEvent.keyCode) {
      let returndateobj = setdates(
        filterType,
        isFiltered,
        "sheetdaydiff",
        toRange,
        changedtodate
      );
      //  let fromRange = returndateobj.fromRange;
      if (returndateobj !== undefined) {
        setfromRange(returndateobj.fromRange);
        settoRange(returndateobj.toRange);
      }
      if (event.target !== undefined) {
        sateorderdummy =
          stateData !== undefined && stateData !== null && stateData.length > 0
            ? stateData
            : initialorders !== null
              ? initialorders
              : [];
      }
      const newItem = searchTreeItemonpath(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
      setSelectedTreeItemDuplicate(newItem);
      if (newItem === undefined) {
        let passObjDet1: any = {
          filetype: fileType,
          directorycode: -1,
          objuser: {
            fromdate: GetutcDate(new Date(returndateobj.fromRange)),
            todate: GetutcDate(new Date(returndateobj.toRange)),
          },
          filefor: "DR",
          createdby: store.getState().Loggeduser,
          lsuserMaster:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: localStorage.getItem("User"),
                username: localStorage.getItem("Username"),
                unifieduserid: localStorage.getItem("unifieduserid"),
              },
        };
        passObjDet1.lstuserMaster = Getteamusersfromsession();
        passObjDet1.lsusersteam = Getteamfromsession();
        passObjDet1.sitemaster = { sitecode: sessionStorage.Usersite };
        passObjDet1.lstworkflow = workflow;
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/Instrument/Getordersondirectory",
          ServiceHeaderobject: passObjDet1,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetordersuccesshome,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
    }
    if (event.nativeEvent.keyCode === 13) {
      const newItem = searchTreeItemonpath(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
      setSelectedTreeItemDuplicate(newItem);
    }
  };

  const ongetfilessuccesshome = (response: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      // setIsLoader(true);
      let directorycode = passeddata.directorycode;
      let itemdata = [];
      if (response !== undefined && response.length > 0) {
        itemdata = response;
      }
      let folderdata = sateorderdummy;

      let newdata = replaceallordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );
      newdata = addorderitemsforhomebutton(
        newdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );
      newdata = addfileitemsforhomebutton(
        newdata,
        directorycode,
        intl,
        itemdata,
        passeddata.filefor,
        screen
      );

      setStateData(newdata);
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      setsheetdatainitservice(false);
      setsheetdatainit(undefined);
      setIsLoader(false);
      sateorderdummy = [];
    } else {
      setIsLoader(false);
    }
    setStateContentData({
      sort: [
        {
          field: "",
          dir: "desc",
        },
      ],
      filter: {
        logic: initialLogic,
        filters: [{ field: "path", operator: "contains", value: "" }],
      },
    });
  };

  const ongetordersuccesshome = (response: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      response.forEach((item: any) => {
        if (item.orderflag.trim() === "N" && item.filetype === 0) {
          item.canuserprocess = true;
        } else if (
          item.lsprojectmaster === undefined &&
          item.viewoption !== undefined &&
          item.viewoption === 1
        ) {
          item.canuserprocess = true;
        } else if (
          (item.lsprojectmaster === undefined &&
            item.viewoption !== undefined &&
            response.viewoption === 2 &&
            item.lsuserMaster?.usercode === parseInt(sessionStorage.User)) ||
          response.viewoption === 3
        ) {
          item.canuserprocess = true;
        }
        if (item?.tittle !== undefined && item?.tittle !== null) {
          item.tle = item.tittle;
        }
      });
      orderdataforfolder = response;
      setServicecall({
        ServiceToUrl: "" + ELNurl + "/Instrument/Getfilesforfolder",
        ServiceHeaderobject: {
          directorycode: -1,
          filefor: "DR",
          contentsearchtype: searchCriteriaType.value,
          contentsearch: SearchContentText.SearchContentText,
          ismultitenant: isMultitenant,
          orderflag:
            orderflag !== undefined && orderflag !== -1 && orderflag === 1
              ? "N"
              : "R",
          approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",

          fromdate: GetutcDate(new Date(passeddata.objuser.fromdate)),
          todate: GetutcDate(new Date(passeddata.objuser.todate)),
          lssitemaster: {
            sitecode: sessionStorage.Usersite,
            sitename: sessionStorage.Usersitename,
          },
        },

        ServiceMethodType: "POST",
        ServcieonSuccess: ongetfilessuccesshome,
        ServcieonFailure: ongetfilesfailure,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
      });
    }
  };

  const ondeletedirectorysuccess = (response: any, directories: any) => {
    ($("#auditTrailModalsheetview") as any).modal("hide");
    props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FOLDERDELETE"));
    console.log(directories);
    if (
      deleteitem === undefined ||
      deleteitem === null ||
      Object.keys(deleteitem).length <= 0 ||
      response === undefined ||
      response === null ||
      response.length <= 0
    )
      return;

    let deletedfolderindex = response.findIndex(
      (obj: { parentdircode: number }) => obj.parentdircode === -2
    );

    if (deletedfolderindex > -1) {
      const curItem = deleteitem[0];
      const movetodirectory = getDirectoryOncode(
        stateData,
        response[deletedfolderindex].dircodetomove
        //=== undefined ? response[deletedfolderindex].dircodetomove = -1 : response[deletedfolderindex].dircodetomove
      );

      let updatedData = removeDataItem(stateData, curItem);
      let statedataclone = stateData;

      for (let ind = 0; ind < response.length; ind++) {
        if (response[ind].parentdircode !== -2) {
          response[ind].icon = convertExtensionToIcon(
            response[ind].directoryname,
            null
          );

          let movedirectory = getDirectoryOncode(
            statedataclone,
            response[ind].parentdircode
          );
          let directorytomove = getDirectoryOncode(
            statedataclone,
            response[ind].directorycode
          );
          directorytomove.path = movedirectory.path;
          updatedData = addFolderonObj(
            updatedData,
            movedirectory,
            intl,
            directorytomove
          );
        } else {
          // updatedData = removeDataItem(updatedData, response[ind]);
        }
      }
      statedataclone = updatedData;
      setSelectedTreeItem(searchTreeItem(updatedData, movetodirectory));
      setSelectedTreeItemDuplicate(
        searchTreeItem(updatedData, movetodirectory)
      );
      setStateData(updatedData);
      // setSelectedFolders([]);
      sateorderdummy = updatedData;
      ChoosePath(updatedData);
      setDeleteDialogView(false);
      setIsMultiSelectFolders(false);
      let id = { id: "Sheet", nativeEvent: { try: "try" } };
      handleBreadcrumbSelection(id);
      // setPullcontents(true);
    }
  };

  const ondeletedirectoryfaliure = (response: any) => { };

  const ondeletemultidirectorysuccess = (response: any) => {
    if (
      deleteitem === undefined ||
      deleteitem === null ||
      Object.keys(deleteitem).length <= 0 ||
      response === undefined ||
      response === null ||
      response.length <= 0
    )
      return;

    let deletedfolderindex: any = [];
    response.map((resitem: any, index: any) => {
      if (resitem.parentdircode === -2) {
        deletedfolderindex.push(index);
      }

      return resitem;
    });

    // if (deletedfolderindex > -1) {
    let updatedData: any = [];

    let statedataclone: any = [];
    let movetodirectory: any = {};
    let newlyupdateddata: any = [];

    deletedfolderindex.forEach((folderitemindex: any) => {
      deleteitem.forEach((item: any) => {
        // const curItem = deleteitem;
        const curItem = item;
        movetodirectory = getDirectoryOncode(
          stateData,
          response[folderitemindex].dircodetomove
        );

        if (newlyupdateddata.length === 0) {
          updatedData = removeDataItem(stateData, curItem);
          statedataclone = stateData;
        } else {
          updatedData = removeDataItem(newlyupdateddata, curItem);
        }

        //  for (let ind = 0; ind < response.length; ind++) {
        if (response[folderitemindex].parentdircode !== -2) {
          response[folderitemindex].icon = convertExtensionToIcon(
            response[folderitemindex].directoryname,
            null
          );
          response[folderitemindex].dateCreated = convertDateFormat(
            convertUTCDateToLocalDate(
              new Date(response[folderitemindex].dateCreated)
            ),
            intl
          );
          response[folderitemindex].dateModified = convertDateFormat(
            convertUTCDateToLocalDate(
              new Date(response[folderitemindex].dateModified)
            ),
            intl
          );
          let movedirectory = getDirectoryOncode(
            statedataclone,
            response[folderitemindex].parentdircode
          );
          let directorytomove = getDirectoryOncode(
            statedataclone,
            response[folderitemindex].directorycode
          );
          directorytomove.path = movedirectory.path;
          updatedData = addFolderonObj(
            updatedData,
            movedirectory,
            intl,
            directorytomove
          );
          statedataclone = updatedData;
        } else {
          //  updatedData = removeDataItem(updatedData, response[ind]);
          newlyupdateddata = updatedData;
        }
        //   }
      });
    });
    setSelectedTreeItem(searchTreeItem(updatedData, movetodirectory));
    // setSelectedTreeItemDuplicate(searchTreeItem(updatedData, movetodirectory));
    // setStateData(updatedData);
    sateorderdummy = updatedData;
    // setSelectedFolders([]);
    setDeleteDialogView(false);
    setIsMultiSelectFolders(false);
    // setPullcontents(true);
    let id = { id: "Sheet", nativeEvent: { try: "try" } };
    handleBreadcrumbSelection(id);

    props.alert.success(props.t("Orders.Sheetorders.IDS_MULTIFOLDERDELETE"));

    //  }
  };
  const handleDialogClick = (event: any) => {
    console.log("Dialog Clicked:", event);
    if (event.type === "cancel add") {
      SelectedCDFvalue = 4;
      setSelectedCDPTreeItem(undefined);

      let returndata = stateCDFData.map((item) => {
        const currentItem = { ...item };
        currentItem.expanded = false;
        currentItem.selected = false;
        return currentItem;
      });
      setStateCDFData(returndata);
      setAddDialogVisible(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_REQCANCELNEWFOLDER", {
            user: sessionStorage.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel rename") {
      setEditDialogView(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_REQCANCELRENAME", {
            user: props.sessionvalues.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel delete") {
      setDeleteDialogView(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_REQCANCELDELETE", {
            user: props.sessionvalues.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel") {
      setMoveDialogView(false);
    }

    const curItem: DataModel | null = Object.keys(selectedGridItem).length
      ? selectedGridItem
      : SelectedCDFvalue === 5 && selectedCDPTreeItem !== undefined
        ? selectedCDPTreeItem
        : selectedTreeItem;
    if (!curItem) {
      return;
    }

    if (
      event.type === "delete" &&
      isMultiSelectFolders === false &&
      isMultiSelectFile === false
    ) {
      let movedircode = event.directoryToMove;

      let movestatus = event.movestatus;
      // let res = !isNaN(+moveparent)
      // if(res){
      //   moveparent = moveparent === 1 ? false:true;
      // }

      if (
        event.dynamicfolders.length === 0 &&
        movestatus === 0 &&
        event.directoryToDelete.parentdircode === -1
      ) {
        let directorytomove = getDirectoryOncode(stateData, movedircode);

        let data = getAllFolderFromItem(
          [event.directoryToDelete],
          event.directoryToDelete,
          movedircode,
          event.keepfolderstructure,
          directorytomove
        );
        deleteitem = [curItem];
        let directories = data.directries;

        if (directories[0].dircodetomove === undefined) {
          directories[0].dircodetomove = -1;
        }

        if (auditRights.IDS_TSK_FOLDERDEL) {
          directories[0].objmanualaudit = Manualauditobject(
            "delete",
            "Sheet Orders"
          );
          ($("#auditTrailModalsheetview") as any).modal("show");
          setAuditservicecall({
            AuditUrl: "" + ELNurl + "/Instrument/Deletedirectories",
            AuditObject: directories,
            AuditPassfunction: ondeletedirectorysuccess.bind(this, directories),
            AuditFailfunction: ondeletedirectoryfaliure,
          });
        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/Deletedirectories",
            directories,
            ondeletedirectorysuccess.bind(this, directories),
            ondeletedirectoryfaliure
          );
        }



        let passObjDet = {
          objsilentaudit: Silentauditobject(
            "delete",
            "Sheet Orders",
            props.t("Orders.Sheetorders.IDS_AUDIT_REQFOLDERDELETED", {
              user: props.sessionvalues.username,
              folder: curItem.directoryname,
            })
          ),
        };
        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );
      } else if (
        event.dynamicfolders.length !== 0 &&
        movestatus === 1 &&
        movedircode === -1
      ) {
        //  && moveparent === false){
        props.alert.error(props.t("select folder to move"));
      } else if (
        (event.dynamicfolders.length !== 0 && movestatus === 0) ||
        (event.dynamicfolders.length !== 0 &&
          movestatus === 1 &&
          movedircode !== -1)
      ) {
        // if (event.selectedItem.parentdircode === -1 && movestatus === 0) {
        //   movedircode = -1;
        // } else if (movestatus === 1 && event.selectedItem.parentdircode === -1) {
        //   movedircode = movedircode;
        // } else if (event.selectedItem.parentdircode !== -1 && movestatus === 0) {
        //   movedircode = event.selectedItem.parentdircode;
        // } else {
        //   movedircode = movedircode;
        // }

        let directorytomove = getDirectoryOncode(stateData, movedircode);

        let data = getAllFolderFromItem(
          [event.directoryToDelete],
          event.directoryToDelete,
          movedircode,
          event.keepfolderstructure,
          directorytomove
        );
        deleteitem = [curItem];
        let directories = data.directries;

        if (event.selectedItem.parentdircode === -1 && movestatus === 0) {
          directories[0].dircodetomove = -1;
        } else if (
          movestatus === 1 &&
          event.selectedItem.parentdircode === -1
        ) {
          directories[0].dircodetomove = movedircode;
        } else if (
          event.selectedItem.parentdircode !== -1 &&
          movestatus === 0
        ) {
          directories[0].dircodetomove = event.selectedItem.parentdircode;
        } else {
          directories[0].dircodetomove = movedircode;
        }
        let passobj = JSON.parse(JSON.stringify(directories));
        if (directories.length > 0) {
          // directories = directories.map((items: any) => {
          //   items.dateCreated = undefined;
          //   items.dateModified = undefined;
          //   return items;
          // });
        }

        if (auditRights.IDS_TSK_FOLDERDEL) {
          directories[0].objmanualaudit = Manualauditobject(
            "delete",
            "Sheet Orders"
          );
          ($("#auditTrailModalsheetview") as any).modal("show");
          setAuditservicecall({
            AuditUrl: "" + ELNurl + "/Instrument/Deletedirectories",
            AuditObject: directories,
            AuditPassfunction: ondeletedirectorysuccess.bind(this, passobj),
            AuditFailfunction: ondeletedirectoryfaliure,
          });
        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/Deletedirectories",
            directories,
            ondeletedirectorysuccess.bind(this, passobj),
            ondeletedirectoryfaliure
          );
        }


        let passObjDet = {
          objsilentaudit: Silentauditobject(
            "delete",
            "Sheet Orders",
            props.t("Orders.Sheetorders.IDS_AUDIT_REQFOLDERDELETED", {
              user: props.sessionvalues.username,
              folder: curItem.directoryname,
            })
          ),
        };
        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );
      }
    }

    if (
      event.type === "delete" &&
      isMultiSelectFolders === true &&
      isMultiSelectFile === false
    ) {
      let movedircode = event.directoryToMove;
      let directorytomove = getDirectoryOncode(stateData, movedircode);
      let data = getAllFolderFromMultiItem(
        // [event.directoryToDelete],
        // event.directoryToDelete,
        selectedFolders,
        selectedFolders,
        movedircode,
        event.keepfolderstructure,
        directorytomove
      );
      deleteitem = selectedFolders;
      let directories = data.directries;
      directories = directories.map((items: any) => {
        if (event.selectedItem.parentdircode !== -1 && movedircode === -1) {
          items.dircodetomove = event.selectedItem.parentdircode;
        } else {
          items.dircodetomove = movedircode;
        }
        items.modifiedby = { usercode: sessionStorage.getItem("User") }
        return items;
      })

      if (auditRights.IDS_TSK_FOLDERDEL) {
        directories[0].objmanualaudit = Manualauditobject("delete", "Sheet Orders");

        ($("#auditTrailModalsheetview") as any).modal("show");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/Deletemultidirectories",
          AuditObject: directories,
          AuditPassfunction: ondeletemultidirectorysuccess,
          AuditFailfunction: ondeletedirectoryfaliure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/Instrument/Deletemultidirectories",
          directories,
          ondeletemultidirectorysuccess,
          ondeletedirectoryfaliure
        );
      }
    }

    if (event.type === "delete" && isMultiSelectFile === true) {
      console.log(selectedFiles);
      console.log(AllSelectedFiles);
      let filedeleteurl =
        selectedTreeItem !== undefined && selectedTreeItem !== null
          ? ELNurl +
          "/Instrument/deletemultifilesforfolder/" +
          selectedTreeItem.directorycode +
          "/" +
          selectedTreeItem.filefor +
          "/" +
          sessionStorage.getItem("tenantid") +
          "/" +
          isMultitenant +
          "/" +
          sessionStorage.getItem("User") +
          "/" +
          sessionStorage.getItem("Usersite") +
          "/" +
          new Date() +
          "/" +
          fileviewfor
          : ELNurl +
          "/Instrument/deletemultifilesforfolder/" +
          -1 +
          "/" +
          "DR" +
          "/" +
          sessionStorage.getItem("tenantid") +
          "/" +
          isMultitenant +
          "/" +
          sessionStorage.getItem("User") +
          "/" +
          sessionStorage.getItem("Usersite") +
          "/" +
          new Date() +
          "/" +
          fileviewfor;

      console.log(stateData);
      setDetailsData(null);
      setServicecall({
        ServiceToUrl: filedeleteurl,
        ServiceHeaderobject:
          selectedFiles.length === 0
            ? AllSelectedFiles !== undefined
              ? AllSelectedFiles
              : selectedFiles
            : selectedFiles,
        ServiceMethodType: "POST",
        ServcieonSuccess: ondeletemultifileSuccess,
        ServcieonFailure: ondeletefileFailure,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
        ServcieProcessbar: true,
      });
    }

    if (event.type === "rename") {
      console.log("Renaming Folder:", event.value);
      const folderPath = getFolderPath(event.path);
      const newPath = `${folderPath}/${event.value}`;
      let currentItem = { ...curItem };
      currentItem.path = newPath;
      const existingItem = validateTreeItem(stateData, currentItem);
      if (!existingItem) {
        const updatedData = editDataItem(stateData, curItem, newPath, intl);
        setSelectedTreeItem(searchTreeItem(updatedData, selectedTreeItem));
        setSelectedTreeItemDuplicate(
          searchTreeItem(updatedData, selectedTreeItem)
        );
        setStateData(updatedData);
        //  }
        let directory = {
          directoryname: event.value,
          directorycode: curItem.directorycode,
          parentdircode: curItem.parentdircode,
          path: newPath,
          modifiedby: {
            usercode: Number(sessionStorage.User),
            username: sessionStorage.Username
          },
          dateModified: new Date(),
        };
        Servicecalls(
          "" + ELNurl + "/Instrument/Movedirectory",
          directory,
          (response: any) => {
            let passObjDet = {
              objsilentaudit: Silentauditobject(
                "update",
                "Sheet Orders",
                props.t("Orders.Sheetorders.IDS_AUDIT_REQCHANGEFOLDERNAME", {
                  user: props.sessionvalues.username,
                  from: curItem.directoryname,
                  to: event.value,
                })
              ),
            };
            Servicecalls(
              "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
              passObjDet,
              onAuditValidateError.bind(this),
              onAuditValidateFailure.bind(this)
            );
            props.alert.success(
              props.t("Orders.Sheetorders.IDS_MSG_FOLDERRENAME")
            );

            let directorycode = response.directorycode;
            let selecteditem = getDirectoryOncode(stateData, directorycode);
            let selectedfolder = getDirectoryOncode(stateData, response.parentdircode);
            selecteditem.directoryname = response.directoryname;
            selecteditem.dateModified = convertDateFormat(
              convertUTCDateToLocalDate(new Date(response.dateModified)),
              intl
            );
            selecteditem.Modified_By = response?.modifiedby?.username ?? sessionStorage.Username;

            // let newData = removeItem(stateData, selecteditem);
            // let basePath;

            // if (selectedfolder && Object.keys(selectedfolder).length !== 0) {
            //   basePath = `${selectedfolder.path}`;
            //   newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
            // } else {
            //   basePath = selecteditem.path.substring(0, selecteditem.path.lastIndexOf("/"));
            //   newData = addFolderonObj(newData, null, intl, selecteditem);
            // }
            let basePath;
            if (selectedfolder && Object.keys(selectedfolder).length !== 0) {
              basePath = `${selectedfolder.path}`;
            } else {
              basePath = selecteditem.path.substring(0, selecteditem.path.lastIndexOf("/"));
            }
            let newData = replaceItem(stateData, selecteditem, basePath);

            selecteditem.path = `${basePath}/${selecteditem.directoryname}`;
            const newTreeItem = searchTreeItem(newData, selecteditem);
            setSelectedTreeItem(newTreeItem);
            setSelectedTreeItemDuplicate(newTreeItem);
            setSelectedGridItem(selecteditem);
            setDetailsData(selecteditem);
            setStateData(newData);

          },
          (response: any) => { }
        );
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST"));
      }
      setEditDialogView(false);
    }

    if (event.type === "add" || event.type === "save") {
      setAddDialogVisible(false);
      handleNewFolderClick(event);
    }
  };

  const onMoveItemSuccess = (response: any, event: any) => {
    let directorycode = response.directorycode;
    let directoryname = response.directoryname;
    let selecteditem =
      response.batchcode !== undefined
        ? getDirectoryOnName(stateData, directoryname)
        : getDirectoryOncode(stateData, directorycode);
    let selectedfolder = selectedTreeItem;
    let SelectedFolderCd = selectedCDPTreeItem;
    selectedfolder =
      response.batchcode !== undefined
        ? getDirectoryOncode(stateData, directorycode)
        : getDirectoryOncode(stateData, response.parentdircode);

    SelectedFolderCd = response.batchcode !== undefined
      ? getDirectoryOncode(stateCDFData, directorycode)
      : getDirectoryOncode(stateCDFData, response.parentdircode);

    selecteditem.directoryname = response.directoryname;
    let newData = removeItem(stateData, selecteditem);
    let stateCDFDatanew = removeItem(stateCDFData, selecteditem);
    if (SelectedFolderCd) {
      if (selecteditem.order !== undefined) {
        selecteditem.path = `${SelectedFolderCd.path}/${selecteditem.directoryname + ".ord"
          }`;
      } else {
        selecteditem.path = `${SelectedFolderCd.path}/${selecteditem.directoryname}`;
      }
      stateCDFDatanew = response.directoryname
        ? addFolderonObj(stateCDFDatanew, SelectedFolderCd, intl, selecteditem)
        : stateCDFDatanew;
      const newTreeItem = searchTreeItem(stateCDFDatanew, stateCDFDatanew);
      setSelectedCDPTreeItem(newTreeItem);
    } else {
      stateCDFDatanew = addFolderonObj(stateCDFDatanew, null, intl, selecteditem);
    }
    if (selectedfolder) {
      if (selecteditem.order !== undefined) {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname + ".ord"
          }`;
      } else {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
      }
      newData = response.directoryname
        ? addFolderonObj(newData, selectedfolder, intl, selecteditem)
        : newData;
      const newTreeItem = searchTreeItem(newData, selectedfolder);
      setSelectedTreeItem(newTreeItem);
      setSelectedTreeItemDuplicate(newTreeItem);
    } else {
      newData = addFolderonObj(newData, null, intl, selecteditem);
    }



    let passObjDet = {};
    setStateData((stateData) => Object.assign([], stateData, newData));
    setStateCDFData((stateCDFData) => Object.assign([], stateCDFData, stateCDFDatanew));
    if (selecteditem.directoryname !== undefined) {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "update",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_REQFOLDERMOVED", {
            user: props.sessionvalues.username,
            folder: selecteditem.directoryname,
            folder2: selectedfolder?.directoryname,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
      props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FOLDERMOVE"));
    } else {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "update",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_ORDERMOVED", {
            orderid: response.batchid,
            folderselect: selectedfolder?.directoryname,
            fromfolder: selectedTreeItem?.directoryname,
            user: store.getState().Loggeduser.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
      props.alert.success(
        props.t("Orders.Protocolorders.IDS_MSG_ORDEREDMOVED")
      );
      const passObjDetMove: any = [{
        batchcode: response.batchcode,
        createby: { usercode: sessionStorage.User },
        stepstartdate: GetutcDate(new Date()),
        viewoption: 2,
        orderobjects: JSON.stringify({
          batchcode: response.batchcode,
          batchid: response?.batchid,
          action: "OrderMoved",
          OrderPreviousFolder: selectedTreeItem?.directoryname,
          OrderNewFolder: selectedfolder?.directoryname,

        })
      }]
      Servicecalls(
        "" + ELNurl + "/protocol/updateTransactionHistoryList",
        passObjDetMove,
        ongetordersfailure,
        ongetordersfailure
      );
    }

    setPullcontents(true);
    setMoveDialogView(false);
  };

  const onMoveFileSuccess = (response: any) => {
    let directorycode = response.directorycode;
    let selecteditem =
      response.folderfilecode !== undefined
        ? getDirectoryOnName(stateData, response.filename)
        : getDirectoryOncode(stateData, directorycode);
    let selectedfolder =
      response.folderfilecode !== undefined
        ? getDirectoryOncode(stateData, directorycode)
        : getDirectoryOncode(stateData, response.parentdircode);

    selecteditem.directoryname = response.filename;
    let newData = removeItem(stateData, selecteditem);

    if (selectedfolder) {
      selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
      newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
      const newTreeItem = searchTreeItem(newData, selectedfolder);
      setSelectedTreeItem(newTreeItem);
      setSelectedTreeItemDuplicate(newTreeItem);
    } else {
      newData = addFolderonObj(newData, null, intl, selecteditem);
    }
    setStateData(newData);
    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "update",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_REQFOLDERMOVED", {
          user: props.sessionvalues.username,
          folder: selecteditem.directoryname,
          folder2: selectedfolder.directoryname,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FILEMOVED"));
    setMoveDialogView(false);
  };

  const onMultiMoveItemSuccess = (response: any) => {
    ($("#auditTrailModalsheetview") as any).modal("hide");
    setMoveDialogView(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);

    setAuditservicecall({
      AuditUrl: "",
      AuditObject: {},
      AuditPassfunction: undefined,
      AuditFailfunction: undefined,
      AuditCancelfunction: undefined,
      Auditfilefunction: false,
    });
    if (response === undefined || response.length <= 0) return;
    let directorycode = response[0].directorycode;
    let newData = stateData;
    let selectedfolder = selectedTreeItem;
    // let filefor;
    for (let ind = 0; ind < response.length; ind++) {
      // let batchid = getsheetitemnameonscreen(response[ind]);
      let batchid = response[ind].batchid;
      let selecteditem = getDirectoryOnName(newData, batchid);
      selectedfolder = getDirectoryOncode(newData, directorycode);
      //filefor = selectedfolder.filefor;
      newData = removeItem(newData, selecteditem);

      if (selectedfolder) {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname + ".ord"
          }`;
        // newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
        const newTreeItem = searchTreeItem(newData, selectedfolder);
        setSelectedTreeItem(newTreeItem);
        setSelectedTreeItemDuplicate(newTreeItem);
      } else {
        //newData = addFolderonObj(newData, null, intl, selecteditem);
      }
    }

    setStateData(newData);

    setMoveDialogView(false);
    setIsMultiSelectOrder(false);
    setSelectedOrders([]);
    setPullcontents(true);

    Servicecalls(
      "" + ELNurl + "/Instrument/Getordersondirectory",
      {
        directorycode: directorycode,
        objuser: {
          fromdate: GetutcDate(new Date(fromRange)),
          todate: GetutcDate(new Date(toRange)),
        },
        lsuserMaster:
          store.getState().Loggeduser !== undefined &&
            store.getState().Loggeduser !== null &&
            Object.keys(store.getState().Loggeduser).length > 0
            ? store.getState().Loggeduser
            : {
              usercode: localStorage.getItem("User"),
              username: localStorage.getItem("Username"),
              unifieduserid: localStorage.getItem("unifieduserid"),
            },
        lstuserMaster: Getteamusersfromsession(),
        sitemaster: { sitecode: sessionStorage.Usersite }
      },
      ongetorderssuccess,
      ongetordersfailure
    );
    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "Move",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_ORDERMOVED", {
          orderid: response[0].batchid,
          folderselect: selectedfolder?.directoryname,
          fromfolder: selectedTreeItem?.directoryname,
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );

    const passObjDetMove: any = response.reduce((acc: any, item: any) => {
      acc.push({
        batchcode: item.batchcode,
        createby: { usercode: sessionStorage.User },
        stepstartdate: GetutcDate(new Date()),
        viewoption: 2,
        orderobjects: JSON.stringify({
          batchcode: item.batchcode,
          batchid: item?.batchid,
          action: "OrderMoved",
          OrderPreviousFolder: selectedTreeItem?.directoryname,
          OrderNewFolder: selectedfolder?.directoryname,
        })
      })
      return acc
    }, [])

    Servicecalls(
      "" + ELNurl + "/protocol/updateTransactionHistoryList",
      passObjDetMove,
      ongetordersfailure,
      ongetordersfailure
    );


  };

  const onMoveItemFailure = (response: any) => { };

  const onMultiMoveFileSuccess = (response: any) => {
    if (response === undefined || response.length <= 0) return;
    let directorycode = response[0].directorycode;
    let newData = stateData;
    let selectedfolder = selectedTreeItem;
    props.alert.success(
      props.t("Orders.Sheetorders.IDS_MSG_FILESMOVEDSUCCESS")
    );
    for (let ind = 0; ind < response.length; ind++) {
      let selecteditem = getDirectoryOnName(newData, response[ind].filename);
      selectedfolder = getDirectoryOncode(newData, directorycode);

      newData = removeItem(newData, selecteditem);
      if (selectedfolder) {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
        newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
        const newTreeItem = searchTreeItem(newData, selectedfolder);
        setSelectedTreeItem(newTreeItem);
        setSelectedTreeItemDuplicate(newTreeItem);
        let passObjDet = {
          objsilentaudit: Silentauditobject(
            "Move",
            "Sheet Orders",
            props.t("Orders.Sheetorders.IDS_AUDIT_FILEMOVED", {
              user: props.sessionvalues.username,
              filename: response[ind].filename,
              folder: selectedfolder?.directoryname,
            })
          ),
        };

        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );
      } else {
        newData = addFolderonObj(newData, null, intl, selecteditem);
      }
    }

    setStateData(newData);

    setMoveDialogView(false);
    setIsMultiSelectFile(false);
    setIsSelectAllFile(false);
    setSelectedFiles([]);
    setPullcontents(true);
  };

  const onMoveFileFailure = (response: any) => {
    console.log(response);
  };

  const onMultiMoveFolderSuccess = (response: any) => {
    if (response === undefined || response.length <= 0) return;
    for (let ind = 0; ind < response.length; ind++) {
      let movetofolder = getDirectoryOncode(
        stateData,
        response[0].parentdircode
      );
      let newData = Movemultifolders(stateData, response, movetofolder);
      movetofolder = getDirectoryOncode(newData, response[0].parentdircode);

      setStateData(newData);
      setSelectedTreeItem(movetofolder);
      setSelectedTreeItemDuplicate(movetofolder);
      setMoveDialogView(false);
      setIsMultiSelectFolders(false);
      setSelectedFolders([]);

      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "Move",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_SHEETFOLDERMOVED", {
            user: props.sessionvalues.username,
            folder1: response[ind].directoryname,
            folder2: movetofolder.directoryname,
          })
        ),
      };

      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FOLDERMOVE"));
  };

  const onMoveFolderFailure = (response: any) => { };

  const handlemoveDialogClick = (event: any) => {
    if (event.selectedfolder === undefined) {
      event.selectedfolder = { directorycode: -1, path: "Sheet" };
    }

    if (event.selectedfolder === null) {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDERSELECT"));
    } else {
      let selectedfolder = event.selectedfolder;
      let selecteditem = event.selecteditem;

      if (selectedfolder.directorycode !== selecteditem.parentdircode) {
        let passData = {
          directoryname: selecteditem.directoryname,
          parentdircode: selectedfolder.directorycode,
        };

        Servicecalls(
          "" + ELNurl + "/Instrument/getMoveDirectory",
          passData,
          (response: any) => {
            selecteditem.directoryname = response.directoryname;
            if (
              isMultiSelectOrder &&
              isSelectAllOrder &&
              selectedOrders !== undefined &&
              selectedOrders.length > 0
            ) {
              let order: any = [];
              selectedOrders.map((obj: any) => {
                if (obj.order !== undefined) {
                  //obj.order.lsautoregister !== undefined ? delete obj.order.lsautoregister : obj.order.lsautoregister;
                  delete obj.order.lsautoregister;
                  order.push(obj.order);
                }
                return obj;
              });

              let orders: any = order.map((obj: any) => {
                obj.directorycode = selectedfolder.directorycode;
                obj.objmanualaudit = Manualauditobject("Move", "Sheet Orders");
                return obj;
              });

              let Audit = AuditTrailValidation("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS", "IDS_TSK_MOVEORDER");

              if (Audit) {
                ($("#auditTrailModalsheetview") as any).modal("show");
                setAuditservicecall({
                  AuditUrl: "" + ELNurl + "/Instrument/UpdateFolderfororders",
                  AuditObject: orders,
                  AuditPassfunction: onMultiMoveItemSuccess.bind(this),
                  AuditFailfunction: onMoveItemFailure.bind(this),
                });
              } else {
                Servicecalls(
                  "" + ELNurl + "/Instrument/UpdateFolderfororders",
                  orders,
                  onMultiMoveItemSuccess,
                  onMoveItemFailure
                );
              }
            } else if (
              isMultiSelectOrder &&
              selectedOrders !== undefined &&
              selectedOrders.length > 0
            ) {
              let orders: any = selectedOrders.map((obj) => {
                obj.directorycode = selectedfolder.directorycode;
                obj.objmanualaudit = Manualauditobject("Move", "Sheet Orders");
                return obj;
              });

              let Audit = AuditTrailValidation(
                "IDS_MDL_ORDERS",
                "IDS_SCN_SHEETORDERS",
                "IDS_TSK_MOVEORDER"
              );
              if (Audit) {
                ($("#auditTrailModalsheetview") as any).modal("show");
                setAuditservicecall({
                  AuditUrl: "" + ELNurl + "/Instrument/UpdateFolderfororders",
                  AuditObject: orders,
                  AuditPassfunction: onMultiMoveItemSuccess.bind(this),
                  AuditFailfunction: onMoveItemFailure.bind(this),
                });
              } else {
                Servicecalls(
                  "" + ELNurl + "/Instrument/UpdateFolderfororders",
                  orders,
                  onMultiMoveItemSuccess,
                  onMoveItemFailure
                );
              }
            } else if (
              isMultiSelectFile &&
              selectedFiles !== undefined &&
              selectedFiles.length > 0
            ) {
              let files = selectedFiles.map((obj) => {
                obj.directorycode = selectedfolder.directorycode;
                return obj;
              });
              Servicecalls(
                "" + ELNurl + "/Instrument/UpdateFolderforfiles",
                files,
                onMultiMoveFileSuccess,
                onMoveFileFailure
              );
            } else if (
              isSelectAllFile &&
              selectedFiles !== undefined &&
              selectedFiles.length > 0
            ) {
              let files = selectedFiles.map((obj) => {
                obj.directorycode = selectedfolder.directorycode;
                return obj;
              });
              Servicecalls(
                "" + ELNurl + "/Instrument/UpdateFolderforfiles",
                files,
                onMultiMoveFileSuccess,
                onMoveFileFailure
              );
            } else if (
              isMultiSelectFolders &&
              selectedFolders !== undefined &&
              selectedFolders.length > 0
            ) {
              let folders = selectedFolders.map((obj) => {
                return {
                  path: selectedfolder.path + "/" + obj.directoryname,
                  parentdircode: selectedfolder.directorycode,
                  directorycode: obj.directorycode,
                };
              });

              Servicecalls(
                "" + ELNurl + "/Instrument/Updateparentforfolder",
                folders,
                onMultiMoveFolderSuccess,
                onMoveFolderFailure
              );
            } else {
              if (selecteditem.order !== undefined) {
                let order =
                  selecteditem !== undefined ? selecteditem.order : {};

                order.directorycode = selectedfolder.directorycode;

                let Audit = AuditTrailValidation(
                  "IDS_MDL_ORDERS",
                  "IDS_SCN_SHEETORDERS",
                  "IDS_TSK_MOVEORDER"
                );

                if (Audit) {
                  ($("#auditTrailModalsheetview") as any).modal("show");
                  setAuditservicecall({
                    AuditUrl: "" + ELNurl + "/Instrument/UpdateFolderfororder",
                    AuditObject: order,
                    AuditPassfunction: onMoveItemSuccess.bind(this),
                    AuditFailfunction: onMoveItemFailure.bind(this),
                  });
                } else {
                  Servicecalls(
                    "" + ELNurl + "/Instrument/UpdateFolderfororder",
                    order,
                    onMoveItemSuccess,
                    onMoveItemFailure
                  );
                }
              } else if (selecteditem.file !== undefined) {
                let order = selecteditem !== undefined ? selecteditem.file : {};

                order.directorycode = selectedfolder.directorycode;

                Servicecalls(
                  "" + ELNurl + "/Instrument/UpdateFolderforfile",
                  order,
                  onMoveFileSuccess,
                  onMoveFileFailure
                );
              } else {
                let currentpath = `${selectedfolder.path}/${selecteditem.directoryname}`;
                let directory = {
                  directoryname: selecteditem.directoryname,
                  directorycode: selecteditem.directorycode,
                  parentdircode: selectedfolder.directorycode,
                  path: currentpath,
                  modifiedby: {
                    usercode: Number(sessionStorage.User),
                    username: sessionStorage.Username
                  },
                  dateModified: new Date(),
                };
                Servicecalls(
                  "" + ELNurl + "/Instrument/Movedirectory",
                  directory,
                  onMoveItemSuccess,
                  onMoveItemFailure
                );
              }
            }
          },
          (response: any) => { }
        );
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDERNOTMOVE"));
      }
    }
  };

  const handleListItemClick = (event: any) => {
    let newSelectedGridItem = { selected: true, [event.dataItem.path]: true };


    if (event.dataItem.path) {
      newSelectedGridItem = event.dataItem;
      newSelectedGridItem[event.dataItem.path] = true;
      newSelectedGridItem.selected = true;

      setSelectedGridItem(newSelectedGridItem);

      if (event.dataItem.path) {
        const key = event.dataItem.path.toString();
        setGridSelection({ [key]: true });
        //   setSelectedTreeItem(newSelectedGridItem);
      }
    }

    if (event.tree) {
      const newSelectedTreeItem: DataModel = searchTreeItem(
        stateData,
        newSelectedGridItem
      );
      setSelectedTreeItem(newSelectedTreeItem);
      setSelectedTreeItemDuplicate(newSelectedTreeItem);
    }
    updateFileDetailsData(newSelectedGridItem);

    let directorycode = event.dataItem.directorycode;

    if (
      directorycode !== undefined &&
      event.dataItem.filefor !== undefined &&
      event.dataItem.filefor === "DR"
    ) {
      Servicecalls(
        "" + ELNurl + "/Instrument/Getordersondirectory",
        {
          directorycode: directorycode,
          objuser: {
            fromdate: GetutcDate(new Date(fromRange)),
            todate: GetutcDate(new Date(toRange)),
          },
          lsuserMaster:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: localStorage.getItem("User"),
                username: localStorage.getItem("Username"),
                unifieduserid: localStorage.getItem("unifieduserid"),
              },
          lstuserMaster: Getteamusersfromsession(),
          sitemaster: { sitecode: sessionStorage.Usersite },
          lstworkflow: workflow
        },
        ongetorderssuccess,
        ongetordersfailure
      );
    }

    if (event?.dataItem?.order?.viewoption && event?.dataItem?.order?.viewoption === 3) {
      let passObjDet = {
        batchcode: event.dataItem.order.batchcode
      }
      Servicecalls("" + ELNurl + "/Instrument/Getselectedteam", passObjDet, (res: any) => {
        if (res !== undefined) {
          console.log(res);
          const updatedOrder = {
            ...event.dataItem.order,
            lsselectedTeam: res,
          };

          const updatedGridItem = {
            ...event.dataItem,
            order: updatedOrder,
          };

          let teamNameString: any = [];
          res.map((items: any, index: number) => {
            teamNameString.push(items?.userteam?.teamname);
            return true;
          });
          const result: any = `(${teamNameString.join(",")})`;
          sessionStorage.setItem("selectedteamname", result);
          updateFileDetailsData(updatedGridItem);
        }
      }, () => { });
    }
  };

  const handleOrderopenClick = (event: any, item: any) => {
    if (item.filecode && item.filecode === -1 && item.filetype === 0) {
      let passObj = {
        testcode: item.testcode,
        testtype: 0,
        objLoggeduser:
          props.sessionvalues.usercode !== undefined &&
            props.sessionvalues.username !== undefined &&
            props.sessionvalues.usercode !== null &&
            props.sessionvalues.username !== null
            ? {
              usercode: props.sessionvalues.usercode,
              username: props.sessionvalues.username,
            }
            : false,
        ismultitenant: isMultitenant,
        lssitemaster: {
          sitecode: sessionStorage.Usersite,
          sitename: sessionStorage.Usersitename,
        },
      };
      Servicecalls(
        "" + ELNurl + "/File/GetfilesOnTestcode",
        passObj,
        Formatrecordfortreevie,
        (res: any) => { }
      );
      setOpenedorder(item);
    } else {

      updateOrderStatusCheck(
        item.batchcode,
        store.getState().Loggeduser.usercode
      );

      recordorderopenhistory(item);
    }
    // item.lstproject = projects;
    // item.lstworkflow = workflow;
  };

  const recordorderopenhistory = (item: any) => {
    let passobj: any = {
      // protocolorderstepcode: this.state.protocolToBeEdited.protocolorderstepcode,
      batchcode: item.batchcode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
        batchid: item.batchid,
        Processed: item.canuserprocess && item.approvelstatus === undefined
          && !(item?.sharetome?.[0]?.sharerights === 0)
          ? "Processed"
          : "Opened",
        user2: sessionStorage.Username,
      }),
      viewoption: 1,
      orderobjects: JSON.stringify({
        batchcode: item.batchcode,
        batchid: item?.batchid,
        action: "OrderOpen",
        ...item.testname && { testname: item.testname },
      })
    };
    if (item.canuserprocess && item.approvelstatus === undefined) {
      passobj.batchid = item.batchid;
    }
    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_SHEETORDERS",
      "IDS_TSK_PROCESSORDER"
    );
    if (Audit) {
      ($("#auditTrailModalsheetview") as any).modal("show");
      if (
        item.approvelstatus !== undefined &&
        (item.approvelstatus === 1 || item.approvelstatus === 3)
      ) {
        passobj.objmanualaudit = Manualauditobject("Open", "Sheet Order");
      } else {
        passobj.objmanualaudit = Manualauditobject(
          "process order",
          "Sheet Order"
        );
      }
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/protocol/updatetransactionhistory",
        AuditObject: passobj,
        AuditPassfunction: (res: any) => {
          setSheetUnmapped(false);
          item.lstproject = projects;
          item.lstworkflow = workflow;
          setOpenedorder(item);
          setIsorderopen(true);
          ($("#auditTrailModalsheetview") as any).modal("hide");

          if (item.approved === 1) {
            let passObjDet = {
              objsilentaudit: Silentauditobject(
                "open",
                "Sheet Orders",
                props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
                  batchid: item.batchid,
                  screen: orderType(item.filetype),
                  Processed:
                    item.canuserprocess &&
                      item.approvelstatus !== undefined &&
                      (item.approvelstatus === 1 || item.approvelstatus === 3)
                      ? "Opened"
                      : "Processed",
                  user: sessionStorage.Username,
                })
              ),
            };
            Servicecalls(
              "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
              passObjDet,
              onAuditValidateError.bind(this),
              onAuditValidateFailure.bind(this)
            );
          } else {
            let passObjDet = {
              objsilentaudit: Silentauditobject(
                "process order",
                "Sheet Orders",
                props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
                  batchid: item.batchid,
                  screen: orderType(item.filetype),
                  Processed:
                    item.canuserprocess &&
                      item.approvelstatus !== undefined &&
                      (item.approvelstatus === 1 || item.approvelstatus === 3)
                      ? "Opened"
                      : "Processed",
                  user: sessionStorage.Username,
                })
              ),
            };
            Servicecalls(
              "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
              passObjDet,
              onAuditValidateError.bind(this),
              onAuditValidateFailure.bind(this)
            );
          }
        },
        AuditFailfunction: oncloseorder,
        AuditCancelfunction: oncloseorder,
      });
    } else {
      setSheetUnmapped(false);
      item.lstproject = projects;
      item.lstworkflow = workflow;
      setOpenedorder(item);
      setIsorderopen(true);
      Servicecalls(
        "" + ELNurl + "/protocol/updatetransactionhistory",
        passobj,
        //ongetordersfailure,
        processsuccess.bind(this, item),
        ongetordersfailure
      );
    }
  };

  const processsuccess = (item: any, res: any) => {
    // setSheetUnmapped(false);
    // item.lstproject = projects;
    // item.lstworkflow = workflow;
    // setOpenedorder(item);
    // setIsorderopen(true);
    // ($('#auditTrailModalsheetview') as any).modal("hide")

    if (
      item.approvelstatus !== undefined &&
      (item.approvelstatus === 1 || item.approvelstatus === 3)
    ) {
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "open",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
            batchid: item.batchid,
            screen: orderType(item.filetype),
            Processed:
              item.canuserprocess &&
                item.approvelstatus !== undefined &&
                (item.approvelstatus === 1 || item.approvelstatus === 3)
                ? "Opened"
                : "Processed",
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    } else {
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "process order",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
            batchid: item.batchid,
            screen: orderType(item.filetype),
            Processed:
              item.canuserprocess &&
                item.approvelstatus !== undefined &&
                (item.approvelstatus === 1 || item.approvelstatus === 3)
                ? "Opened"
                : "Processed",
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
  };
  const handleContextMenuView = (event: ContextMenuEvent) => {
    setMenuOffSet({ left: event.event.clientX, top: event.event.clientY });
    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
    deletefolderevents = event?.tree ? true : false;
    if (
      event.dataItem !== undefined &&
      event.dataItem !== null &&
      // ((event.dataItem.filefor !== undefined &&
      //   event.dataItem.filefor === "DR") ||
      //   event.dataItem.order !== undefined)
      ((event.dataItem.filefor !== undefined &&
        (event.dataItem.filefor === "DR" ||
          event.dataItem.filefor === "TMP" ||
          event.dataItem.filefor === "TMM")) ||
        event.dataItem.order !== undefined)
    ) {
      if (
        event.dataItem.order !== undefined &&
        event.dataItem.order.ordercancell !== undefined
      ) {
        setIsMenuContext(false);
        setContextMenuView(false);
      } else {
        setContextMenuView(true);

        setIsMenuContext(false);
        handleListItemClick(event);
      }
    } else if (
      event.dataItem !== undefined &&
      event.dataItem !== null &&
      (event.dataItem.filefor !== undefined ||
        event.dataItem.file !== undefined)
    ) {
      setContextMenuView(true);

      setIsMenuContext(false);
      handleListItemClick(event);
    } else {
      setIsMenuContext(true);
    }
    if (event.dataItem?.Isview_Constence) {
      Isview_Constence = event.dataItem?.Isview_Constence;
    } else if (Isview_Constence) {
      Isview_Constence = false;
    }
  };

  const handleContextMenuClick = (event: ContextMenuEvent, item: any) => {
    if (item !== undefined && item.order !== undefined) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "openorder"
      ) {
        recordorderopenhistory(item.order);
        item.order.lstproject = projects;
        item.order.lstworkflow = workflow;
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "moveorder"
      ) {
        setMoveDialogView(true);
      }
    } else if (item !== undefined && item.file !== undefined) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "movefiles"
      ) {
        setMoveDialogView(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "deletefiles"
      ) {
        ondeletefile(item.file);
      }
    } else if (item !== undefined && item.menuselected) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultiorders"
      ) {
        setIsMultiSelectOrder(true);
        setSelectedOrders([]);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultifiles"
      ) {
        setIsMultiSelectFile(true);
        setSelectedFiles([]);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultifolders"
      ) {
        setIsMultiSelectFolders(true);
        setSelectedFolders([]);
      }
    } else {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "createfolder"
      ) {
        setAddDialogVisible(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "renamefolder"
      ) {
        setEditDialogView(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "deletefolder"
      ) {
        if (
          selectedTreeItem !== undefined &&
          selectedTreeItem !== null &&
          selectedTreeItem.parentdircode === -1
        ) {
          let issingleparent = stateData.findIndex(
            (obj) =>
              obj.parentdircode === -1 &&
              obj.directorycode !== selectedTreeItem?.directorycode
          );
          if (issingleparent <= -1) {
            props.alert.error("Orders.Sheetorders.IDS_MSG_HAVEONEDIRECTORY");
          } else {
            setDeleteDialogView(true);
          }
        } else {
          setDeleteDialogView(true);
        }
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "movefolder"
      ) {
        setMoveDialogView(true);
      }
    }
  };

  const handleDialogClose = () => {
    setDeleteDialogView(false);
    setEditDialogView(false);
    setMoveDialogView(false);
    setAddDialogVisible(false);
  };

  const handleCloseMultiselectClick = (event: any) => {
    setIsMultiSelectOrder(false);
    setIsMultiSelectFile(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);
    setIsMultiSelectFolders(false);
    setSelectedOrders([]);
    setSelectedFiles([]);
    setSelectedFolders([]);
  };

  const handleMoveOnMultiselect = (event: any) => {
    console.log(selectedFiles);
    if (SelectAllFile) {
      if (AllSelectedFiles && AllSelectedFiles.length > 0) {
        setMoveDialogView(true);
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
      }
    } else if (SelectAllOrder) {
      if (AllSelectedOrder && AllSelectedOrder.length > 0) {
        setMoveDialogView(true);
        setSelectedOrders(AllSelectedOrder);
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
      }
    } else if (
      (selectedFiles && selectedFiles.length > 0) ||
      (selectedOrders && selectedOrders.length > 0) ||
      (selectedFolders && selectedFolders.length > 0)
    ) {
      setMoveDialogView(true);
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
    }
  };
  const handleSelectAllOrderClick = (event: any) => {
    if (selectedTreeItem?.items !== undefined) {
      if (event.checked) {
        let items: any = [selectedTreeItem?.items];
        console.log(items);
        let orders: any = [];
        items[0].map((obj: any) => {
          if (obj.order !== undefined) {
            orders.push(obj.order);
          }
          return true;
        });

        console.log(orders);
        setSelectedOrders([...orders]);
        setSelectedTreeItem(selectedTreeItem);
        setIsSelectAllOrder(true);
        SelectAllOrder = true;
        AllSelectedOrder = orders;

        console.log(AllSelectedOrder);
      } else {
        setIsSelectAllOrder(false);
        setSelectedOrders([]);
        SelectAllOrder = undefined;
      }
    } else if (stateData !== undefined) {
      if (event.checked) {
        let items: any = stateData;
        console.log(items);
        let orders: any = [];
        items.map((obj: any) => {
          if (obj.order !== undefined) {
            orders.push(obj);
          }
          return true;
        });

        console.log(orders);
        //setSelectedOrders([...orders]);
        setIsSelectAllOrder(true);
        SelectAllOrder = true;
        AllSelectedOrder = orders;
        console.log(AllSelectedOrder);
      } else {
        setIsSelectAllOrder(false);
        SelectAllOrder = undefined;
      }
    }
  };

  const handleSelectAllFileClick = (event: any) => {
    if (selectedTreeItem?.items !== undefined) {
      if (event.checked) {
        let items: any = [selectedTreeItem?.items];
        let files: any = [];
        items[0].map((obj: any) => {
          if (obj.file !== undefined) {
            // obj.selected=true;
            files.push(obj.file);
          }
          return true;
        });
        console.log(files);
        SelectAllFile = true;
        setSelectedTreeItem(selectedTreeItem);
        setSelectedFiles([...files]);
        setIsSelectAllFile(true);
        AllSelectedFiles = files;
        console.log(AllSelectedFiles);
      } else {
        setIsSelectAllFile(false);
        setSelectedFiles([]);
        SelectAllFile = undefined;
      }
    } else if (stateData !== undefined) {
      if (event.checked) {
        let items: any = stateData;
        let files: any = [];
        items.map((obj: any) => {
          if (obj.file !== undefined) {
            files.push(obj.file);
            setSelectedGridItem(obj);
          }
          return true;
        });
        console.log(files);
        //  setSelectedFiles([selectedTreeItem?.items]);
        setSelectedFiles([...files]);
        setIsSelectAllFile(true);
        SelectAllFile = true;
        AllSelectedFiles = files;
        console.log(AllSelectedFiles);
      } else {
        setIsSelectAllFile(false);
        SelectAllFile = undefined;
      }
    }
  };

  const handleDeleteOnMultiselect = (event: any) => {
    //  ondeletefile();
    console.log(selectedFiles);

    if (
      isMultiSelectFile &&
      SelectAllFile &&
      AllSelectedFiles &&
      AllSelectedFiles.length
    ) {
      ondeletemultifile(AllSelectedFiles);
    } else if (isMultiSelectFile && selectedFiles && selectedFiles.length) {
      ondeletemultifile(selectedFiles);
    } else if (
      isMultiSelectFolders &&
      selectedFolders &&
      selectedFolders.length
    ) {
      ondeletemultifolder(selectedFolders);
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_PLEASESELECTARECORD"));
    }
  };
  document.addEventListener("click", (event) => {
    let id = (event.target as HTMLElement).getAttribute("id");
    if (id === "idcontextmenushow" || id === "idcontextmenushowicon") {
      setIsMenuContext(true);
      setContextMenuView(true);
    } else if (isMenuContext || contextMenuView) {
      setIsMenuContext(false);
      setContextMenuView(false);
    }
  });

  /**
   * Used to get the selected from and to date for date filteration
   * @param From date
   * @param To date
   */
  const setdateRange = (e: any, isrest: Boolean) => {
    setfromRange(e.from);
    settoRange(e.to);
    setchangedtodate(e.changedtodate);

    // setFileType(e.filetype);
    let daydiff = dateDiffInDays(new Date(e.from), new Date(e.to)).toString();
    localStorage.setItem("sheetdaydiff", daydiff);

    // if(filterType === 1){
    //   let daydiff = dateDiffInDays(new Date(e.from), new Date()).toString();
    //   localStorage.setItem("sheetdaydiff", daydiff);
    // }
    initialorders = null;
    if (isrest) {
      setFileType(-1);
      setsearchCriteriaType(0);
      setorderflag(-1);
      setSearchContentText("");
      setorderstatusType(0);
      setFlitertest(-1);
      setFliterproject(-1);
      setIscancelled(false);

      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        fileType,
        0,
        -1,
        { testcode: -1, testname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) },
        { projectcode: -1, projectname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) },
        e.iscancelled,
        stateData
      );
    } else if (e.test !== undefined || e.project !== undefined) {
      setFliterproject(e.projects);
      setFlitertest(e.test);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        e.filetype,
        searchCriteriaType,
        orderflag,
        e.test,
        e.projects,
        e.iscancelled,
        stateData
      );
    } else if (e.filetype !== undefined) {
      setFileType(e.filetype);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        e.filetype,
        searchCriteriaType,
        orderflag,
        flitertest,
        fliterproject,
        e.iscancelled,
        stateData
      );
    } else if (e.orderflag !== undefined) {
      setorderflag(e.orderflag);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        fileType,
        searchCriteriaType,
        e.orderflag,
        flitertest,
        fliterproject,
        e.iscancelled,
        stateData
      );
    }

  };
  const handleSyncClick = (event: any) => {
    let passObjDet = sessionStorage.Usersite;
    setServicecall({
      ServiceToUrl: "" + ELNurl + "/Restcall/ImportLimsOrder",
      ServiceHeaderobject: passObjDet,
      ServiceMethodType: "POST",
      ServcieonSuccess: onImportLimsorderSuccess,
      ServcieonFailure: onImportLimsorderFailure,
      ServiceTenant: undefined,
      Servicecontenttype: undefined,
    });
  };

  const onImportLimsorderSuccess = (response: any) => {
    // this.getorders(0, this.state.activemenukey);
    // props.onImportLimsorderFailure();
    setTimeout(() => {
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        fromRange,
        new Date(),
        fileType,
        searchCriteriaType,
        orderflag,
        flitertest,
        fliterproject,
        iscancelled,
        stateData
      );
    }, 500);

    if (response === "success") {
      props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_SYNCSUCCESS"));
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_SYNCFAILURE"));
    }

    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "syncLims",
        "Sheet Order",
        props.t("Orders.Sheetorders.IDS_AUDIT_SYNCLIMSORDERS", {
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError,
      onAuditValidateFailure
    );
  };
  const onImportLimsorderFailure = (response: any) => {
    // this.getorders(0, this.state.activemenukey);
    // this.onsetDefaultdate();
  };

  const onfilterTypeChange = (key: any) => {
    localStorage.setItem("sheetfiltertype", key);
    setfilterType(key);
  };

  const ondeletefile = (file: any) => {
    let filedeleteurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/deletefilesforfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/deletefilesforfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;


    confirmAlert({
      title: props.t("Confirm"),
      message: props.t("Do you want to delete this file?"),
      buttons: [
        {
          label: props.t("Yes"),
          onClick: () => {
            // let file = file;

            let selecttree = getDirectoryOncode(stateData, file.directorycode);
            let directory: number = file.directorycode;
            let newData: any = [];

            if (selectedTreeItem === undefined || selectedTreeItem === null) {
              selecttree = getDirectoryOncode(stateData, file.folderfilecode);
              directory = file.folderfilecode;
              newData = deletefileitemsforhomebutton(stateData, [
                {
                  directorycode: file.folderfilecode,
                  file: file,
                  filefor: "FIL",
                },
              ]);
            } else {
              newData = deletefileitemstoFolderwithfilefor(
                stateData,
                directory,
                intl,
                [
                  {
                    directorycode: file.folderfilecode,
                    file: file,
                    filefor: "FIL",
                  },
                ],
                selecttree !== undefined && selecttree !== null && selecttree?.filefor
                  ? selecttree?.filefor
                  : "",
                screen
              );
            }
            setStateData(newData);
            setSelectedCDPTreeItem(undefined);
            SelectedCDPTreeItem = undefined;
            SelectedCDFvalue = 4;
            setDetailsData(null);
            console.log(stateData);
            // setDetailsData(null);
            setServicecall({
              ServiceToUrl: filedeleteurl,
              ServiceHeaderobject: file,
              ServiceMethodType: "POST",
              ServcieonSuccess: ondeletefileSuccess,
              ServcieonFailure: ondeletefileFailure,
              ServiceTenant: undefined,
              Servicecontenttype: undefined,
              ServcieProcessbar: true,
            });
          }
        },
        {
          label: props.t("No"),
          onClick: () => {
          }
        }
      ]
    });
  };


  const ondeletefileCancelSuccess = (response: any, passdata: any) => { };
  const ondeletefileSuccess = (response: any, passdata: any) => {
    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "delete",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_FILEDELETE", {
          file: response.file.filename,
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
    setTimeout(() => {
      props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FILEDELETED"));
    }, 10);
  };

  const ondeletefileFailure = (response: any) => {
    console.log(response);
  };

  const ondeletemultifile = (multifile: any) => {
    // setDeleteDialogView(true);
    confirmAlert({
      title: props.t("Confirm"),
      message: props.t("Do you want to delete this file?"),
      buttons: [
        {
          label: props.t("Yes"),
          onClick: () => {
            handleDialogClick({
              event: undefined,
              type: "delete",
              directoryToMove: undefined,
              directoryToDelete: undefined,
              keepfolderstructure: undefined,
              dynamicfolders: undefined,
              movestatus: undefined,
              selectedItem: undefined,
            })
          }
        },
        {
          label: props.t("No"),
          onClick: () => {
            handleDialogClick({
              event: undefined,
              type: "cancel delete",
              directoryToMove: undefined,
              directoryToDelete: undefined,
              keepfolderstructure: undefined,
              dynamicfolders: undefined,
              movestatus: undefined,
              selectedItem: undefined,
            })
          }
        }
      ]
    });


  };

  const ondeletemultifileSuccess = (response: any, passdata: any) => {
    let file = passdata;
    let newData: any = [];
    let updateddata: any = [];
    file.forEach((item: any) => {
      let selecttree = getDirectoryOncode(stateData, item.directorycode);
      let directory: number = item.directorycode;
      if (selectedTreeItem !== undefined && selectedTreeItem !== null) {
        if (updateddata.length === 0) {
          newData = deletefileitemstoFolderwithfilefor(
            stateData,
            directory,
            intl,
            [
              {
                directorycode: item.folderfilecode,
                file: item,
                filefor: "FIL",
              },
            ],
            selecttree !== undefined &&
              selecttree !== null &&
              selecttree?.filefor
              ? selecttree?.filefor
              : "",
            screen
          );
          updateddata = newData;
        } else {
          newData = deletefileitemstoFolderwithfilefor(
            updateddata,
            directory,
            intl,
            [
              {
                directorycode: item.folderfilecode,
                file: item,
                filefor: "FIL",
              },
            ],
            selecttree !== undefined &&
              selecttree !== null &&
              selecttree?.filefor
              ? selecttree?.filefor
              : "",
            screen
          );
        }
        updateddata = newData;
      } else {
        newData = deletefileitemsforhomebutton(stateData, [
          {
            directorycode: item.folderfilecode,
            file: item,
            filefor: "FIL",
          },
        ]);
      }
    });
    props.alert.success(props.t("Orders.Sheetorders.IDS_MULTIFILEDELETE"));

    setStateData(newData);
    setIsMultiSelectFile(false);
    // setIsSelectAllFile(false);
    setSelectedFiles([]);
    setDetailsData(null);
    setDeleteDialogView(false);
  };

  // const ondeletemultifileFailure = (response: any) => { };

  const ondeletemultifolder = (multifolder: any) => {
    if (
      selectedTreeItem !== undefined &&
      selectedTreeItem !== null &&
      selectedTreeItem.parentdircode === -1
    ) {
      let issingleparent = stateData.findIndex(
        (obj) =>
          obj.parentdircode === -1 &&
          obj.directorycode !== selectedTreeItem?.directorycode
      );
      if (issingleparent <= -1) {
        props.alert.error("The system should have atleast one directory.");
      } else {
        setDeleteDialogView(true);
      }
    } else {
      setDeleteDialogView(true);
    }
  };

  const Samplelogin = (order: any, methoddetails: any) => {
    let passObjDet: any = {};
    if (
      methoddetails !== undefined &&
      methoddetails.filenameuser !== "" &&
      methoddetails.filecode > 0
    ) {
      passObjDet = order;
      passObjDet.lsfile = methoddetails.file;
      passObjDet.methodcode = methoddetails.methodid;
      passObjDet.instrumentcode = methoddetails.instrumentid;
      passObjDet.lsuserMaster = props.sessionvalues.lsuserMaster;
      // passObjDet.createdtimestamp = GetutcDate(new Date());
      if (
        passObjDet.lssamplefile === undefined ||
        passObjDet.lssamplefile === null
      ) {
        passObjDet.lssamplefile = {
          batchcode: order.batchcode,
          testid: order.testcode,
          createdate: GetutcDate(new Date()),
          createbyuser: store.getState().Loggeduser,
          processed: 0,
          // filecontent: OrderTestcode.filecontent,
          versionno: 1,
          lssamplefileversion: [],
        };
      }
      passObjDet.ismultitenant = isMultitenant;

      let Audit = false;

      if (Audit) {
        // $("#auditTrailModalsheetview").modal("show");
        setServicecall({
          Orderclosebuttonvisible: true,

          AuditUrl: "" + ELNurl + "/Instrument/UpdateLimsOrder",
          AuditObject: passObjDet,
          AuditPassfunction: onUpdateLimsorderSuccess,
          AuditFailfunction: onUpdateLimsorderFaliure,
        });
      } else {
        setServicecall({
          Orderclosebuttonvisible: true,

          ServiceToUrl: "" + ELNurl + "/Instrument/UpdateLimsOrder",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: onUpdateLimsorderSuccess,
          ServcieonFailure: onUpdateLimsorderFaliure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
    } else {
      props.alert.error(
        props.t("Templates.Protocoltemplates.IDS_MSG_INVALID", { param: "" })
      );
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "warning",
          "Sheet Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_INVALIDSEL", {
            module: props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {
              param: "",
            }),
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/AuditConfigurationrecord",
        passObjDet,
        onAuditValidateError,
        onAuditValidateFailure
      );
    }
  };

  const onUpdateLimsorderSuccess = (response: any) => {
    if (
      response.response !== undefined &&
      response.response !== null &&
      response.response === false
    ) {
      props.alert.error(props.t("Common.ID_VALIDATION", { param: "" }));
    } else {
      response.canuserprocess = true;
      setSheetUnmapped(false);
      if (selectedTreeItem && selectedTreeItem.items) {
        selectedTreeItem.items.map((item) => {
          if (item.order.batchcode === response.batchcode) {
            item.order = response;
          }
          return item;
        });
      }
      setIsorderopen(true);

      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "Mapping",
          "Sheet Order",
          props.t("Orders.Sheetorders.IDS_AUDIT_SHEETMAPTOLIMSORDER", {
            sheet: response.filename,
            order: response.batchid,
            user: store.getState().Loggeduser.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError,
        onAuditValidateFailure
      );
    }
  };

  const onUpdateLimsorderFaliure = (response: any) => { };

  const Formatrecordfortreevie = (Sheetdata: any) => {
    let FileData: any = [];
    let ParentIDindex = 0;

    if (Sheetdata !== undefined && Sheetdata.length > 0) {
      for (let sheet = 0; sheet < Sheetdata.length; sheet++) {
        let data: any = {};
        ParentIDindex = ParentIDindex + 1;
        data = {
          id: ParentIDindex,
          filecode: Sheetdata[sheet].filecode,
          parentID: null,
          name: Sheetdata[sheet].filenameuser,
          filenameuser: Sheetdata[sheet].filenameuser,
          methodid:
            Sheetdata[sheet].lsmethods !== undefined &&
              Sheetdata[sheet].lsmethods.length > 0
              ? Sheetdata[sheet].lsmethods[0].methodid
              : null,
          instrumentid:
            Sheetdata[sheet].lsmethods !== undefined &&
              Sheetdata[sheet].lsmethods.length > 0
              ? Sheetdata[sheet].lsmethods[0].instrumentid
              : null,
          data: Sheetdata[sheet],
          selected: false,
          file: Sheetdata[sheet],
        };
        FileData.push(data);
      }
    }

    setTimeout(() => {
      setSheetData(FileData);
    }, 1000);
    setSheetUnmapped(true);
    setIsorderopen(false);
    // setOpenedorder(undefined);
    // return FileData;
  };

  const openFileSelected = (response: any) => {
    $("#idOpenSheet").attr("data-dismiss", "modal");
    $("#idOpenSheet").removeAttr("disabled");

    setSheetSelected(response);
  };

  const Opensheet = (response: any) => {
    Samplelogin(openedorder, sheetSelected !== undefined && sheetSelected);
  };

  const OnCancelOpensheet = (response: any) => {
    setSheetUnmapped(false);
    if (props.openorder !== undefined) {
      getfoldersforclose();
    }
  };

  const Detailview = React.useCallback(() => {

    return (
      <Suspense fallback={<div></div>}>
        <FileInformation
          data={detailsData}
          screen={screen}
          filefor={selectedTreeItem?.filefor}
          selectedteamname={sessionStorage.selectedteamname}
          t={props.t}
        />
      </Suspense>
    );
  }, [detailsData]);
  let filesaveurl: any, fileremoveurl: any;
  if (selectedCDPTreeItem) {
    filesaveurl =
      selectedCDPTreeItem !== undefined && selectedCDPTreeItem !== null
        ? ELNurl +
        "/Instrument/uploadfilessheetfolder/" +
        selectedCDPTreeItem.directorycode +
        "/" +
        selectedCDPTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/uploadfilessheetfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;

    fileremoveurl =
      selectedCDPTreeItem !== undefined && selectedCDPTreeItem !== null
        ? ELNurl +
        "/Instrument/removefilessheetfolder/" +
        selectedCDPTreeItem.directorycode +
        "/" +
        selectedCDPTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/removefilessheetfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;
  } else {
    filesaveurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/uploadfilessheetfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/uploadfilessheetfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;

    fileremoveurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/removefilessheetfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/removefilessheetfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;
  }

  let homeuploadfile =
    ELNurl +
    "/Instrument/uploadfilessheetfolder/" +
    -1 +
    "/" +
    "DR" +
    "/" +
    sessionStorage.getItem("tenantid") +
    "/" +
    isMultitenant +
    "/" +
    sessionStorage.getItem("User") +
    "/" +
    sessionStorage.getItem("Usersite") +
    "/" +
    new Date() +
    "/" +
    fileviewfor;

  let homeremovefile =
    ELNurl +
    "/Instrument/removefilessheetfolder/" +
    -1 +
    "/" +
    "DR" +
    "/" +
    sessionStorage.getItem("tenantid") +
    "/" +
    isMultitenant +
    "/" +
    sessionStorage.getItem("User") +
    "/" +
    sessionStorage.getItem("Usersite") +
    "/" +
    new Date() +
    "/" +
    fileviewfor;

  const searchonButtonClick = (
    SearchContentText: any,
    searchCriteriaType: any
  ) => {
    let returndateobj = setdates(
      filterType,
      isFiltered,
      "sheetdaydiff",
      toRange,
      changedtodate
    );
    //  let fromRange = returndateobj.fromRange;
    if (returndateobj !== undefined) {
      setfromRange(returndateobj.fromRange);
      settoRange(returndateobj.toRange);
    }
    setsearchCriteriaType(searchCriteriaType.value);
    if (
      SearchContentText !== "" &&
      searchCriteriaType.value !== undefined &&
      searchCriteriaType.value === 2
    ) {
      if (
        selectedTreeItemDuplicate !== undefined &&
        selectedTreeItemDuplicate !== null &&
        selectedTreeItemDuplicate.items !== undefined
      ) {
        let filterorders = selectedTreeItemDuplicate.items.filter(
          (item) =>
            item &&
            item.order &&
            item.order.keyword
              .toLowerCase()
              .includes(SearchContentText.toLowerCase())
        );
        setSelectedTreeItem({
          ...selectedTreeItem,
          items: filterorders,
        });
      }

      // if (selectedTreeItem !== undefined && selectedTreeItem !== null && selectedTreeItem.items !== undefined) {
      //   let filterorders = selectedTreeItem.items.filter((item) =>
      //     item && item.order && item.order.keyword
      //       .toLowerCase()
      //       .includes(SearchContentText.toLowerCase())
      //   );
      //   setSelectedTreeItem({
      //     ...selectedTreeItem,
      //     items: filterorders,
      //   });
      // }
    } else if (
      searchCriteriaType.value !== undefined &&
      searchCriteriaType.value === 1
    ) {
      if (
        selectedTreeItem !== undefined &&
        selectedTreeItem !== null &&
        selectedTreeItem.items !== undefined
      ) {
        let filterorders: any = [];
        if (
          (selectedTreeItem.directorycode === -8 ||
            selectedTreeItem.directorycode === -9) &&
          stateData[0].items !== undefined
        ) {
          filterorders = stateData[0].items.filter(
            (item) => item.directorycode === selectedTreeItem.directorycode
          );
        } else if (
          (selectedTreeItem.directorycode === -10 ||
            selectedTreeItem.directorycode === -11) &&
          stateData[1].items !== undefined
        ) {
          filterorders = stateData[1].items.filter(
            (item) => item.directorycode === selectedTreeItem.directorycode
          );
        }
        console.log(filterorders);
        if (filterorders.length > 0) {
          setSelectedTreeItem({
            ...selectedTreeItem,
            items: filterorders[0].items,
          });
          setSelectedTreeItemDuplicate({
            ...selectedTreeItem,
            items: filterorders[0].items,
          });
        }
      }
    } else if (
      searchCriteriaType.value !== undefined &&
      searchCriteriaType.value === 3
    ) {
      setsearchCriteriaType({ ...searchCriteriaType });
      if (searchCriteriaType.value === 3) {
        setSearchContentText({ SearchContentText });
      } else if (searchCriteriaType.value === 1) {
        setSearchContentText("");
      }
    }
  };

  const updateskiptake = (skiptake: any) => {
    setTakeskip(skiptake);
  };

  const handleoncolumnchange = (column: any, splititems: any) => {
    setColumns([...column]);
    setsplitBtnItems(splititems);
  };

  const onsinglerecordupdater = (order: any) => {
    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(order);
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );
      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );
      setSelectedTreeItem(selectedtree);
      setSelectedTreeItemDuplicate(selectedtree);
      setStateData(newdata);
      setOpenedorder(order);
    }

    if (
      selectedGridItem !== undefined &&
      selectedGridItem.order !== undefined &&
      selectedGridItem.order.lsworkflow !== undefined &&
      order !== undefined &&
      order.lsworkflow !== undefined
    ) {
      let selectedGridItemobj: any = selectedGridItem;
      selectedGridItemobj.order.lsworkflow = order.lsworkflow;
      setSelectedGridItem(selectedGridItemobj);
      updateFileDetailsData(selectedGridItemobj);
    }
  };

  const updateorder = (order: any) => {
    if (stateData.length > 0) {
      if (
        selectedTreeItem &&
        selectedTreeItem.directorycode &&
        (selectedTreeItem.filefor === "LPO" ||
          selectedTreeItem.filefor === "EPO" ||
          selectedTreeItem.filefor === "RPO" ||
          selectedTreeItem.filefor === "MPO" ||
          selectedTreeItem.filefor === "SPO") &&
        order &&
        order.orderflag &&
        order.orderflag.trim() === "R"
      ) {
        let newData = removeDataItem(stateData, {
          directorycode: order.batchcode,
        });
        let selectedtree = getDirectoryOncode(
          newData,
          selectedTreeItem.directorycode
        );
        setStateData(newData);
        setSelectedTreeItem(selectedtree);
        setSelectedTreeItemDuplicate(selectedtree);
      } else if (
        selectedTreeItem &&
        selectedTreeItem.directorycode &&
        (selectedTreeItem.filefor === "MYO" || order.orderflag.trim() === "R")
      ) {
        let folderdata =
          stateData !== undefined && stateData !== null && stateData.length > 0
            ? stateData
            : initialorders !== null
              ? initialorders
              : [];
        let directorycode: any =
          selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
        let filefor: any =
          selectedTreeItem !== null ? selectedTreeItem.filefor : "";
        if (order !== undefined) {
          let responseorder = [order];
          let newdata = replaceonechangeorderordertoFolderwithfilefor(
            folderdata,
            directorycode,
            intl,
            responseorder !== undefined && responseorder.length > 0
              ? responseorder
              : [],
            filefor,
            screen
          );
          let selectedtree = getDirectoryOncode(
            newdata,
            selectedTreeItem.directorycode
          );
          setStateData(newdata);
          setSelectedTreeItem(selectedtree);
          setSelectedTreeItemDuplicate(selectedtree);
        }
      } else {
        onsinglerecordupdater(order);
      }
    }
  };

  const oncloseorder = () => {
    setIsorderopen(false);
    setOpenedorder(undefined);
    store.dispatch(updateorderopen(false));
    if (props.notificationpreviouspath) {
      history.push(props.notificationpreviouspath);
    }

    // if (stateData.length === 0) {
    //   getfoldersforclose();
    // }
  };

  const getfoldersforclose = () => {
    let passObj: any = {
      // filetype: parseInt(type),
      fromdate: GetutcDate(new Date(fromRange)),
      todate: GetutcDate(new Date(toRange)),
      lstproject: projects,
      lstworkflow: workflow,
      // objsilentaudit: silentaudit,
      lsuserMaster:
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? store.getState().Loggeduser
          : {
            usercode: parseInt(sessionStorage.User),
            username: sessionStorage.Username,
            unifieduserid: sessionStorage.unifieduserid,
          },
      ismultitenant: isMultitenant,
    };
    passObj.lstuserMaster = Getteamusersfromsession();

    passObj.lsuserMaster.lsusergrouptrans = {
      usergroupcode: localStorage.getItem("multiusergroups"),
      usergroupname: localStorage.getItem("usergroupname"),
      usergroupstatus: localStorage.getItem("usergroupstatus"),
    };
    passObj.lssitemaster = {
      sitecode: sessionStorage.Usersite,
      sitename: sessionStorage.Usersitename,
    }
    Servicecalls(
      "" + ELNurl + "/Instrument/Getfoldersfororders",
      passObj,
      ongetfoldersuccess,
      ongetfolderfailure
    );
  };

  useEffect(() => {

    document.title =
      isMultitenant === 2
        ? "Logilab ELN " + props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS")
        : props.t("ELNTitle.IDS_LBL_SHEETORDER");
    selectedTreeItemRef.current = selectedTreeItem;
  }, [selectedTreeItem]);
  //last opened folder to store db purpose
  useEffect(() => {
    return () => {
      console.log({ kumu_wid: selectedTreeItemRef?.current });
      if (
        selectedTreeItemRef?.current !== undefined &&
        selectedTreeItemRef?.current !== null &&
        selectedTreeItemRef?.current.directorycode !== undefined &&
        (selectedTreeItemRef?.current?.filefor === "DR" ||
          selectedTreeItemRef?.current?.path?.includes("Sheet/Projects/"))
      ) {
        let lsActiveWidgets: any = {
          screenname: "Sheet_Folder",
          activityType: "Lastopen_Folder",
          userId: sessionStorage.User,
          activewidgetsdetailscode: selectedTreeItemRef?.current?.directorycode,
          Activewidgetsdetails:
            selectedTreeItemRef?.current?.directoryname || "",
          description: selectedTreeItemRef?.current?.path,
          parentcode: selectedTreeItemRef?.current?.parentdircode,
          sitecode: sessionStorage.Usersite
        };
        if (!Number.isInteger(selectedTreeItemRef?.current?.directorycode)) {
          var parts = selectedTreeItemRef?.current?.directorycode
            .toString()
            .split(".");
          lsActiveWidgets.folderdirfloatcode = parts[1];
        }
        Onsaveactivewidgetsdata(lsActiveWidgets);
      }
    };
  }, []);

  useEffect(() => {

    document.title =
      isMultitenant === 2
        ? "Logilab ELN " + props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS")
        : props.t("ELNTitle.IDS_LBL_SHEETORDER");



    if (
      sheetdatainit === undefined &&
      sheetdatainitservice && !isOrderMismatched &&
      props.notificationorder?.Open_Type === undefined
    ) {
      let passobj =
        isMultitenant === 0 ? pendinglimsorderfolder : pendingelnorderfolder;
      let passObjDet4: any = {
        filetype: renderSwitch(passobj.filefor),
        fromdate: filterType === 1 ? GetutcDateaudi(GetutcDate(new Date(fromRange))) : GetutcDate(new Date(fromRange)),
        todate: GetutcDate(new Date(toRange)),
        lstproject: projects,
        lstworkflow: workflow,
        directorycode: passobj.directorycode,
        orderflag:
          passobj.filefor === "LPO" ||
            passobj.filefor === "EPO" ||
            passobj.filefor === "RPO" ||
            passobj.filefor === "MPO" ||
            passobj.filefor === "SPO"
            ? "N"
            : "R",
        filefor: passobj.filefor,
        lsuserMaster: store.getState().Loggeduser,
        searchCriteria: {
          contentsearchtype: searchCriteriaType.value,
          contentsearch: SearchContentText.SearchContentText,
        },
        ismultitenant: isMultitenant,
      };
      if (orderflag !== undefined && orderflag !== -1) {
        passObjDet4.orderflag = orderflag === 1 ? "N" : "R";
      }
      if (orderflag !== undefined && orderflag === 3) {
        passObjDet4.approvelstatus = 3;
      }

      if (flitertest.testcode !== -1) {
        passObjDet4.testcode = flitertest.testcode;
      }
      if (
        fliterproject.projectcode !== undefined &&
        fliterproject.projectcode !== -1
      ) {
        passObjDet4.lsprojectmaster = fliterproject;
      }
      passobjectdates = passObjDet4;
      if (Foldercontext !== undefined) {
        ongetfoldersuccess(Foldercontext, intl);
      }
      passObjDet4.lstdirectorycode = flattenAndExtractDirectoryCodes(JSON.parse(JSON.stringify(Foldercontext?.directory)), true);
      passObjDet4.lstuserMaster = Getteamusersfromsession();


    } else if (
      sheetdatainit !== undefined &&
      sheetdatainitservice &&
      props.notificationorder?.Open_Type === undefined
    ) {
      orderdataforfolder = sheetdatainit;
      getfolderfiles(passobjectdates, undefined);
    } else if (
      props.notificationorder?.Open_Type !== undefined &&
      props.notificationorder?.Open_Type === "Globl_Search_Folder" &&
      props.notificationorder?.Issamp_Page
    ) {
      // handleTreeItemClick({ item: props.notificationorder });
      let Allstate_Data = flattenHierarchy(
        JSON.parse(JSON.stringify(stateData))
      );
      let orders = expandPathInHierarchy(
        Allstate_Data,
        props.notificationorder?.path,
        stateData
      );
      const newTreeItem = searchTreeItem(orders, props.notificationorder);
      setSelectedTreeItem(newTreeItem);
      props.onresetnotification();
      setStateData(orders);
      setTimeout(() => {
        setPullcontents(true);
      }, 100);
      setTimeout(() => {
        const elements = document.getElementsByClassName(
          "k-in k-state-selected"
        );
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 1000);
    }

    if ((SearchContentText !== undefined && searchCriteriaType.value === 3 &&
      props.notificationorder?.Open_Type === undefined) ||
      (SearchContentText === "" && searchCriteriaType.value === 1) || pullcontents) {
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        fromRange,
        toRange,
        fileType,
        searchCriteriaType,
        orderflag,
        flitertest,
        fliterproject,
        iscancelled,
        Foldercontext?.directory
      );
    }

    store.dispatch(updateorderopen(isorderopen));

  }, [
    SearchContentText,
    pullcontents,
    isorderopen,
    sheetdatainitservice,
    sheetdatainit,
    selectedFiles,
    props.notificationorder,
  ]);

  const stopautoregister = (event: any) => {
    console.log(event);
    let repeat = false;

    let passObjDet1 = {
      repeat: repeat,
      batchcode: event.order.batchcode,
      batchid: event.order.batchid,
    };
    let passObjDet2 = {
      objsilentaudit: Silentauditobject(
        "stop Auto Register",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_STOPAUTO", {
          // screen: orderType(stateOrder.Assigntestfor),
          batchid: event.order.batchid,
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    let passobj3 = {
      batchcode: event.order.batchcode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Orders.Sheetorders.IDS_AUDIT_STOPAUTO", {
        // screen: orderType(stateOrder.Assigntestfor),
        batchid: event.order.batchid,
        user: store.getState().Loggeduser.username,
      }),
      viewoption: 2,
    };

    if (auditRights.IDS_TSK_AUTOREGORDERCANCEL) {
      let objManualAudit = passObjDet1 as any;
      objManualAudit.objmanualaudit = Manualauditobject(
        "stop Auto Register",
        "Sheet Orders"
      );
      ($("#auditTrailModalsheetview") as any).modal("show");
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/Instrument/stopautoregister",
        AuditObject: objManualAudit,
        AuditPassfunction: (res: any) => {
          ($("#auditTrailModalsheetview") as any).modal("hide");
          props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_AUTOREGSTOP"));
        },
        AuditFailfunction: (res: any) => { },
      });
    } else {
      Servicecalls(
        "" + ELNurl + "/Instrument/stopautoregister",
        passObjDet1,
        (res: any) => {

          props.alert.success(
            props.t("Orders.Sheetorders.IDS_MSG_AUTOREGSTOP")
          );
          console.log(res);
          updatestateorderdata(res);

        },
        (res: any) => { }
      );
    }

    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet2,
      onAuditValidateError,
      onAuditValidateFailure,

      "" + ELNurl + "/protocol/updatetransactionhistory",
      passobj3,
      onAuditValidateError,
      onAuditValidateFailure
    );
  };

  const updatestateorderdata = (res: any) => {

    // let a;
    console.log(stateData);
    res = OrderSequence(res);

    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(res);
      let folderdata =
        stateData !== undefined &&
          stateData !== null &&
          stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );
      console.log(newdata);

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );

      console.log(selectedtree);
      setSelectedTreeItem(selectedtree);
      setSelectedTreeItemDuplicate(selectedtree);
      setStateData(newdata);
      setOpenedorder({ ...openedorder, repeat: false });
    }
  }
  useLayoutEffect(() => {
    if (props.notificationorder === "") {
      if (
        userrights.LIMSorderVisible !== undefined &&
        userrights.LIMSorderVisible === true &&
        isMultitenant === 0
      ) {
        setsheetdatainitservice(true);
      } else if (
        userrights.ELNorderVisible === true &&
        (isMultitenant === 1 || isMultitenant === 2)
      ) {
        setsheetdatainitservice(true);
      } else {
        if (Foldercontext !== undefined) {
          ongetfoldersuccess(Foldercontext, intl);
        }
      }
    } else if (
      props.notificationorder &&
      props.notificationorder?.Open_Type === undefined
    ) {
      let Audit = AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_SHEETORDERS",
        "IDS_TSK_PROCESSORDER"
      );
      if (Audit) {
        setOpenedorder(props.notificationorder);
        // setIsorderopen(true);
        // getfoldersforclose();
        setTimeout(() => {
          recordorderopenhistory(props.openorder);
          // props.onresetnotification();
        }, 700);
      } else {
        // if (
        //   props.openorder.filecode !== undefined &&
        //   props.openorder.filecode === -1
        // ) {
        setIsorderopen(true);
        setOpenedorder(props.notificationorder);
        handleOrderopenClick(null, props.openorder);
        // } else {

        //   props.onresetnotification();
        // }
      }
    } else if (
      props.notificationorder?.Open_Type !== undefined &&
      (props.notificationorder?.Open_Type === "Globl_Search_Folder" ||
        props.notificationorder?.Open_Type === "Activities_Folder")
    ) {
      if (Foldercontext !== undefined) {
        ongetfoldersuccess(Foldercontext, intl);
      }
    } else if (props.ordercode && props.ordercode !== "") {
      setTimeout(() => {
        updateStateforprocessnotification(props.ordercode, "link");
      }, 500);
    }
  }, [ELNurl]);

  const Itemview = React.useCallback(() => {
    let item =
      contentView === "grid"
        ? selectedTreeItem && selectedTreeItem.items
          ? process(
            selectedTreeItem.items.map((item) => {
              if (item.order !== undefined) {
                item.order.directorycode = item.directorycode;
              }
              return {
                ...item,
                ...item.order,
                // link: generateLink(item.order !== undefined ? item.order.batchcode : ""),
                [SELECTED_FIELD]: gridSelection[idGetter(item)],
              };
            }),
            stateContentData
          )
          : !selectedTreeItem
            ? process(
              stateData.map((item) => {
                if (item.order !== undefined) {
                  item.order.directorycode = item.directorycode;
                }
                return {
                  ...item,
                  ...item.order,
                  // link: generateLink(item.order !== undefined ? item.order.batchcode : ""),
                  [SELECTED_FIELD]: gridSelection[idGetter(item)],
                };
              }),
              stateContentData
            )
            : null
        : selectedTreeItem && selectedTreeItem.items
          ? process(
            selectedTreeItem.items.map((item) => ({
              ...item,
              [SELECTED_FIELD]: gridSelection[idGetter(item)],
            })),
            stateContentData
          )
          : !selectedTreeItem
            ? process(
              stateData.map((item) => ({
                ...item,
                [SELECTED_FIELD]: gridSelection[idGetter(item)],
              })),
              stateContentData
            )
            : null;

    return (
      <React.Fragment>
        {contentView === "grid" ? (
          // <OverlayScrollbarsComponent style={{ height: "calc(100vh - 225px)" }}>
          <Suspense fallback={<div></div>}>
            <div className="heightgird">
              <MyGlobalContext.Provider value={userrights}>
                <GridView
                  data={item}
                  sort={stateContentData.sort}
                  dataItemKey={DATA_ITEM_KEY}
                  onSelectionChange={handleSelectionChange}
                  onMultipleSelection={handleMultipleSelection}
                  onSortChange={handleSortChange}
                  onDoubleClick={handleGridDoubleClick}
                  onContextMenu={handleContextMenuView}
                  onOrderShared={onOrderShared}
                  props={props}
                  columns={columns}
                  splitItems={splitBtnItems}
                  openunsharelist={openunsharelist}
                  filedownloadurl={
                    ELNurl +
                    "/Instrument/downloadsheetfileforfolder/" +
                    isMultitenant +
                    "/" +
                    sessionStorage.getItem("tenantid")
                  }
                  ondeletefile={ondeletefile}
                  screen={screen}
                  onOrderOpen={handleOrderopenClick}
                  name={"sheetorder_1"}
                  skiptake={takeskip}
                  updateskiptake={updateskiptake}
                  multiSelectedOrders={selectedOrders}
                  onMultiOrderSelect={handleMultiSelectClick}
                  isMultiSelectOrder={isMultiSelectOrder}
                  multiSelectedFiles={selectedFiles}
                  onMultiFileSelect={handleMultiSelectFileClick}
                  onSelectAllFileClick={handleSelectAllFileClick}
                  onSelectAllOrderClick={handleSelectAllOrderClick}
                  isMultiSelectFile={isMultiSelectFile}
                  multiSelectedFolders={selectedFolders}
                  onMultiFolderSelect={handleMultiSelectFolderClick}
                  isMultiSelectFolders={isMultiSelectFolders}
                  onordercommonaction={onordercommonaction}
                  stopautoregister={stopautoregister}
                  handleExcelExport={handleExcelExport}
                  SelectAllFile={SelectAllFile}
                  isSelectAllFile={isSelectAllFile}
                  SelectAllOrder={SelectAllOrder}
                  isSelectAllOrder={isSelectAllOrder}
                />
              </MyGlobalContext.Provider>
            </div>
          </Suspense>
        ) : (
          // </OverlayScrollbarsComponent>
          <Suspense fallback={<div></div>}>
            <MyGlobalContext.Provider value={userrights}>
              <ListView
                data={
                  selectedTreeItem && selectedTreeItem.items
                    ? process(
                      selectedTreeItem.items.map((item) => ({
                        ...item,
                        [SELECTED_FIELD]: gridSelection[idGetter(item)],
                      })),
                      stateContentData
                    )
                    : !selectedTreeItem
                      ? process(
                        stateData.map((item) => ({
                          ...item,
                          [SELECTED_FIELD]: gridSelection[idGetter(item)],
                        })),
                        stateContentData
                      )
                      : null
                }
                sort={stateContentData.sort}
                onSelectionChange={handleSelectionChange}
                onMultipleSelection={handleMultipleSelection}
                onItemClick={handleListItemClick}
                onDoubleClick={handleGridDoubleClick}
                onContextMenu={handleContextMenuView}
                onOrderOpen={handleOrderopenClick}
                multiSelectedOrders={selectedOrders}
                onMultiOrderSelect={handleMultiSelectClick}
                onSelectAllFileClick={handleSelectAllFileClick}
                onSelectAllOrderClick={handleSelectAllOrderClick}
                isMultiSelectOrder={isMultiSelectOrder}
                onOrderShared={onOrderShared}
                props={props}
                screen={screen}
                openunsharelist={openunsharelist}
                closeunsharelist={closeunsharelist}
                filedownloadurl={
                  ELNurl +
                  "/Instrument/downloadsheetfileforfolder/" +
                  isMultitenant +
                  "/" +
                  sessionStorage.getItem("tenantid")
                }
                ondeletefile={ondeletefile}
                multiSelectedFiles={selectedFiles}
                onMultiFileSelect={handleMultiSelectFileClick}
                isMultiSelectFile={isMultiSelectFile}
                isSelectAllFile={isSelectAllFile}
                isSelectAllOrder={isSelectAllOrder}
                SelectAllFile={SelectAllFile}
                SelectAllOrder={SelectAllOrder}
                columns={columns}
                splitItems={splitBtnItems}
                multiSelectedFolders={selectedFolders}
                onMultiFolderSelect={handleMultiSelectFolderClick}
                isMultiSelectFolders={isMultiSelectFolders}
                onordercommonaction={onordercommonaction}
                stopautoregister={stopautoregister}
                activekey={
                  selectedTreeItem !== null && selectedTreeItem !== undefined
                    ? selectedTreeItem.filefor
                    : ""
                }
              />
            </MyGlobalContext.Provider>
          </Suspense>
        )}
      </React.Fragment>
    );
  }, [
    selectedTreeItem,
    stateData,
    stateContentData,
    selectedGridItem,
    contentView,
    isMultiSelectOrder,
    isMenuContext,
    takeskip,
    gridSelection,
    selectedOrders,
    selectedFiles,
    isMultiSelectFile,
    isSelectAllFile,
    isMultiSelectFolders,
    selectedFolders,
    columns
  ]);

  const folderview = React.useCallback(() => {
    return (
      <div
        className={
          "k-widget k-filemanager k-filemanager-resizable " +
          // stateOrder.orderDetailsclassName +
          " cls-filemanager "
        }
        style={{ display: !isorderopen ? "block" : "none" }}
      >
        <div className="k-filemanager-header">
          <Suspense fallback={<div></div>}>
            <MyGlobalContext.Provider value={userrights}>
              <FileManagerToolbar
                folderCreate={folderCreate}
                splitItems={splitBtnItems}
                sortSelectedText={sortSelectedText}
                columns={columns}
                sort={stateContentData.sort}
                files={files}
                filesaveurl={filesaveurl}
                fileremoveurl={fileremoveurl}
                homeuploadfile={homeuploadfile}
                homeremovefile={homeremovefile}
                onNewFolderClick={handleNewFolderClick}
                onCreateOrderClick={handleRegisterOrder}
                onSearchChange={handleSearchChange}
                onSwitchChange={handleSwitchChange}
                onViewChange={handleViewChange}
                onSortChange={handleSortChange}
                onFileChange={handleFileChange}
                onAddFileChange={handleAddFileChange}
                onClearFileList={handleClearFileList}
                onUploadComplete={handleUploadComplete}
                onContextMenu={handleContextMenuView}
                isMultiSelectOrder={isMultiSelectOrder}
                onSelectAllOrderClick={handleSelectAllOrderClick}
                isMultiSelectFile={isMultiSelectFile}
                isSelectAllFile={isSelectAllFile}
                SelectAllFile={SelectAllFile}
                SelectAllOrder={SelectAllOrder}
                EnableAddDialog={false}
                isMultiSelectFolders={isMultiSelectFolders}
                onCloseMultiSelect={handleCloseMultiselectClick}
                onMultiselectMove={handleMoveOnMultiselect}
                onMultiselectDelete={handleDeleteOnMultiselect}
                onSelectAllFileClick={handleSelectAllFileClick}
                onhandleSyncClick={handleSyncClick}
                sessionvalues={props.sessionvalues}
                folderdata={getFolderTree(stateData, selectedTreeItem)}
                selectedItem={selectedGridItem}
                selectedFolder={selectedTreeItem}
                t={props.t}
                userData={stateUserData}
                props={props}
                screen={screen}
                view={
                  localStorage.getItem("elnsheetorderview") !== undefined &&
                    localStorage.getItem("elnsheetorderview") !== null &&
                    localStorage.getItem("elnsheetorderview") === "grid"
                    ? false
                    : true
                }
                oncolumnchange={handleoncolumnchange}
                rights={userrights}
                selectedCDPFolder={selectedCDPTreeItem}
                stateCDFData={getFolderTree(stateCDFData, selectedCDPTreeItem)}
                onFolderCDPItemClick={handleCDPTreeItemClick}
                onradioCDFbtnonClick={onradioCDFbtnclick}
                onCDFselectstate={SelectedCDFvalue}
                handlecancelClick={handlecancelClick}
                handleexportClick={handleexportClick}
                isSelectAllOrder={isSelectAllOrder}
              />
            </MyGlobalContext.Provider>
          </Suspense>
        </div>
        <Suspense fallback={<div></div>}>
          <OrdershowContext.Provider value={userrights}>
            <DateFilter
              t={props.t}
              setFilterType={onfilterTypeChange}
              filterType={filterType}
              fromRange={fromRange}
              toRange={toRange}
              setDateRange={setdateRange}
              props={props}
              screen={screen}
              folder={selectedTreeItem}
              searchonButtonClick={searchonButtonClick}
              searchCriteriaType={searchCriteriaType}
              orderstatusType={orderstatusType}
              ismultitenant={isMultitenant}
              orderflag={orderflag}
            />
          </OrdershowContext.Provider>
        </Suspense>
        <div className="k-filemanager-content-container">
          <Splitter panes={panes} onChange={handleSplitterChange}>
            <OverlayScrollbarsComponent
              style={{ height: "calc(100vh - 200px)" }}
            >
              <Suspense fallback={<div></div>}>
                <FolderTree
                  data={getFolderTree(stateData, selectedTreeItem)}
                  selected={selectedTreeItem}
                  selectedItem={selectedTreeItem}
                  onItemClick={handleTreeItemClick}
                  onContextMenu={handleContextMenuView}
                />
              </Suspense>
            </OverlayScrollbarsComponent>
            <div className="k-filemanager-content positioned-tr-group iconed-breadcrumb table-header-overflow sticky-header-order">
              <Suspense fallback={<div></div>}>
                <div className="row breadcrumb-search mr-0">
                  <div className="col-9 pr-0">
                    <BreadcrumbComponent
                      data={convertToBreadcrumbData(selectedTreeItem, screen)}
                      onBreadcrumbSelect={handleBreadcrumbSelection}
                    />
                  </div>
                  <form
                    className="k-filemanager-search-tool k-textbox k-toolbar-last-visible col-3 float-right pr-0"
                    id="breadcrumb_searchform"
                    autoComplete="off"
                  >
                    <Input
                      className="k-input"
                      placeholder={props.t("Header.IDS_LBL_SEARCH")}
                      onChange={handleSearchChange}
                      id="breadcrumb_search_order"
                      value={SearchValue}
                      style={{ height: "100%" }}
                    />
                    <span className="k-input-icon">
                      <span className="k-icon k-i-search"></span>
                    </span>
                  </form>
                </div>
              </Suspense>
              {/* <OverlayScrollbarsComponent
                  style={{ height: "calc(100vh - 195px)" }}
                > */}
              {Itemview()}
              {/* </OverlayScrollbarsComponent> */}
            </div>
            <OverlayScrollbarsComponent
              style={{ height: "calc(100vh - 200px)" }}
            >
              {Detailview()}
            </OverlayScrollbarsComponent>
          </Splitter>
        </div>
      </div>
    );
  }, [
    menuOffSet,
    selectedGridItem,
    selectedTreeItem,
    isMultiSelectFile,
    isMultiSelectFolders,
    selectedFolders,
    orderstatusType,
    fromRange,
    toRange,
    splitBtnItems,
    columns,
    stateContentData,
    files,
    isMultiSelectOrder,
    selectedOrders,
    contentView,
    searchCriteriaType,
    stateData,
    isorderopen,
    sheetUnmapped,
    openedorder,
    panes,
    takeskip
  ]);

  const closeModel = () => {
    setCancellorder(false);
    setDuplicateorder(false);
    setCancellorderitem("");
    setDublicateorderitem("");
  };

  const onsavecancelformodal = (saveActiontype: any) => {
    if (cancellorderitem !== undefined && cancellorderitem !== null && cancellorderitem !== "" && saveActiontype === "cancellorder") {
      let passObjDet = cancellorderitem;
      passObjDet.ordercancell = 1;
      passObjDet.objLoggeduser = store.getState().Loggeduser;
      if (auditRights.IDS_TSK_CANCELORDER) {
        passObjDet.objmanualaudit = Manualauditobject("cancel", "Sheet Orders");
        ($("#auditTrailModalsheetview") as any).modal("show");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/cancelsheetorder",
          AuditObject: passObjDet,
          AuditPassfunction: oncancancelsheetordersucess.bind(this),
          AuditFailfunction: oncancancelsheetorderFailure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/Instrument/cancelsheetorder",
          passObjDet,
          oncancancelsheetordersucess.bind(this),
          oncancancelsheetorderFailure.bind(this)
        );
      }
    } else {
      Servicecalls(
        "" + ELNurl + "/Instrument/getordercontent",
        {
          ...dublicateorderitem,
          ismultitenant: isMultitenant,
        },
        ongetordercontent.bind(this),
        oncancancelsheetorderFailure.bind(this)
      );
    }
  };

  const ongetordercontent = (response: any) => {
    console.log(dublicateorderitem);
    // dublicateorderitem.lsfile = response.lsfile;
    let content = JSON.parse(response.lssamplefile.filecontent);
    if (content) {
      content.sheets?.forEach((sheet: any) => {
        sheet.rows?.forEach((row: any) => {
          row.cells?.forEach((cell: any) => {
            if (cell.tag) {
              const tag = JSON.parse(cell.tag);
              if (cell.value !== `[${tag.fieldname}]`) {
                cell.value = `[${tag.fieldname}]`;
              }
            }
          });
        });
      });
    }
    const {
      directorycode,
      elnfileAttachments,
      assignedto,
      filetype,
      keyword,
      lsbatchdetails,
      lsfile,
      lssamplemaster,
      lsOrderattachments,
      lsorderelnmethod,
      lsparsedparameters,
      lsprojectmaster,
      lsselectedTeam,
      lstestmasterlocal,
      orderdisplaytype,
      orderflag,
      ordersaved,
      projectname,
      repeat,
      samplename,
      teamselected,
      testcode,
      testname,
      viewoption,
      lsrepositories,
      lsrepositoriesdata,
      elnmaterial,
      elnmaterialinventory,
      tittle,
      autoregistercount,
    } = dublicateorderitem;

    let contentparsed =
      lsfile !== undefined &&
        lsfile.filecontent === undefined &&
        lsfile.filecontent !== null
        ? extractValuefromsheet(lsfile.filecontent)
        : extractValuefromsheet(sheetDefaultContent);
    let sequence = getsequenceoncode(1);
    let passObjDet: any = {
      directorycode,
      elnfileAttachments,
      assignedto,
      filetype,
      keyword,
      lsbatchdetails,
      lsfile,
      lssamplemaster,
      lsOrderattachments,
      lsorderelnmethod,
      lsparsedparameters,
      lsprojectmaster,
      lsselectedTeam,
      lstestmasterlocal,
      orderdisplaytype,
      orderflag,
      ordersaved,
      projectname,
      repeat,
      samplename,
      teamselected,
      testcode,
      testname,
      viewoption,
      lsrepositories,
      lsrepositoriesdata,
      elnmaterial,
      elnmaterialinventory,
      tittle,
      autoregistercount,
      lssamplefile: {
        filecontent:
          content !== undefined && content !== null
            ? JSON.stringify(content) : sheetDefaultContent,
        // lsfile !== undefined
        //   ? lsfile.filecontent
        //   : sheetDefaultContent,
        contentvalues: contentparsed.contentvalues,
        contentparameter: contentparsed.contentparameter,
        createdate: GetutcDate(new Date()),
        createbyuser: store.getState().Loggeduser,
        processed: 0,
        versionno: 1,
        lssamplefileversion: [
          {
            filecontent:
              lsfile !== undefined
                ? lsfile.filecontent
                : sheetDefaultContent,
            createdate: GetutcDate(new Date()),
            createbyuser: store.getState().Loggeduser,
            versionno: 1,
            versionname: "version_1",
          },
        ],
      },
      lsuserMaster: store.getState().Loggeduser,
      objLoggeduser: store.getState().Loggeduser,
      ismultitenant: isMultitenant,
      createdtimestamp: GetutcDate(new Date()),
      lstworkflow: workflow,
      sequenceid: sequence && formsequenceformatview(JSON.parse(sequence.sqf), sequence.sep, "g", {
        projectname: lsprojectmaster && lsprojectmaster.projectname ? lsprojectmaster.projectname : "",
        projectcode: lsprojectmaster && lsprojectmaster.projectid ? lsprojectmaster.projectid : "",
        task: testname !== undefined ? testname : "",
        ordertype: getordertype(parseInt(filetype))
      }),
      sheetversionno: ((parseInt(filetype) === 2 || parseInt(filetype) === 3) && (lsfile?.approved !== 1)) ? (lsfile?.versionno - 1) : lsfile?.versionno || 1,
      // sheetversionno: lsfile?.versionno || 1,
      lsActiveWidgets: {
        screenname: "Sheet_Order",
        activityType: "Clone",
        userId: sessionStorage.User,
      },
      notificationdate: convertUTCDateToLocalDate(new Date()),
      sitecode: sessionStorage.Usersite,
      isDefault: orderdefaultcheck(),
      isclone: true,
    }
    if (passObjDet?.lsfile?.filenameuser !== undefined && passObjDet?.lsfile?.versionno !== undefined) {
      passObjDet.lsfile.filenameuser = passObjDet.lsfile.filenameuser + "_" + "V" + (((parseInt(filetype) === 2 || parseInt(filetype) === 3) && (lsfile?.approved !== 1)) ? (lsfile?.versionno - 1) : lsfile?.versionno || 1);
      passObjDet.filename = passObjDet.lsfile.filenameuser
    }
    console.log("kumu")
    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_SHEETORDERS",
      "IDS_TSK_CLONEORDER"
    );
    let selectedfolder = null;
    if (passObjDet.directorycode) {
      selectedfolder = getDirectoryOncode(
        stateData,
        passObjDet.directorycode
      );
    }
    if (Audit) {
      ($("#auditTrailModalsheetview") as any).modal("show");
      passObjDet.objmanualaudit = Manualauditobject(
        "registered",
        "Sheet Orders"
      );
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/Instrument/InsertELNOrder",
        AuditObject: passObjDet,
        AuditPassfunction: oninsertordersuccess.bind(this, selectedfolder),
        AuditFailfunction: oninsertorderfailure.bind(this),
      });
    } else {
      Servicecalls(
        "" + ELNurl + "/Instrument/InsertELNOrder",
        passObjDet,
        oninsertordersuccess.bind(this, selectedfolder),
        oninsertorderfailure.bind(this)
      );
    }
  }

  const oncancancelsheetordersucess = (response: any) => {
    response = OrderSequence(response);
    ($("#auditTrailModalsheetview") as any).modal("hide");
    let responseorder: any = [];
    responseorder.push(response);
    let folderdata =
      stateData !== undefined && stateData !== null && stateData.length > 0
        ? stateData
        : initialorders !== null
          ? initialorders
          : [];
    let directorycode: any =
      selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
    let filefor: any =
      selectedTreeItem !== null ? selectedTreeItem.filefor : "";
    let newdata = replaceonechangeorderordertoFolderwithfilefor(
      folderdata,
      directorycode,
      intl,
      responseorder !== undefined && responseorder.length > 0
        ? responseorder
        : [],
      filefor,
      screen
    );

    let selectedtree = getDirectoryOncodeandfilefor(
      newdata,
      directorycode,
      filefor
    );
    setCancellorder(false);
    props.alert.success(
      props.t("Orders.Sheetorders.IDS_MSG_ORDERCANCELLEDSUCESS", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") })
    );
    setPullcontents(true);
    setDetailsData(null);
    setSelectedTreeItem(selectedtree);
    setSelectedTreeItemDuplicate(selectedtree);
    setStateData(newdata);
    let passObjDet1 = {
      objsilentaudit: Silentauditobject(
        "cancel",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_CANCELORDER", {
          order: cancellorderitem.batchid,
          screen: orderType(response.filetype),
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet1,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );

    // <Sheet/Protocol Order Type> : <Order ID> was cancelled by User: <user> for Reason: <reason></reason>
    let passobj = {
      batchcode: cancellorderitem.batchcode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
        batchid: cancellorderitem.batchid,
        Processed: "Cancelled",
        user2: sessionStorage.Username,
      }),
      viewoption: 3,
      orderobjects: JSON.stringify({
        batchcode: cancellorderitem.batchcode,
        batchid: cancellorderitem.batchid,
        action: "Cancelledorder",
        versionno: response?.sheetversionno,
        sequenceid: response?.sequenceid,
        Reason: response?.objuser?.comments || undefined
      })
    };

    Servicecalls(
      "" + ELNurl + "/protocol/updatetransactionhistory",
      passobj,
      ongetordersfailure,
      ongetordersfailure
    );

  };

  const oncancancelsheetorderFailure = (response: any) => { };

  const Updateordersendapprovalstatus = (res: any) => {

    res = OrderSequence(res);

    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(res);
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );
      console.log(newdata);

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );
      let openedordercopy = openedorder;
      openedordercopy.sentforapprovel = res.sentforapprovel;
      openedordercopy.canuserprocess = res.canuserprocess;

      setOpenedorder(openedordercopy);
      setStateData(newdata);
      setSelectedTreeItem(selectedtree);
      // setDetailsData(res);
      setSelectedTreeItemDuplicate(selectedtree);

    }
  }
  const Updateorderapprovalstatus = (res: any) => {

    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(res);
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );
      console.log(newdata);

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );

      //setOpenedorder(res);
      if (res.approvelaccept !== undefined) {
        if (res.approvelaccept === "3") {

          let openedordercopy = openedorder;
          openedordercopy.approvelaccept = res.approvelaccept;
          openedordercopy.approvelstatus = res.approvelstatus;
          setOpenedorder(openedordercopy);

        } else {
          let openedordercopy = openedorder;
          openedordercopy.approvelaccept = res.approvelaccept;
          setOpenedorder(openedordercopy);
        }
      }

      setSelectedTreeItem(selectedtree);
      // setDetailsData(res);
      setSelectedTreeItemDuplicate(selectedtree);
      setStateData(newdata);

    }
  };



  return (
    <div>
      {/* {!stateOrder.stopDisabled && ( */}
      {!isorderopen && folderview()}
      {/* )} */}
      {contextMenuView && (
        <Suspense fallback={<div></div>}>
          <ContextMenu
            offset={menuOffSet}
            onContextMenuCLick={handleContextMenuClick}
            selectedItem={selectedGridItem}
            ismenucontext={isMenuContext}
            rights={userrights}
            t={props.t}
            screen={"Sheet"}
          />
        </Suspense>
      )}

      {editDialogView && (
        <Suspense fallback={<div></div>}>
          <EditDialog
            editValue={
              Object.keys(selectedGridItem).length
                ? selectedGridItem
                : selectedTreeItem
            }
            onDialogClose={handleDialogClose}
            onDialogClick={handleDialogClick}
            selectedFolder={selectedTreeItem}
            sessionvalues={props.sessionvalues}
            t={props.t}
            alert={props.alert}
            screen={screen}
          />
        </Suspense>
      )}

      {deleteDialogView && (
        <Suspense fallback={<div></div>}>
          <DeleteDialog
            onDialogClose={handleDialogClose}
            onDialogClick={handleDialogClick}
            selectedFolder={selectedTreeItem}
            folderdata={getFolderTree(stateData, selectedTreeItem)}
            selectedItem={deletefolderevents ? selectedTreeItem : selectedGridItem}
            sessionvalues={props.sessionvalues}
            userData={stateUserData}
            t={props.t}
            selectedFolders={selectedFolders}
            screen={'sheetorder'}
          />
        </Suspense>
      )}

      {moveDialogView && (
        <Suspense fallback={<div></div>}>
          <MoveDialog
            folderdata={getFolderTree(stateData, selectedTreeItem)}
            selectedItem={selectedGridItem}
            selectedFolder={selectedTreeItem}
            userData={stateUserData}
            onDialogClose={handleDialogClose}
            onDialogClick={handlemoveDialogClick}
            sessionvalues={props.sessionvalues}
            mutifolders={selectedFolders}
            isSelectAllFile={isSelectAllFile}
            SelectAllFile={SelectAllFile}
            SelectAllOrder={SelectAllOrder}
            isSelectAllOrder={isSelectAllOrder}
            isshowallfolder={
              isMultiSelectFile
                ? // &&
                // selectedFiles !== undefined &&
                // selectedFiles.length > 0 || selectedGridItem.file !== undefined
                // ? 0 : isMultiSelectFolders ? 1 : 2)}
                2
                : isMultiSelectFolders
                  ? 1
                  : 2
            }
            t={props.t}
            alert={props.alert}
            screen={'sheetorder'}
          />
        </Suspense>
      )}

      {adddialogVisible && (
        <Suspense fallback={<div></div>}>
          <DialogComponent
            className="dialogue-inner-panel form-group fixed-dashboard"
            title={props.t("Orders.Sheetorders.IDS_LBL_CREATENEWFOLDER")}
            onClose={handleDialogClose}
          >
            <AddDialog
              addValue={undefined}
              onDialogClose={handleDialogClose}
              onDialogClick={handleDialogClick}
              sessionvalues={props.sessionvalues}
              t={props.t}
              alert={props.alert}
              // selectedFolder={selectedTreeItem}
              selectedFolder={
                Isview_Constence && Object.keys(selectedGridItem).length > 0
                  ? selectedGridItem
                  : selectedTreeItem
              }
              props={{
                selectedFolder:
                  Isview_Constence && Object.keys(selectedGridItem).length > 0
                    ? selectedGridItem
                    : selectedTreeItem,
                selectedCDPFolder: selectedCDPTreeItem,
                stateCDFData: getFolderTree(
                  stateCDFData,
                  selectedCDPTreeItem ? selectedCDPTreeItem : null
                ),
                onFolderCDPItemClick: handleCDPTreeItemClick,
                onradioCDFbtnonClick: onradioCDFbtnclick,
                onCDFselectstate: SelectedCDFvalue,
                handlecancelClick: handlecancelClick,
              }}
            />
          </DialogComponent>
        </Suspense>
      )}

      {isunshareopen && (
        <Suspense fallback={<div></div>}>
          <Unsharelistview
            isOpen={isunshareopen}
            closeunsharelist={closeunsharelist}
            shareitem={selectedUnsharedItem}
            onorderunshare={onorderunshare}
            screen={screen}
            t={props.t}
          />
        </Suspense>
      )}
      {/* openedorder && */}
      {isorderopen && (
        <Suspense fallback={<div></div>}>
          <Sheetorderview
            projects={projects}
            workflow={workflow}
            order={openedorder}
            t={props.t}
            sessionvalues={props.sessionvalues}
            alert={props.alert}
            updateorder={updateorder}
            userrights={userrights}
            onclose={oncloseorder}
            openfrom={"screen"}
            singlrecoredupdate={onsinglerecordupdater}
            filefor={selectedTreeItem?.filefor}
            Updateorderapprovalstatus={Updateorderapprovalstatus}
            Updateordersendapprovalstatus={Updateordersendapprovalstatus}
            updatestateorderdata={updatestateorderdata}
            idle_save={idle_save}
          // statedata={stateData}
          />
        </Suspense>
      )}
      {sheetUnmapped && (
        <Modal centered isOpen={sheetUnmapped}>
          <div className="modal-header">
            <h5 className="modal-title" id="openSheetLabel">
              {props.t("Orders.Sheetorders.IDS_LBL_OPENSHEET", {
                param: "",
              })}
            </h5>
            <button
              type="button"
              className="btn_white_bg"
              data-dismiss="modal"
              aria-label="Close"
              onClick={OnCancelOpensheet}
            >
              <i className="fas fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <form>
                  <div className="form-group">
                    <Suspense fallback={<div></div>}>
                      <KendoTreeList
                        Datasorce={sheetData}
                        selectedsheet={openFileSelected}
                      />
                    </Suspense>
                  </div>
                </form>
              </div>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <button
              type="button"
              id="idOpenSheet"
              className="btn btn-user btn-primary-blue"
              onClick={Opensheet}
            >
              {props.t("Orders.Sheetorders.IDS_LBL_OPEN", {
                param: "",
              })}
            </button>
            <button
              type="button"
              id="idOpenCancel"
              className="btn btn-user btn-cancel"
              data-dismiss="modal"
              onClick={OnCancelOpensheet}
            >
              {props.t("Orders.Sheetorders.IDS_LBL_CANCEL", {
                param: "",
              })}
            </button>
          </div>
        </Modal>
      )}
      <Service
        Tourl={servicecall.ServiceToUrl}
        MethodType={servicecall.ServiceMethodType}
        onSuccess={servicecall.ServcieonSuccess}
        onFailure={servicecall.ServcieonFailure}
        Headerobject={servicecall.ServiceHeaderobject}
        onReseturl={() => {
          setServicecall({ ...servicecall, ServiceToUrl: "" });
        }}
        ServiceTenant={servicecall.ServiceTenant}
        contenttype={servicecall.Servicecontenttype}
      ></Service>
      {isupgradeopen && (
        <Suspense fallback={<div></div>}>
          <Upgrade
            isopen={isupgradeopen}
            onpopupclose={() => {
              setisupgradeopen(false);
            }}
            popcontent={props.t("UPGRADE.IDS_LBL_UPGRADDESCRIPTION")}
            popheader={props.t("UPGRADE.IDS_LBL_UPGRADEINMBTITLE")}
          />
        </Suspense>
      )}
      <div>
        <Suspense fallback={<div></div>}>
          <Audit
            AuditId="auditTrailModalsheetview"
            AuditUrl={Auditservicecall.AuditUrl}
            AuditObject={Auditservicecall.AuditObject}
            AuditPassfunction={Auditservicecall.AuditPassfunction}
            AuditFailfunction={Auditservicecall.AuditFailfunction}
            Auditfilefunction={Auditservicecall.Auditfilefunction}
            AuditCancelfunction={Auditservicecall.AuditCancelfunction ? Auditservicecall.AuditCancelfunction : Auditcancel}
            alert={props.alert}
          />
        </Suspense>

        {(cancellorder || dublicateorder) && (
          <Suspense fallback={<div></div>}>
            <CommonDialog
              saveActiontype={cancellorder ? "cancellorder" : "dublicateorder"}
              cancellorder={cancellorder}
              header={cancellorder ? isMultitenant === 2 ? "Orders.Protocolorders.IDS_LBL_CANCELLTASKS" : "Orders.Protocolorders.IDS_LBL_CANCELLORDER" : "Orders.Protocolorders.IDS_LBL_DUBLICATEORDER"}
              bodycontent={
                cancellorder ?
                  props.t(
                    "Orders.Sheetorders.IDS_LBL_CANCELLORDERCONSHEET",
                    {
                      screenname:
                        isMultitenant === 2
                          ? props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS")
                          : props.t("Orders.Sheetorders.IDS_LBL_SHEETORDER"),
                    }
                  )
                  : props.t("Orders.Protocolorders.IDS_LBL_DUBLICATEORDERCON", {
                    screenname:
                      isMultitenant === 2
                        ? props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS")
                        : props.t("Orders.Sheetorders.IDS_LBL_SHEETORDER"),
                  })
              }
              submitbuttonname={props.t(
                "Templates.Protocoltemplates.IDS_LBL_SUBMIT"
              )}
              closeuttonname={props.t(
                "Templates.Protocoltemplates.IDS_LBL_CLOSE",
                { param: "" }
              )}
              closeModel={closeModel}
              onsavecancelformodal={onsavecancelformodal}
              t={props.t}
            />
          </Suspense>
        )}
      </div>
      {/* <PageLoader isloader={IsLoader} /> */}
    </div>
  );
};

export default withAlert()(withTranslation(Sheetorder));
